// Generated by scripts/sync-catalog-sitemap.mjs — do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const gamesSlugMap = {
    "1_million_fortunes_megaways": {
        name: "1 Million Fortunes Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "1_million_megaways_bc": {
        name: "1 Million Megaways BC",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "100_flaring_fruits": {
        name: "100 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "100_joker_staxx": {
        name: "100 Joker Staxx",
        provider: "Playson",
        providerSlug: "playson"
    },
    "10000_wishes": {
        name: "10000 Wishes",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "1001_mystery_genie_fortunes": {
        name: "1001 Mystery Genie Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "108_heroes": {
        name: "108 Heroes",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "108_heroes_water_margin": {
        name: "108 Heroes Water Margin",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "12_bolts_of_thunder": {
        name: "12 Bolts of Thunder",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "12_coins": {
        name: "12 Coins™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "12_coins_grand_gold_edition": {
        name: "12 Coins™ Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "12_coins_grand_platinum_edition": {
        name: "12 Coins™: Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "12_volt_diamonds": {
        name: "12 Volt Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "12_zodiacs": {
        name: "12 Zodiacs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "123_soccer_link_and_merge": {
        name: "123 Soccer Link and Merge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "13th_trial_hercules_abyssways": {
        name: "13th Trial Hercules Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "1429_uncharted_seas": {
        name: "1429 Uncharted Seas",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "15_coins": {
        name: "15 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "15_coins_grand_gold_edition": {
        name: "15 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "15_coins_grand_platinum_edition": {
        name: "15 Coins™: Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "15_crystal_roses_a_tale_of_love": {
        name: "15 Crystal Roses: A Tale of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "15_tridents": {
        name: "15 Tridents",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "16_coins": {
        name: "16 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "16_coins_grand_gold_edition": {
        name: "16 Coins™ Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "16_coins_grand_platinum_edition": {
        name: "16 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "2_wild_2_die": {
        name: "2 Wild 2 Die",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "20_coins": {
        name: "20 Coins™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "20_coins_grand_gold_edition": {
        name: "20 Coins™ Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "20_flaring_fruits": {
        name: "20 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "24_coins": {
        name: "24 Coins™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "243_chili": {
        name: "243 Chili",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_christmas_fruits": {
        name: "243 Christmas Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_crystal_fruits": {
        name: "243 Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_crystal_fruits_reversed": {
        name: "243 Crystal Fruits Reversed",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "243_fire_n_diamonds": {
        name: "243 Fire n Diamonds",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "24d_spin": {
        name: "24D Spin",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "24k_dragon": {
        name: "24K Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "25_coins": {
        name: "25 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "25_coins_grand_gold_edition": {
        name: "25 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "25_cookies_hit_the_bonus": {
        name: "25 Cookies: Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "25000_talons": {
        name: "25000 Talons",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "3_angels_power_combo": {
        name: "3 Angels Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "3_apex_treasures": {
        name: "3 Apex Treasures",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_blades_and_blessings": {
        name: "3 Blades and Blessings",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_blazing_volcanoes_power_combo": {
        name: "3 Blazing Volcanoes Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "3_builder_piggies": {
        name: "3 Builder Piggies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_buzzing_wilds": {
        name: "3 Buzzing Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_capybaras": {
        name: "3 Capybaras",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_carts_of_gold_hold_and_win": {
        name: "3 Carts of Gold: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_cheeky_chimps": {
        name: "3 Cheeky Chimps",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_chillies_and_joker_hold_and_win": {
        name: "3 Chillies and Joker Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_christmas_fortunes": {
        name: "3 Christmas Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_clown_monty": {
        name: "3 Clown Monty",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_clown_monty_ii": {
        name: "3 Clown Monty II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_crazy_tikis": {
        name: "3 Crazy Tikis",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_cursed_chests_hold_and_win": {
        name: "3 Cursed Chests: Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "3_dancing_monkeys": {
        name: "3 Dancing Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_easter_pigs_hop_and_win": {
        name: "3 Easter Pigs Hop and Win",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "3_genie_wishes": {
        name: "3 Genie Wishes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_gifts_of_xmas": {
        name: "3 Gifts of Xmas",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "3_gladiators_vs_caesar": {
        name: "3 Gladiators Vs Caesar",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "3_gods_of_goalympus": {
        name: "3 Gods of Goalympus",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_hand_casino": {
        name: "3 Hand Casino",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "3_hot_chilli_peppers": {
        name: "3 Hot Chilli Peppers",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_hot_chilli_peppers_extra": {
        name: "3 Hot Chilli Peppers Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_jungle_beats": {
        name: "3 Jungle Beats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_kingdoms_battle_of_red_cliffs": {
        name: "3 Kingdoms - Battle of Red Cliffs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_laughing_lions_combo": {
        name: "3 Laughing Lions Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "3_laughing_lions_power_combo": {
        name: "3 Laughing Lions Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "3_leprechaun_charms": {
        name: "3 Leprechaun Charms",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_luxor_pots_hold_and_win": {
        name: "3 Luxor Pots Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_mad_frogs": {
        name: "3 Mad Frogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_magic_eggs": {
        name: "3 Magic Eggs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "3_magic_lamps_hold_and_win": {
        name: "3 Magic Lamps: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_mermaids": {
        name: "3 Mermaids",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "3_pigs_of_olympus_2_rise_of_the_demihog": {
        name: "3 Pigs of Olympus 2 Rise of the Demihog",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "3_pigs_of_the_caribbean": {
        name: "3 Pigs of the Caribbean",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "3_pigs_of_xmas_bonus_pot_20000": {
        name: "3 Pigs of Xmas Bonus Pot 20,000",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "3_pinatas": {
        name: "3 Pinatas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_pirate_barrels_hold_and_win": {
        name: "3 Pirate Barrels: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_plucky_hens": {
        name: "3 Plucky Hens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_porky_banks_christmas": {
        name: "3 Porky Banks Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_porky_banks_hold_and_win": {
        name: "3 Porky Banks Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_porky_banks_hold_and_win_extra": {
        name: "3 Porky Banks Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_pots_riches_hold_and_win": {
        name: "3 Pots Riches: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_power_bears": {
        name: "3 Power Bears",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_power_dragons": {
        name: "3 Power Dragons",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_power_genies": {
        name: "3 Power Genies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "3_royal_coins_hold_and_win": {
        name: "3 Royal Coins Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_runaway_riches": {
        name: "3 Runaway Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_super_porky_banks": {
        name: "3 Super Porky Banks",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_supercharged_diamonds_hold_and_win": {
        name: "3 Supercharged Diamonds Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_thunder_coins_hold_and_win": {
        name: "3 Thunder Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "3_top_dogs": {
        name: "3 Top Dogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "3_wild_aliens": {
        name: "3 Wild Aliens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "30_coins": {
        name: "30 Coins™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "30_coins_grand_gold_edition": {
        name: "30 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "3021_ad_the_bounty_hunter_gigablox": {
        name: "3021 AD The Bounty Hunter Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "36_coins": {
        name: "36 Coins™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "36_coins_grand_gold_edition": {
        name: "36 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "3rd_base": {
        name: "3rd Base",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "3x_catch": {
        name: "3x Catch",
        provider: "Playson",
        providerSlug: "playson"
    },
    "4_chili_amigos_hold_and_win": {
        name: "4 Chili Amigos Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "4_diamond_blues_megaways": {
        name: "4 Diamond Blues Megaways",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "4_dragon_pots": {
        name: "4 Dragon Pots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "4_foxx_crew_wild_energy_multimax": {
        name: "4 Foxx Crew Wild Energy Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "4_gym_pigs_porky": {
        name: "4 Gym Pigs Porky",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "4_pots_riches_super_wheel": {
        name: "4 Pots Riches: Super Wheel",
        provider: "Playson",
        providerSlug: "playson"
    },
    "4_supercharged_clovers": {
        name: "4 Supercharged Clovers",
        provider: "Playson",
        providerSlug: "playson"
    },
    "4_wild_riches": {
        name: "4 Wild Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "40_finest_xxl": {
        name: "40 Finest XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "40_finest_xxl_flaming_link": {
        name: "40 Finest XXL Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "40_hot_diamond_desire": {
        name: "40 Hot Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "420_blaze_it": {
        name: "420 Blaze It",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "5_ember_wilds": {
        name: "5 Ember Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "5_flaring_fruits": {
        name: "5 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "5_fortunator": {
        name: "5 Fortunator",
        provider: "Playson",
        providerSlug: "playson"
    },
    "5_frozen_charms_megaways": {
        name: "5 Frozen Charms Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_hot_diamond_desire_94": {
        name: "5 Hot Diamond Desire 94",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "5_lions": {
        name: "5 Lions",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_dance": {
        name: "5 Lions Dance",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_gold": {
        name: "5 Lions Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_megaways": {
        name: "5 Lions Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_megaways_2": {
        name: "5 Lions Megaways 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lions_reborn": {
        name: "5 Lions Reborn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_lucky_lions": {
        name: "5 Lucky Lions",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "5_mariachis": {
        name: "5 Mariachis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "5_rabbits_megaways": {
        name: "5 Rabbits MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "5_reel_drive": {
        name: "5 Reel Drive",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "5_super_sevens_and_fruits": {
        name: "5 Super Sevens & Fruits",
        provider: "Playson",
        providerSlug: "playson"
    },
    "50_flaring_fruit": {
        name: "50 Flaring Fruit",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "50_flaring_fruits": {
        name: "50 Flaring Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "5x_magic": {
        name: "5x Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "6_jokers": {
        name: "6 Jokers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "64_gold_coins_hold_and_win": {
        name: "64 Gold Coins Hold and Win ",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_gold_coins_hold_and_win_20000": {
        name: "64 Gold Coins Hold and Win 20000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_nuggets_hold_and_win": {
        name: "64 Nuggets Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "64_presents_hold_and_win": {
        name: "64 Presents Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "7_clovers_of_fortune": {
        name: "7 Clovers of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_fates": {
        name: "7 Fates",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "7_lucky_gods": {
        name: "7 Lucky Gods",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "7_monkeys": {
        name: "7 Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_piggies": {
        name: "7 piggies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "7_sins": {
        name: "7 Sins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "777_deluxe": {
        name: "777 Deluxe",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "777_mega_deluxe": {
        name: "777 Mega Deluxe",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "777_sizzling_wins_5_line": {
        name: "777 Sizzling Wins: 5 Line",
        provider: "Playson",
        providerSlug: "playson"
    },
    "777_super_big_buildup_deluxe": {
        name: "777 Super BIG BuildUp Deluxe",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "777_surge": {
        name: "777 Surge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "777_volt_gigablox": {
        name: "777 Volt GigaBlox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "8_dragons": {
        name: "8 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "8_golden_dragon_challenge": {
        name: "8 Golden Dragon Challenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "8_treasures_luck_of_the_dragon": {
        name: "8 Treasures Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "80spop": {
        name: "80sPOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "81_creepy_circus": {
        name: "81 Creepy Circus",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "81_frutas_grandes": {
        name: "81 Frutas Grandes",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "81_frutas_grandes_vip": {
        name: "81 Frutas Grandes VIP",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "81_joker_x": {
        name: "81 Joker X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "888_bonanza": {
        name: "888 Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "888_dragons": {
        name: "888 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "9_balls": {
        name: "9 Balls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_burning_dragons": {
        name: "9 Burning Dragons",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_burning_stars": {
        name: "9 Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins": {
        name: "9 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_1000_edition": {
        name: "9 Coins 1000 Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_extremely_light": {
        name: "9 Coins™ Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_grand_diamond_edition": {
        name: "9 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_grand_gold_edition": {
        name: "9 Coins: Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_coins_grand_platinum_edition": {
        name: "9 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_lions": {
        name: "9 Lions",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_lions_hold_the_jackpot": {
        name: "9 Lions™ Hold The Jackpot™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "9_masks_of_fire": {
        name: "9 Masks of Fire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "9_masks_of_fire_hyperspins": {
        name: "9 Masks of Fire HyperSpins",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "9_pots_of_gold": {
        name: "9 Pots of Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "9_pots_of_gold_megaways": {
        name: "9 Pots of Gold Megaways",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "9_tigers": {
        name: "9 Tigers™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "a_tale_of_elves": {
        name: "A Tale of Elves",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "aarupolis": {
        name: "Aarupolis",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "ace_of_spades": {
        name: "Ace of Spades",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "adventure_palace": {
        name: "Adventure Palace",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "adventures_beyond_wonderland_magical_maze": {
        name: "Adventures Beyond Wonderland Magical Maze",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "adventures_of_doubloon_island": {
        name: "Adventures of Doubloon Island",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "african_elephant": {
        name: "African Elephant",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "african_quest": {
        name: "African Quest",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "age_of_asgard": {
        name: "Age of Asgard",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "age_of_discovery": {
        name: "Age of Discovery",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "agent_destiny": {
        name: "Agent Destiny",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "agent_of_hearts": {
        name: "Agent of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ahoy_royale": {
        name: "Ahoy Royale",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "aiko_and_the_wind_spirit": {
        name: "Aiko and the Wind Spirit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "airwave_roulette": {
        name: "Airwave Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "akne_fruits": {
        name: "Akne Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "aladdin_and_the_sorcerer": {
        name: "Aladdin and the Sorcerer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "alaskan_fishing": {
        name: "Alaskan Fishing",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "alchemy_gold": {
        name: "Alchemy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "alchymedes": {
        name: "Alchymedes",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "aldos_journey": {
        name: "Aldo's Journey",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "alexandria_fire": {
        name: "Alexandria Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "alibabas_cave_of_fortune": {
        name: "Alibaba's Cave of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "alibi": {
        name: "Alibi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "alice_in_adventureland": {
        name: "Alice in Adventureland",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "alice_wonderluck": {
        name: "Alice Wonderluck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_fruits": {
        name: "Alien Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_fruits_2": {
        name: "Alien Fruits 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_fruits_3": {
        name: "Alien Fruits 3",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alien_invaders": {
        name: "Alien Invaders",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "alien_sea_turtles_vs_humans": {
        name: "Alien Sea Turtles vs Humans",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "all_for_one": {
        name: "All For One",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "all_star_fruits": {
        name: "All Star Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "almighty_athena_empire": {
        name: "Almighty Athena Empire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "almighty_bear_megaways": {
        name: "Almighty Bear Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "almighty_dionysus_empire": {
        name: "Almighty Dionysus Empire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "almighty_goddess_zera": {
        name: "Almighty Goddess Zera",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "almighty_hera": {
        name: "Almighty Hera",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "almighty_poseidon_empire": {
        name: "Almighty Poseidon Empire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "almighty_zeus_empire": {
        name: "Almighty Zeus Empire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "almighty_zeus_wilds": {
        name: "Almighty Zeus Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "almighty_zeus_wilds_link_and_merge": {
        name: "Almighty Zeus Wilds Link and Merge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "aloha_king_elvis": {
        name: "Aloha King Elvis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "alpha_eagle": {
        name: "Alpha Eagle",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "alpha_gold": {
        name: "Alpha Gold",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "always_up_x10000": {
        name: "Always Up x10000",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "amazing_baccarat": {
        name: "Amazing Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "amazing_money_machine": {
        name: "Amazing Money Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "amazon_lost_gold": {
        name: "Amazon Lost Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "american_blackjack": {
        name: "American Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "american_roulette": {
        name: "American Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "amstel_roulette": {
        name: "Amstel Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "amulets_of_horus": {
        name: "Amulets of Horus",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "anacoda_gold": {
        name: "Anacoda Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_egypt": {
        name: "Ancient Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_egypt_classic": {
        name: "Ancient Egypt Classic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_fortunes_poseidon_megaways": {
        name: "Ancient Fortunes : Poseidon Megaways",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "ancient_fortunes_zeus": {
        name: "Ancient Fortunes: Zeus",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "ancient_island_megaways": {
        name: "Ancient Island Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ancient_magic": {
        name: "Ancient Magic",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ancient_riches": {
        name: "Ancient Riches",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ancient_treasure_poseidon": {
        name: "Ancient Treasure Poseidon",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "ancient_tumble": {
        name: "Ancient Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "andar_bahar": {
        name: "Andar Bahar",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "andar_bahar_a": {
        name: "Andar Bahar A",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "andar_bahar_royale": {
        name: "Andar Bahar Royale",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "andvari_the_golden_fish": {
        name: "Andvari the Golden Fish",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "angel_vs_sinner": {
        name: "Angel vs Sinner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "animafia": {
        name: "Animafia",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "animal_carnival": {
        name: "Animal Carnival",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "animal_madness": {
        name: "Animal Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "animals_strike": {
        name: "Animals Strike",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "anime_mecha_megaways": {
        name: "Anime Mecha Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ankh_of_anubis": {
        name: "Ankh of Anubis",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ankh_of_anubis_awakening": {
        name: "Ankh of Anubis Awakening",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "annihilator": {
        name: "Annihilator",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "anubis_curse": {
        name: "Anubis Curse",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "anubis_curse_2": {
        name: "Anubis Curse 2",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "anubis_wrath": {
        name: "Anubis Wrath",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "anvil_and_ore": {
        name: "Anvil & Ore",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "apex_strike_lucky_cache": {
        name: "Apex Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "apex_strike_megaways": {
        name: "Apex Strike Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "aphrodite_goes_wild_rushingwilds": {
        name: "Aphrodite Goes Wild RushingWilds",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "arabian_spins": {
        name: "Arabian Spins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "arcade": {
        name: "Arcade",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "arcader": {
        name: "Arcader",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "arcanapop": {
        name: "ArcanaPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "arcane_elements": {
        name: "Arcane Elements",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "arcane_gems": {
        name: "Arcane Gems",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "arctic_fruits": {
        name: "Arctic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "arctic_hunt": {
        name: "Arctic Hunt",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "arctic_wonders": {
        name: "Arctic Wonders",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "argonauts": {
        name: "Argonauts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "arizona_heist_hold_and_win": {
        name: "Arizona Heist: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "ark_of_mystery": {
        name: "Ark of Mystery",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "army_of_ares": {
        name: "Army of Ares",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "arriba_heat_salsa_wilds": {
        name: "Arriba Heat Salsa Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "arrow_slot": {
        name: "Arrow Slot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "artemis_vs_medusa": {
        name: "Artemis vs Medusa",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "arthurs_fortune": {
        name: "Arthur's Fortune",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "artic_wolf_triple_riches": {
        name: "Artic Wolf Triple Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "artifacts": {
        name: "Artifacts",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "asgard": {
        name: "Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "asgard_warriors": {
        name: "Asgard Warriors",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "asgardian_fire": {
        name: "Asgardian Fire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "asgardian_rising": {
        name: "Asgardian Rising",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "asian_beauty": {
        name: "Asian Beauty",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "assassin_moon": {
        name: "Assassin Moon",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "astro": {
        name: "Astro",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "astro_legends_lyra_and_erion": {
        name: "Astro Legends: Lyra and Erion",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "astro_newts_megaways": {
        name: "Astro Newts Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "astropop": {
        name: "AstroPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "athena_ascending": {
        name: "Athena Ascending",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "atlantean_gigarise": {
        name: "Atlantean Gigarise",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "atlantic_wilds": {
        name: "Atlantic Wilds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "atlantis_crush": {
        name: "Atlantis Crush",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "atomic_kittens": {
        name: "Atomic Kittens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "attila_the_hun": {
        name: "Attila The Hun",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "aura_god": {
        name: "Aura God",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "aura_of_jupiter": {
        name: "Aura of Jupiter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "aurora_wilds": {
        name: "Aurora Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "aurum_roulette_brasileira": {
        name: "Aurum Roulette Brasileira",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "aurum_sic_bo": {
        name: "Aurum Sic Bo",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "auto_mega_roulette": {
        name: "Auto Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "auto_roulette": {
        name: "Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "auto_roulette_speed": {
        name: "Auto Roulette Speed",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "avalon": {
        name: "Avalon",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "avalon_the_lost_kingdom": {
        name: "Avalon: The Lost Kingdom",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "avatars_gateway_guardians": {
        name: "Avatars: Gateway Guardians",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "aviamasters": {
        name: "Aviamasters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aviamasters_2": {
        name: "Aviamasters 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aviamasters_xmas": {
        name: "Aviamasters Xmas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aviator": {
        name: "Aviator",
        provider: "Aviator",
        providerSlug: "aviator"
    },
    "aztec_blaze": {
        name: "Aztec Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_bonanza": {
        name: "Aztec Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_clusters": {
        name: "Aztec Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_gems": {
        name: "Aztec Gems",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_gems_deluxe": {
        name: "Aztec Gems Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_gems_megaways": {
        name: "Aztec Gems Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_idols": {
        name: "Aztec Idols",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "aztec_king": {
        name: "Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_king_megaways": {
        name: "Aztec King MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_magic_bonanza": {
        name: "Aztec Magic Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_magic_deluxe": {
        name: "Aztec Magic Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_magic_megaways": {
        name: "Aztec Magic MEGAWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztec_powernudge": {
        name: "Aztec Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_smash": {
        name: "Aztec Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_treasure_hunt": {
        name: "Aztec Treasure Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "aztec_triple_riches_power_combo": {
        name: "Aztec Triple Riches Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "aztec_warrior_princess": {
        name: "Aztec Warrior Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "aztec_wilds_megaways": {
        name: "Aztec Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "aztecs_claw_wild_dice": {
        name: "Aztec's Claw Wild Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "aztecx": {
        name: "Aztec-X",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "azticons_chaos_clusters": {
        name: "Azticons Chaos Clusters",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "aztlans_gold": {
        name: "Aztlan's Gold",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "baba_yaga": {
        name: "Baba Yaga",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "babushkas": {
        name: "Babushkas",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "baccarat": {
        name: "Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "baccarat_classic": {
        name: "Baccarat Classic",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "baccarat_deluxe": {
        name: "Baccarat Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "baccarat_ftv": {
        name: "Baccarat FTV",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "baccarat_lobby": {
        name: "Baccarat Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "back_to_70s": {
        name: "Back to 70's",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "back_to_the_fruits": {
        name: "Back to the Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "back_to_the_fruits_respins_of_amunre": {
        name: "Back to the Fruits Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "bacon_banker": {
        name: "Bacon Banker",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "bad_babushkas": {
        name: "Bad Babushkas",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "bad_bass": {
        name: "Bad Bass",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bad_bass_cash_haul": {
        name: "Bad Bass Cash Haul",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bad_bass_cash_towers": {
        name: "Bad Bass Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bad_santa": {
        name: "Bad Santa",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "badge_blitz": {
        name: "Badge Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "badger_miners": {
        name: "Badger Miners",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "badminton_hero": {
        name: "Badminton Hero",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bakers_treat": {
        name: "Baker's Treat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bakery_bonanza": {
        name: "Bakery Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "bali_vacation": {
        name: "Bali Vacation",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "balloon_mania": {
        name: "Balloon Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "balloons": {
        name: "Balloons",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bamboo_wilds": {
        name: "Bamboo Wilds",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "banana_rock": {
        name: "Banana Rock",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "banana_rush": {
        name: "Banana Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "banana_town": {
        name: "Banana Town",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bandit_megaways": {
        name: "Bandit Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bang_bang": {
        name: "Bang Bang",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bang_bang_reloaded": {
        name: "Bang Bang Reloaded",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bank_wagon_heist": {
        name: "Bank Wagon Heist",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "bankers_and_cash": {
        name: "Bankers and Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "bankin_bacon": {
        name: "Bankin' Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bankin_more_bacon": {
        name: "Bankin' More Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "banknote_blitz": {
        name: "Banknote Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "banquet_of_dead": {
        name: "Banquet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bao_shi": {
        name: "Bao Shi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "barbarian_gold": {
        name: "Barbarian Gold",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "barbarossa_dragon_empire": {
        name: "Barbarossa Dragon Empire",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "barbershop_uncut": {
        name: "Barbershop: Uncut",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "barn_busters": {
        name: "Barn Busters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "barn_festival": {
        name: "Barn Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "barnstormer_bucks": {
        name: "Barnstormer Bucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "barnyard_megahays_megaways": {
        name: "Barnyard Megahays Megaways™",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "baron_bloodmore_and_the_crimson_castle": {
        name: "Baron Bloodmore and the Crimson Castle",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "baron_lord_of_saturday": {
        name: "Baron: Lord of Saturday",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "baron_samedi": {
        name: "Baron Samedi",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "bars_and_7s": {
        name: "Bars & 7s",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "barx_safecracker_megaways": {
        name: "Bar-X Safecracker Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bash_bros": {
        name: "Bash Bros",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "basketball_star": {
        name: "Basketball Star",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "basketball_star_deluxe": {
        name: "Basketball Star Deluxe",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "basketball_star_on_fire": {
        name: "Basketball Star on Fire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "basketball_star_wilds": {
        name: "Basketball Star Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bass_catch_super_luck": {
        name: "Bass Catch Super Luck",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "battle_dwarf": {
        name: "Battle Dwarf",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "battle_dwarf_2": {
        name: "Battle Dwarf 2",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "battle_dwarf_xmas": {
        name: "Battle Dwarf Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "battle_maidens_cleopatra": {
        name: "Battle Maidens: Cleopatra",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "battle_maidens_cleopatra_no_buy_feature": {
        name: "Battle Maidens Cleopatra (No buy feature)",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "battle_royal": {
        name: "Battle Royal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "battleground_royale": {
        name: "Battleground Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "beach_party": {
        name: "Beach Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "beach_party_hot": {
        name: "Beach Party Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "beam_boys": {
        name: "Beam Boys",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bear_crazy": {
        name: "Bear Crazy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bears_make_bank_power_combo": {
        name: "Bears Make Bank Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "beast_band": {
        name: "Beast Band",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "beast_below": {
        name: "Beast Below",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "beast_coinz": {
        name: "Beast Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "beast_gains": {
        name: "Beast Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "beast_mode": {
        name: "Beast Mode",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "beastie_bux": {
        name: "Beastie Bux",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "beastly_burglars": {
        name: "Beastly Burglars",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "beasts_of_fire": {
        name: "Beasts Of Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "beasts_of_fire_maximum": {
        name: "Beasts of Fire Maximum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "beasty_blox_gigablox": {
        name: "Beasty Blox GigaBlox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "beat_the_beast_dragons_wrath": {
        name: "Beat the Beast: Dragon's Wrath",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "beat_the_beast_griffins_gold": {
        name: "Beat the Beast: Griffin's Gold",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "beat_the_beast_krakens_lair": {
        name: "Beat the Beast: Kraken's Lair",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "beat_the_beast_quetzalcoatls_trial": {
        name: "Beat the Beast: Quetzalcoatl's Trial",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "beautiful_bones": {
        name: "Beautiful Bones",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "beautiful_nature": {
        name: "Beautiful Nature",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "beauty_and_the_beast": {
        name: "Beauty and the Beast",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "beauty_fruity": {
        name: "Beauty Fruity",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "bee_keeper": {
        name: "Bee Keeper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "beer_bonanza": {
        name: "Beer Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "beer_boost": {
        name: "Beer Boost",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "beer_party": {
        name: "Beer Party",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "before_time_runs_out": {
        name: "Before Time Runs Out",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bell_wizard": {
        name: "Bell Wizard",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "benny_the_beer": {
        name: "Benny The Beer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "berserkin_buffalo_power_hit": {
        name: "Berserkin Buffalo Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bet_on_poker": {
        name: "Bet On Poker",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "better_barn_house_bonanza": {
        name: "Better Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "beware_the_deep_megaways": {
        name: "Beware The Deep Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bicicleta": {
        name: "Bicicleta",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "big_apple_wins": {
        name: "Big Apple Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "big_atlantis_frenzy": {
        name: "Big Atlantis Frenzy",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "big_bad_wolf": {
        name: "Big Bad Wolf",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bad_wolf_christmas_special": {
        name: "Big Bad Wolf Christmas Special",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bad_wolf_megaways": {
        name: "Big Bad Wolf Megaways",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bad_wolf_pigs_of_steel": {
        name: "Big Bad Wolf: Pigs of Steel",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_bass_amazon_xtreme": {
        name: "Big Bass Amazon Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza": {
        name: "Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_1000": {
        name: "Big Bass Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_3_reeler": {
        name: "Big Bass Bonanza 3 Reeler",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_keeping_it_reel": {
        name: "Big Bass Bonanza - Keeping it Reel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_megaways": {
        name: "Big Bass Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_bonanza_reel_action": {
        name: "Big Bass Bonanza - Reel Action",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_boxing_bonus_round": {
        name: "Big Bass Boxing Bonus Round",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_christmas_bash": {
        name: "Big Bass Christmas Bash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_christmas_frozen_lake": {
        name: "Big Bass Christmas Frozen Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_crash": {
        name: "Big Bass Crash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_day_at_the_races": {
        name: "Big Bass Day at the Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_floats_my_boat": {
        name: "Big Bass Floats My Boat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_football_bonanza": {
        name: "Big Bass Football Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_halloween": {
        name: "Big Bass Halloween",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_halloween_2": {
        name: "Big Bass Halloween 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_halloween_3": {
        name: "Big Bass Halloween 3",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_hold_and_spinner": {
        name: "Big Bass - Hold & Spinner™",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_hold_and_spinner_megaways": {
        name: "Big Bass Hold & Spinner Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_mission_fishin": {
        name: "Big Bass Mission Fishin'",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_raceday_repeat": {
        name: "Big Bass Raceday Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_reel_repeat": {
        name: "Big Bass Reel Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_return_to_the_races": {
        name: "Big Bass Return to the Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_secrets_of_the_golden_lake": {
        name: "Big Bass Secrets of the Golden Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_splash": {
        name: "Big Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_splash_1000": {
        name: "Big Bass Splash 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_trophy_catch": {
        name: "Big Bass Trophy Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_vegas_double_down_deluxe": {
        name: "Big Bass Vegas Double Down Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_bass_xmas_xtreme": {
        name: "Big Bass Xmas Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_black_cock": {
        name: "Big Black Cock",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "big_blox": {
        name: "Big Blox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "big_boom_riches": {
        name: "Big Boom Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "big_bot_crew": {
        name: "Big Bot Crew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "big_buck_blitz": {
        name: "Big Buck Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "big_burger_load_it_up_with_xtra_cheese": {
        name: "Big Burger Load it up with Xtra Cheese",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_button_bash": {
        name: "Big Button Bash",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "big_catch_bass_fishing_megaways": {
        name: "Big Catch Bass Fishing Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_craze": {
        name: "Big Catch Craze",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "big_catch_even_bigger_bass_2": {
        name: "Big Catch Even Bigger Bass 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_even_bigger_bass_3_megaways": {
        name: "Big Catch Even Bigger Bass 3 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_catch_xmas": {
        name: "Big Catch Xmas",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "big_fin_bay": {
        name: "Big Fin Bay",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "big_juan": {
        name: "Big Juan",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "big_money_frenzy_cash_gains": {
        name: "Big Money Frenzy Cash Gains",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_money_megaways": {
        name: "Big Money Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "big_roar": {
        name: "Big Roar",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "big_top": {
        name: "Big Top",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "big_win_777": {
        name: "Big Win 777",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "big_win_cat": {
        name: "Big Win Cat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "big_win_city_pawsperity": {
        name: "Big Win City Pawsperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bigger_barn_house_bonanza": {
        name: "Bigger Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_bass_blizzard_christmas_catch": {
        name: "Bigger Bass Blizzard - Christmas Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_bass_bonanza": {
        name: "Bigger Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_bass_splash": {
        name: "Bigger Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bigger_catch_bass_fishing": {
        name: "Bigger Catch Bass Fishing",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "biggy_winnie_feat_the_rich_one": {
        name: "Biggy Winnie feat The Rich One",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "bikini_island": {
        name: "Bikini Island",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bikini_island_deluxe": {
        name: "Bikini Island Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bikini_paradise": {
        name: "Bikini Paradise",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "bikini_party": {
        name: "Bikini Party",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bill_and_coin": {
        name: "Bill & Coin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bill_and_coin_2": {
        name: "Bill and Coin 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bingo_mania": {
        name: "Bingo Mania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bird_of_thunder": {
        name: "Bird of Thunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "birds_on_a_wire": {
        name: "Birds On A Wire",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "bison_bonanza": {
        name: "Bison Bonanza",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_fire_charge": {
        name: "Bison Fire Charge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bison_fire_charge_vf": {
        name: "Bison Fire Charge VF",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bison_moon": {
        name: "Bison Moon",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bison_rising_gold_strike": {
        name: "Bison Rising Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_rising_megaways": {
        name: "Bison Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_rising_reloaded_megaways": {
        name: "Bison Rising Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bison_vs_buffalo": {
        name: "Bison vs Buffalo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "black_beauty": {
        name: "Black Beauty",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "black_bull": {
        name: "Black Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "black_friday": {
        name: "Black Friday",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "black_friday_cart_craze": {
        name: "Black Friday Cart Craze",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "black_hawk": {
        name: "Black Hawk",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_hawk_deluxe": {
        name: "Black Hawk Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_horse": {
        name: "Black Horse",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_horse_deluxe": {
        name: "Black Horse Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "black_mamba": {
        name: "Black Mamba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "black_mummy": {
        name: "Black Mummy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "blackbeards_bounty": {
        name: "Blackbeard's Bounty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "blackbeards_quest": {
        name: "Blackbeard's Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "blackjack": {
        name: "Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_amsterdam": {
        name: "Blackjack Amsterdam",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_berlin": {
        name: "Blackjack Berlin",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_calgary": {
        name: "Blackjack Calgary",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_lobby": {
        name: "Blackjack Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blackjack_london": {
        name: "Blackjack London",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_manchester": {
        name: "Blackjack Manchester",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_monte_carlo": {
        name: "Blackjack Monte Carlo",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_montreal": {
        name: "Blackjack Montreal",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_premium": {
        name: "BlackJack Premium",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "blackjack_riga": {
        name: "Blackjack Riga",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjack_toronto": {
        name: "Blackjack Toronto",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "blackjackx": {
        name: "BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "blade_and_fangs": {
        name: "Blade & Fangs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blazin_bonus": {
        name: "Blazin' Bonus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "blazin_bullfrog": {
        name: "Blazin’ Bullfrog",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "blazin_quinn": {
        name: "Blazin' Quinn",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "blazing_777": {
        name: "Blazing 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "blazing_cash": {
        name: "Blazing Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blazing_fire_pots_hold_and_spin": {
        name: "Blazing Fire Pots Hold and Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "blazing_mammoth": {
        name: "Blazing Mammoth",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "blazing_wilds_megaways": {
        name: "Blazing Wilds Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blazing_wins_5_lines": {
        name: "Blazing Wins: 5 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "blender_blitz": {
        name: "Blender Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bling_blitz_diamond_drop": {
        name: "Bling Blitz Diamond Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "blinged": {
        name: "Blinged",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "blirix_workshop": {
        name: "Blirix workshop",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "blitz_super_wheel": {
        name: "Blitz Super Wheel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blockchain_megaways": {
        name: "Blockchain MEGAWAYS",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "blood_club": {
        name: "Blood Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "blood_moon_wilds": {
        name: "Blood Moon Wilds",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "blood_rage": {
        name: "Blood Rage",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "bloodthirst": {
        name: "Bloodthirst",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bloody_dawn": {
        name: "Bloody Dawn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "blue_fortune": {
        name: "Blue Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "boat_bonanza": {
        name: "Boat Bonanza",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_christmas": {
        name: "Boat Bonanza Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_colossal_catch": {
        name: "Boat Bonanza Colossal Catch",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_croconile": {
        name: "Boat Bonanza Croconile",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_bonanza_down_under": {
        name: "Boat Bonanza Down Under",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "boat_of_fortune": {
        name: "Boat of Fortune",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bob_marlin_goes_deep": {
        name: "Bob Marlin Goes Deep",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "boilin_pots": {
        name: "Boilin’ Pots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "bomb_bonanza": {
        name: "Bomb Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bomb_runner": {
        name: "Bomb Runner",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bombs_away": {
        name: "Bombs Away",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "bonanza_billion": {
        name: "Bonanza Billion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bonanza_billion_xtreme": {
        name: "Bonanza Billion Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bonanza_gold": {
        name: "Bonanza Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bonanza_trillion": {
        name: "Bonanza Trillion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bone_bonanza": {
        name: "Bone Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bone_raiders": {
        name: "Bone Raiders",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bones_and_bounty": {
        name: "Bones and Bounty",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "bonnys_treasure": {
        name: "Bonny's Treasure",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bonsai_dragon_blitz": {
        name: "Bonsai Dragon Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bonza_bucks_hold_and_win_extreme_10000": {
        name: "Bonza Bucks Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boogie_boom": {
        name: "Boogie Boom",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "book_del_sol": {
        name: "Book Del Sol",
        provider: "Playson",
        providerSlug: "playson"
    },
    "book_of_ages": {
        name: "Book of Ages",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_arabia": {
        name: "Book of Arabia",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "book_of_aztec_king": {
        name: "Book of Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_baal": {
        name: "Book Of Ba'al",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "book_of_blackeyes_bounty": {
        name: "Book of Blackeye's Bounty",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "book_of_books": {
        name: "Book of Books",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "book_of_buffalo": {
        name: "Book of Buffalo",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "book_of_cats": {
        name: "Book of Cats",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_cats_megaways": {
        name: "Book of Cats Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_cleo": {
        name: "Book of Cleo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_crazy_chicken": {
        name: "Book of Crazy Chicken",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_crystal_fruits": {
        name: "Book of Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_darius": {
        name: "Book of Darius",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_dead": {
        name: "Book of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "book_of_dead_go_collect": {
        name: "Book of Dead Go Collect",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "book_of_duat": {
        name: "Book of Duat",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "book_of_elements": {
        name: "Book of Elements",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_faith": {
        name: "Book of Faith™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "book_of_gold_classic": {
        name: "Book of Gold: Classic",
        provider: "Playson",
        providerSlug: "playson"
    },
    "book_of_gold_double_chance": {
        name: "Book of Gold: Double Chance",
        provider: "Playson",
        providerSlug: "playson"
    },
    "book_of_gold_multichance": {
        name: "Book of Gold: Multichance",
        provider: "Playson",
        providerSlug: "playson"
    },
    "book_of_golden_sands": {
        name: "Book of Golden Sands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_juno": {
        name: "Book of Juno",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_kemet": {
        name: "Book of Kemet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_kingdoms": {
        name: "Book Of Kingdoms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_love": {
        name: "Book of Love",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "book_of_madness": {
        name: "Book of Madness",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_madness_flaming_link": {
        name: "Book of Madness Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_madness_respins_of_amunre": {
        name: "Book of Madness Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_monsters": {
        name: "Book of Monsters",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "book_of_oasis": {
        name: "Book of Oasis",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_oz": {
        name: "Book of Oz",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "book_of_oz_lock_n_spin": {
        name: "Book of Oz - Lock 'N Spin",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "book_of_panda_megaways": {
        name: "Book Of Panda Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_power": {
        name: "Book of Power",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "book_of_pyramids": {
        name: "Book of Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "book_of_romeo_and_julia": {
        name: "Book of Romeo and Julia",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "book_of_spells": {
        name: "Book of Spells",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_time": {
        name: "Book of Time",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "book_of_tombs": {
        name: "Book of Tombs",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "book_of_vampires": {
        name: "Book of Vampires",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "book_of_wizardry": {
        name: "Book of Wizardry",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "book_of_yuletide": {
        name: "Book of Yuletide",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "bookie_of_odds": {
        name: "Bookie of Odds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "books_and_bounties": {
        name: "Books & Bounties",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_bulls": {
        name: "Books & Bulls",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_pearls": {
        name: "Books & Pearls",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_pearls_respins_of_amunre": {
        name: "Books & Pearls Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "books_and_temples": {
        name: "Books & Temples",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "boom_city": {
        name: "Boom City",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "boom_farm": {
        name: "Boom Farm",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "boom_time": {
        name: "Boom Time",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "booming_seven_deluxe": {
        name: "Booming Seven Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "booming_seven_deluxe_legacy": {
        name: "Booming Seven Deluxe Legacy",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "booze_bash": {
        name: "Booze Bash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bork_the_berzerker_hack_n_slash_edition": {
        name: "Bork The Berzerker Hack 'N' Slash Edition",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "born_wild": {
        name: "Born Wild",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bouncy_bombs": {
        name: "Bouncy Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bountiful_birds": {
        name: "Bountiful Birds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bounty_county": {
        name: "Bounty County",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "bounty_gold": {
        name: "Bounty Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bounty_hunter": {
        name: "Bounty Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bounty_hunter_unchained": {
        name: "Bounty Hunter Unchained",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bounty_pop": {
        name: "Bounty Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "bounty_showdown": {
        name: "Bounty Showdown",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "bow_of_artemis": {
        name: "Bow of Artemis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "brainwashed": {
        name: "Brainwashed",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "branded_book_of": {
        name: "Branded Book Of",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "branded_megaways": {
        name: "Branded Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "brawlers_bar_cash_collect": {
        name: "Brawlers Bar Cash Collect™",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "brawlers_brew": {
        name: "Brawlers Brew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "brazil_bomba_mobile": {
        name: "Brazil Bomba Mobile",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "brazilian_mega_roulette": {
        name: "Brazilian Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "brazilian_roulette": {
        name: "Brazilian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "break_away": {
        name: "Break Away",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_away_candy_link_and_merge": {
        name: "Break Away Candy Link and Merge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_away_candy_link_and_merge_vf": {
        name: "Break Away Candy Link and Merge VF",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_away_deluxe": {
        name: "Break Away Deluxe",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_away_lucky_wilds": {
        name: "Break Away Lucky Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_away_shootout": {
        name: "Break Away Shootout",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_away_ultra": {
        name: "Break Away Ultra",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_bones": {
        name: "Break Bones",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "break_da_bank": {
        name: "Break da Bank",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_da_bank_again": {
        name: "Break da Bank Again",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_da_bank_again_megaways": {
        name: "Break Da Bank Again MEGAWAYS",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_da_bank_again_respin": {
        name: "Break Da Bank Again Respin",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "break_the_ice": {
        name: "Break the Ice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "breakaway_gold": {
        name: "Breakaway Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "breakaway_max": {
        name: "Breakaway MAX",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "brew_brothers": {
        name: "Brew Brothers",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "brew_brothers_xmas_brew": {
        name: "Brew Brothers Xmas Brew",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "brick_house_bonanza": {
        name: "Brick House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bronco_big_bounty": {
        name: "Bronco Big Bounty",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "brooklyn_bootleggers": {
        name: "Brooklyn Bootleggers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "bruce_bumerang": {
        name: "Bruce Bumerang",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "bubble_beez": {
        name: "Bubble Beez",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "bubble_pop": {
        name: "Bubble Pop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bubblegum_and_robo": {
        name: "Bubblegum and Robo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "bubblin_riches": {
        name: "Bubblin Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "buffalo_freedom_doublemax": {
        name: "Buffalo Freedom Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "buffalo_hold_and_win": {
        name: "Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "buffalo_hold_and_win_extreme": {
        name: "Buffalo Hold and Win Extreme",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "buffalo_hold_and_win_extreme_10000": {
        name: "Buffalo Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "buffalo_king": {
        name: "Buffalo King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "buffalo_king_megaways": {
        name: "Buffalo King Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "buffalo_king_untamed_megaways": {
        name: "Buffalo King Untamed Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "buffalo_of_wealth": {
        name: "Buffalo of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "buffalo_power_2": {
        name: "Buffalo Power 2",
        provider: "Playson",
        providerSlug: "playson"
    },
    "buffalo_power_christmas": {
        name: "Buffalo Power: Christmas",
        provider: "Playson",
        providerSlug: "playson"
    },
    "buffalo_power_hold_and_win": {
        name: "Buffalo Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "buffalo_power_megaways": {
        name: "Buffalo Power Megaways",
        provider: "Playson",
        providerSlug: "playson"
    },
    "buffalo_stacknsync": {
        name: "Buffalo Stack'n'Sync",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "buffalo_win": {
        name: "Buffalo Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "buggy_bonus": {
        name: "Buggy Bonus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "buildin_bucks": {
        name: "Buildin' Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "buildin_even_more_bucks": {
        name: "Buildin' Even More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "buildin_more_bucks": {
        name: "Buildin More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bull_fiesta": {
        name: "Bull Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "bull_in_a_china_shop": {
        name: "Bull in a China Shop",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bull_in_a_rodeo": {
        name: "Bull in a Rodeo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bullets_and_bounty": {
        name: "Bullets and Bounty",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "bullion_blitz_power_play": {
        name: "Bullion Blitz Power Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "bullion_express": {
        name: "Bullion Express",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "bunny_heist": {
        name: "Bunny Heist",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "burning_chilli_243": {
        name: "Burning Chilli 243",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "burning_chilli_x": {
        name: "Burning Chilli X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "burning_classic_2": {
        name: "Burning Classic 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_classics": {
        name: "Burning Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_classics_5000": {
        name: "Burning Classics 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_classics_royal_edition": {
        name: "Burning Classics \nRoyal Edition",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_desire": {
        name: "Burning Desire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "burning_fortunator": {
        name: "Burning Fortunator",
        provider: "Playson",
        providerSlug: "playson"
    },
    "burning_love": {
        name: "Burning Love",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "burning_reels": {
        name: "Burning Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_riot": {
        name: "Burning RIot",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "burning_stars": {
        name: "Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_stars_3": {
        name: "Burning Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_sun": {
        name: "Burning Sun™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_sun_extremely_light": {
        name: "Burning Sun™ Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "burning_wins": {
        name: "Burning Wins",
        provider: "Playson",
        providerSlug: "playson"
    },
    "burning_wins_x2": {
        name: "Burning Wins x2",
        provider: "Playson",
        providerSlug: "playson"
    },
    "bust_the_bank": {
        name: "Bust the Bank",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "busy_bees": {
        name: "Busy Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "butterfly_blossom": {
        name: "Butterfly Blossom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "butterfly_lovers": {
        name: "Butterfly Lovers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cabin_crashers": {
        name: "Cabin Crashers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "caishen_wins": {
        name: "Caishen Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "caishens_cash": {
        name: "Caishen's Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "caishens_cash_pots": {
        name: "Caishen's Cash Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "caishens_gold": {
        name: "Caishen's Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cake_valley": {
        name: "Cake Valley",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "calavera_crush": {
        name: "Calavera Crush",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "calaveras_explosivas": {
        name: "Calaveras Explosivas",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "camelot_cash": {
        name: "Camelot Cash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "candy_blitz": {
        name: "Candy Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_blitz_bombs": {
        name: "Candy Blitz Bombs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_bonanza": {
        name: "Candy Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "candy_burst": {
        name: "Candy Burst",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "candy_coinz": {
        name: "Candy Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "candy_corner": {
        name: "Candy Corner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_glyph": {
        name: "Candy Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "candy_island_princess": {
        name: "Candy Island Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "candy_jar_clusters": {
        name: "Candy Jar Clusters™",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_monsta": {
        name: "Candy Monsta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "candy_rush": {
        name: "Candy Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_rush_wilds": {
        name: "Candy Rush Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "candy_rush_wilds_2": {
        name: "Candy Rush Wilds 2",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "candy_stars": {
        name: "Candy Stars",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candy_tower": {
        name: "Candy Tower",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "candy_treasures": {
        name: "Candy Treasures",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "candy_treasures_cash_towers": {
        name: "Candy Treasures Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "candy_village": {
        name: "Candy Village",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "candycash": {
        name: "CandyCash",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "candyfinity": {
        name: "Candyfinity",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "canine_carnage": {
        name: "Canine Carnage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cannonade": {
        name: "Cannonade!",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "canyon_riches": {
        name: "Canyon Riches",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "captain_glum_pirate_hunter": {
        name: "Captain Glum: Pirate Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "captain_kraken_megaways": {
        name: "Captain Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "captain_moregain": {
        name: "Captain More'gain",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "captain_shark": {
        name: "Captain Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "captain_xenos_earth_adventure": {
        name: "Captain Xeno's Earth Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "captains_bounty": {
        name: "Captain's Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "captains_curse": {
        name: "Captain's Curse",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "capymania_green": {
        name: "Capymania Green",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "capymania_orange": {
        name: "Capymania Orange",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "capymania_yellow": {
        name: "Capymania Yellow",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "caravan_of_riches": {
        name: "Caravan of Riches",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "cards_champion": {
        name: "Cards Champion",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "carioca_vibes": {
        name: "Carioca Vibes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "carnaval": {
        name: "Carnaval",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "carnaval_fiesta": {
        name: "Carnaval Fiesta",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "carnival_bonanza": {
        name: "Carnival Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "carnival_cash": {
        name: "Carnival Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "carnival_cove": {
        name: "Carnival Cove",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "carnival_queen": {
        name: "Carnival Queen",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "carnival_queen_2": {
        name: "Carnival Queen 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "carol_of_the_elves": {
        name: "Carol of the Elves",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "carribean_beach_poker": {
        name: "Carribean Beach Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cartel_chase": {
        name: "Cartel Chase",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "carts_of_cash": {
        name: "Carts of Cash",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "carts_of_cash_xmas": {
        name: "Carts of Cash Xmas",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "cash_a_cabana": {
        name: "Cash a Cabana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_blitz": {
        name: "Cash Blitz",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "cash_blitz_extreme": {
        name: "Cash Blitz Extreme",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "cash_bonanza": {
        name: "Cash Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_box": {
        name: "Cash Box",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_chips": {
        name: "Cash Chips",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_crew": {
        name: "Cash Crew",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_elevator": {
        name: "Cash Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_grotto": {
        name: "Cash Grotto",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cash_in_transit": {
        name: "Cash in Transit",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "cash_mania": {
        name: "Cash Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "cash_n_riches_megaways": {
        name: "Cash 'N Riches Megaways",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "cash_of_command": {
        name: "Cash of Command",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_pandas": {
        name: "Cash Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "cash_patrol": {
        name: "Cash Patrol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_pig": {
        name: "Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cash_pig_2": {
        name: "Cash Pig 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cash_pig_2_15000": {
        name: "Cash Pig 2 15000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cash_pool": {
        name: "Cash Pool",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_pump": {
        name: "Cash Pump",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_quest": {
        name: "Cash Quest",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_reef": {
        name: "Cash Reef",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "cash_strike": {
        name: "Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_hotstepper": {
        name: "Cash Strike Hotstepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_hotstepper_megaways": {
        name: "Cash Strike Hotstepper Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_power_5": {
        name: "Cash Strike Power 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_power_force_5_megaways": {
        name: "Cash Strike Power force 5 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_power_up": {
        name: "Cash Strike Power Up",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_win_boost": {
        name: "Cash Strike Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_strike_xcash": {
        name: "Cash Strike X-Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "cash_surge": {
        name: "Cash Surge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cash_truck": {
        name: "Cash Truck",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_truck_2": {
        name: "Cash Truck 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_truck_3_turbo": {
        name: "Cash Truck 3 Turbo",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_truck_begins": {
        name: "Cash Truck Begins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_truck_xmas_delivery": {
        name: "Cash Truck Xmas Delivery",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "cash_vandal": {
        name: "Cash Vandal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cash_vault_i": {
        name: "Cash Vault I",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_vault_ii": {
        name: "Cash Vault II",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cash_wheel_carnival": {
        name: "Cash Wheel Carnival",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "cashin_joker": {
        name: "Cashin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cashosaurus": {
        name: "Cashosaurus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "cashout_blackjack": {
        name: "Cashout Blackjack",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "cashpots_blazinator": {
        name: "Cashpots Blazinator",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "casino_barbut": {
        name: "Casino Barbut",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "casino_holdem": {
        name: "Casino Holdem",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "casino_holdem_eclipse": {
        name: "Casino Holdem Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "casino_patience": {
        name: "Casino Patience",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "casino_zeppelin_reloaded": {
        name: "Casino Zeppelin Reloaded",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "castle_of_fire": {
        name: "Castle of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cat_clans": {
        name: "Cat Clans",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "cat_wilde_and_the_doom_of_dead": {
        name: "Cat Wilde and the Doom of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_and_the_incan_quest": {
        name: "Cat Wilde and the Incan Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_and_the_lost_chapter": {
        name: "Cat Wilde and the Lost Chapter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_and_the_pyramids_of_dead": {
        name: "Cat Wilde and the Pyramids of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cat_wilde_in_the_eclipse_of_the_sun_god": {
        name: "Cat Wilde in the Eclipse of the Sun God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "catch_the_gold_hold_and_win": {
        name: "Catch the Gold Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "catdiana": {
        name: "Catdiana",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "cats_and_cash": {
        name: "Cats and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cats_soup": {
        name: "Cat's Soup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "cauldron": {
        name: "Cauldron",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "caveman_bob": {
        name: "Caveman Bob",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "cazino_cosmos": {
        name: "Cazino Cosmos",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "cazino_zeppelin": {
        name: "Cazino Zeppelin",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "centre_court": {
        name: "Centre Court",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "chambers_of_ancients": {
        name: "Chambers of Ancients",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "champion_of_the_underworld": {
        name: "Champion of the Underworld",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "champions_of_mithrune": {
        name: "Champions of Mithrune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "champions_of_rome": {
        name: "Champions of Rome",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "chaos_crew_2": {
        name: "Chaos Crew 2",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "chaos_crew_3": {
        name: "Chaos Crew 3",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "chaos_crew_scratch": {
        name: "Chaos Crew Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "charge_the_clovers_hit_the_bonus": {
        name: "Charge the Clovers Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "charlie_chance": {
        name: "Charlie Chance",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "charlie_chance_and_the_curse_of_cleopatra": {
        name: "Charlie Chance and The Curse of Cleopatra",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "charlie_chance_in_hell_to_pay": {
        name: "Charlie Chance in Hell to Pay",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "charming_hearts": {
        name: "Charming Hearts",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "chase_for_glory": {
        name: "Chase for Glory",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cheeky_emperor": {
        name: "Cheeky Emperor",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cherry_pop": {
        name: "Cherry Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cherry_pop_deluxe": {
        name: "Cherry Pop Deluxe",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cherrypop_burst": {
        name: "CherryPop Burst",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "chests_of_cai_shen": {
        name: "Chests of Cai Shen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chests_of_cai_shen_2": {
        name: "Chests of Cai Shen 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chibeasties": {
        name: "Chibeasties",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "chicken": {
        name: "Chicken+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chicken_chase": {
        name: "Chicken Chase",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chicken_drop": {
        name: "Chicken Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chicken_night_fever": {
        name: "Chicken Night Fever",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "chicken_rush": {
        name: "Chicken Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "chicken_shot": {
        name: "Chicken Shot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "chicken_x": {
        name: "Chicken X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "chicken_x_and_friends": {
        name: "Chicken X and Friends",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "chicky_run": {
        name: "Chicky Run",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "chief_hawks_spirit_walk": {
        name: "Chief Hawk's Spirit Walk",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "chilli_bandits": {
        name: "Chilli Bandits",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "chilli_heat": {
        name: "Chilli Heat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chilli_heat_megaways": {
        name: "Chilli Heat MEGAWAYS",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chilli_heat_spicy_spins": {
        name: "Chilli Heat Spicy Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "chilli_picante_megaways": {
        name: "Chilli Picante Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "chinese_new_year": {
        name: "Chinese New Year",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "chinese_speed_baccarat": {
        name: "Chinese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "chip_spin": {
        name: "Chip Spin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "choco_reels": {
        name: "Choco Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "chocolate_deluxe": {
        name: "Chocolate Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "christmas_big_bass_bonanza": {
        name: "Christmas Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "christmas_carol_megaways": {
        name: "Christmas Carol Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "christmas_gift_rush": {
        name: "Christmas Gift Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "christmas_megaways": {
        name: "Christmas Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "christmas_plaza_doublemax": {
        name: "Christmas Plaza Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "chronicles_of_olympus_zeus": {
        name: "Chronicles of Olympus Zeus",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "chronos_joker": {
        name: "Chronos Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "circle_of_life": {
        name: "Circle of Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "circle_of_sylvan": {
        name: "Circle of Sylvan",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "circus_delight": {
        name: "Circus Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "circus_jugglers_jackpots": {
        name: "Circus Jugglers Jackpots",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "city_of_sound": {
        name: "City of Sound",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "clash_of_camelot": {
        name: "Clash of Camelot",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "clash_of_claws": {
        name: "Clash of Claws",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "clash_of_gods_anubis_vs_hades": {
        name: "Clash of Gods Anubis vs Hades",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "classic_coins": {
        name: "Classic Coins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "classic_fantastic": {
        name: "Classic Fantastic",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "classic_fruit_hold_and_win": {
        name: "Classic Fruit Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "classic_fruits": {
        name: "Classic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "classic_multihand_blackjack": {
        name: "Classic Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "classico": {
        name: "Classico",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "cleocatra": {
        name: "Cleocatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cleopatras_fortune": {
        name: "Cleopatra's Fortune",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "cloud_princess": {
        name: "Cloud Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cloud_quest": {
        name: "Cloud Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "clover_bonanza": {
        name: "Clover Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "clover_charm_hit_the_bonus": {
        name: "Clover Charm: Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "clover_gold": {
        name: "Clover Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "clover_lady": {
        name: "Clover Lady",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "clover_strike_hold_and_win": {
        name: "Clover Strike Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "club_tropicana": {
        name: "Club Tropicana",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "club_tropicana_happy_hour": {
        name: "Club Tropicana Happy Hour",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "clubhouse_roulette": {
        name: "Clubhouse Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "cluckin_sweet_feast": {
        name: "Cluckin Sweet Feast",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "clucking_hell": {
        name: "Clucking Hell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "cluster_tumble": {
        name: "Cluster Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "cocktail_nights": {
        name: "Cocktail Nights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "coco_rush": {
        name: "Coco Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "coffee_wild": {
        name: "Coffee Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "coils_of_cash": {
        name: "Coils of Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "coin_blox": {
        name: "Coin Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "coin_crusher_hold_and_win": {
        name: "Coin Crusher Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "coin_field": {
        name: "Coin Field",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "coin_flip": {
        name: "Coin Flip",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "coin_quest": {
        name: "Coin Quest",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "coin_quest_2": {
        name: "Coin Quest 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "coin_strike_2_hold_and_win": {
        name: "Coin Strike 2: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "coin_strike_xxl": {
        name: "Coin Strike XXL",
        provider: "Playson",
        providerSlug: "playson"
    },
    "coin_vault": {
        name: "Coin Vault",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "coins": {
        name: "Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "coins_and_cannons": {
        name: "Coins and Cannons",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "coins_of_cleo": {
        name: "Coins of Cleo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "coins_of_valhalla_20000": {
        name: "Coins of Valhalla 20000",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "colin_the_cat": {
        name: "Colin the Cat",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "colors": {
        name: "Colors",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "colossal_cash_zone": {
        name: "Colossal Cash Zone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "colossal_gems": {
        name: "Colossal Gems",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "colt_lightning": {
        name: "Colt Lightning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "colt_lightning_firestorm": {
        name: "Colt Lightning Firestorm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "congo_cash": {
        name: "Congo Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "congo_cash_xl": {
        name: "Congo Cash XL",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "conquer_babylon": {
        name: "Conquer Babylon",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "contact": {
        name: "Contact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "coocoo_cashoo": {
        name: "CooCoo Cashoo",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "cop_the_lot_megaways_power_play": {
        name: "Cop the Lot Megaways Power Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "copsnrobbers": {
        name: "Cops'n'Robbers",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "corrida_romance": {
        name: "Corrida Romance",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "corrida_romance_deluxe": {
        name: "Corrida Romance Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cosmic_cash": {
        name: "Cosmic Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cosmic_jokers": {
        name: "Cosmic Jokers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cosmic_voyager": {
        name: "Cosmic Voyager",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "count_jokula": {
        name: "Count Jokula",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "court_of_hearts": {
        name: "Court of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "cowboy_coins": {
        name: "Cowboy Coins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cowboy_showdown": {
        name: "Cowboy Showdown",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "cowboys_gold": {
        name: "Cowboys Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "coyote_crash": {
        name: "Coyote Crash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "coyote_gold": {
        name: "Coyote Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "coywolf_cash": {
        name: "Coywolf Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crabbin_for_cash_extra_big_splash": {
        name: "Crabbin For Cash Extra Big Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "crabbin_for_cash_megaways": {
        name: "Crabbin' For Cash Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "crabbin_for_christmas": {
        name: "Crabbin For Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "crabbys_gold": {
        name: "Crabby's Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crack_the_bank_hold_and_win": {
        name: "Crack the Bank Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "crank_it_up": {
        name: "Crank It Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "crash": {
        name: "Crash",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "crash_squad": {
        name: "Crash Squad",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "crash_squad_winter_party": {
        name: "Crash Squad Winter Party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "crazy_bob_bonanza": {
        name: "Crazy Bob Bonanza",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "crazy_cars": {
        name: "Crazy Cars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "crazy_cows": {
        name: "Crazy Cows",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crazy_crops": {
        name: "Crazy Crops",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "crazy_diamonds": {
        name: "Crazy Diamonds",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "crazy_donuts": {
        name: "Crazy Donuts",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "crazy_mart_bonanza": {
        name: "Crazy Mart Bonanza",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crazy_rich_tigers": {
        name: "Crazy Rich Tigers",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "crazy_tiki_hold_and_win": {
        name: "Crazy Tiki Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "cred": {
        name: "Cred",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "creepy_christmas": {
        name: "Creepy Christmas",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "cricket_mania": {
        name: "Cricket Mania",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "cricket_star": {
        name: "Cricket Star",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "criss_cross_81": {
        name: "Criss Cross 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "critter_pop": {
        name: "Critter Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "cross_it": {
        name: "Cross It",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "cross_the_lake": {
        name: "Cross The Lake",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "cross_the_road": {
        name: "Cross the Road",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "crown_and_diamonds_hold_and_win": {
        name: "Crown and Diamonds: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "crown_of_avalon": {
        name: "Crown of Avalon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "crown_of_fire": {
        name: "Crown of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "crown_of_valor": {
        name: "Crown of Valor",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crowns_legacy": {
        name: "Crown's Legacy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "cruise_royale": {
        name: "Cruise Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "crypto_bro": {
        name: "Crypto Bro",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_10": {
        name: "Crypto Crown 10",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_20": {
        name: "Crypto Crown 20",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_40": {
        name: "Crypto Crown 40",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_crown_5": {
        name: "Crypto Crown 5",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "crypto_gold": {
        name: "Crypto Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "crystal_ball": {
        name: "Crystal Ball",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_deluxe": {
        name: "Crystal Ball Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_flaming_link": {
        name: "Crystal Ball Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_ball_multi_symbols": {
        name: "Crystal Ball Multi Symbols",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_burst_xxl": {
        name: "Crystal Burst XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_caverns_megaways": {
        name: "Crystal Caverns MEGAWAYS",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "crystal_clusters": {
        name: "Crystal Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "crystal_fruits_bonanza": {
        name: "Crystal Fruits Bonanza",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "crystal_hall": {
        name: "Crystal Hall",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crystal_prince": {
        name: "Crystal Prince",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crystal_queen": {
        name: "Crystal Queen",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crystal_queen_coins": {
        name: "Crystal Queen Coins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "crystal_quest_arcane_tower": {
        name: "Crystal Quest: Arcane Tower",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "crystal_quest_deep_jungle": {
        name: "Crystal Quest: Deep Jungle",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "crystal_quest_frostlands": {
        name: "Crystal Quest: Frostlands",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "crystal_roulette": {
        name: "Crystal Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "crystal_strike": {
        name: "Crystal Strike",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "crystal_sun": {
        name: "Crystal Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "crystopia": {
        name: "Crystopia",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "cube_mania": {
        name: "Cube Mania™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cube_mania_deluxe": {
        name: "Cube Mania Deluxe™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "cult": {
        name: "CULT",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cupids_crush": {
        name: "Cupid's Crush",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "curse_of_medusa": {
        name: "Curse of Medusa",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "curse_of_the_werewolf_megaways": {
        name: "Curse of the Werewolf Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cursed_crypt": {
        name: "Cursed Crypt",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cursed_seas": {
        name: "Cursed Seas",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cut_the_grass": {
        name: "Cut the Grass",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "cutie_cat": {
        name: "Cutie Cat",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "cyber_doom": {
        name: "Cyber Doom",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "cyber_heist": {
        name: "Cyber Heist",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cyber_pup_megaways": {
        name: "Cyber Pup Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cyber_slot": {
        name: "Cyber slot",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "cyberheist_city": {
        name: "Cyberheist City",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "cyclops_smash": {
        name: "Cyclops Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "da_vincis_treasure": {
        name: "Da Vinci’s Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dance_party": {
        name: "Dance Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dandy_diamonds": {
        name: "Dandy Diamonds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "danny_dollar": {
        name: "Danny Dollar",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dansband_pa_turne": {
        name: "Dansband Pa Turne",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dark_forge": {
        name: "Dark Forge",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "dark_spiral": {
        name: "Dark Spiral",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dark_summoning": {
        name: "Dark Summoning",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dark_vortex": {
        name: "Dark Vortex",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "daruma_impact": {
        name: "Daruma Impact",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dawn_of_egypt": {
        name: "Dawn of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dawn_of_kings": {
        name: "Dawn of Kings",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "day_of_dead": {
        name: "Day of Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dcirque": {
        name: "Dcirque",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "dead_mans_drop": {
        name: "Dead Man's Drop",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "dead_mans_riches": {
        name: "Dead Man's Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dead_mans_trail": {
        name: "Dead Man's Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "dead_riders_trail": {
        name: "Dead Riders Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "deal_with_death": {
        name: "Deal with Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "death_becomes_you": {
        name: "Death Becomes You",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "deep_descent": {
        name: "Deep Descent",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "deep_sea": {
        name: "Deep Sea",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "defenders_of_mystica": {
        name: "Defenders of Mystica",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "dega_baby": {
        name: "Dega Baby",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "demon": {
        name: "Demon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "demon_jack_27": {
        name: "Demon Jack 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "demon_pots": {
        name: "Demon Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "demon_slayer": {
        name: "Demon Slayer",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "demons_gate": {
        name: "Demon's Gate",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "densho": {
        name: "Densho",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "depths_of_fortune": {
        name: "Depths of Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "derby_rush": {
        name: "Derby Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "derby_wheel": {
        name: "Derby Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "desert_shark": {
        name: "Desert Shark",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "destiny_of_sun_and_moon": {
        name: "Destiny of Sun & Moon",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "devilicious": {
        name: "Devilicious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "devils_13": {
        name: "Devil's 13",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "devils_finger": {
        name: "Devils Finger",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "devour_the_weak": {
        name: "Devour the Weak",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "dia_de_los_muertos": {
        name: "Dia De Los Muertos",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "diamond_cascade": {
        name: "Diamond Cascade",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamond_charge_extra": {
        name: "Diamond Charge Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_charge_hold_and_win": {
        name: "Diamond Charge Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_charge_megaways": {
        name: "Diamond Charge Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_desire": {
        name: "Diamond Desire",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "diamond_desire_deluxe": {
        name: "Diamond Desire Deluxe",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "diamond_desire_flame": {
        name: "Diamond Desire Flame",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "diamond_dez": {
        name: "Diamond Dez",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "diamond_duke": {
        name: "Diamond Duke",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "diamond_forge_link_and_loot": {
        name: "Diamond Forge Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_fortunator": {
        name: "Diamond Fortunator",
        provider: "Playson",
        providerSlug: "playson"
    },
    "diamond_hill": {
        name: "Diamond Hill",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "diamond_hits": {
        name: "Diamond Hits",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_hits_trio_instastrike": {
        name: "Diamond Hits Trio Instastrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_mine_extra_gold": {
        name: "Diamond Mine Extra Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "diamond_mine_megaways": {
        name: "Diamond Mine Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "diamond_of_jungle": {
        name: "Diamond of Jungle",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "diamond_power_hold_and_win": {
        name: "Diamond Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "diamond_power_xxl_hold_and_win": {
        name: "Diamond Power XXL Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "diamond_riches": {
        name: "Diamond Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamond_rush": {
        name: "Diamond Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "diamond_strike": {
        name: "Diamond Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamond_supercharge": {
        name: "Diamond Supercharge",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "diamond_vortex": {
        name: "Diamond Vortex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "diamond_wins": {
        name: "Diamond Wins",
        provider: "Playson",
        providerSlug: "playson"
    },
    "diamonds": {
        name: "Diamonds",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "diamonds_are_forever_3_lines": {
        name: "Diamonds are Forever 3 Lines",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamonds_diamonds_diamonds_hold_and_win": {
        name: "Diamonds Diamonds Diamonds Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamonds_of_egypt": {
        name: "Diamonds of Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "diamonds_of_liberty": {
        name: "Diamonds of Liberty",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "diamonds_of_the_realm": {
        name: "Diamonds of the Realm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dice": {
        name: "Dice",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "dice_bonanza": {
        name: "Dice Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dice_city": {
        name: "Dice City",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "dice_million": {
        name: "Dice Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dice_pop": {
        name: "Dice Pop",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "dick_the_farmer": {
        name: "Dick the Farmer",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "dig_dig_digger": {
        name: "Dig Dig Digger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dig_it": {
        name: "Dig it",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "diner_delights": {
        name: "Diner Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "diner_frenzy_spins": {
        name: "Diner Frenzy Spins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ding_dong_christmas_bells": {
        name: "Ding Dong Christmas Bells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dino_reels_81": {
        name: "Dino Reels 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "dinosaur_rage": {
        name: "Dinosaur Rage",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dio_killing_the_dragon": {
        name: "DIO - Killing the Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dionysus_golden_feast": {
        name: "Dionysus Golden Feast",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "disc_of_athena": {
        name: "Disc of Athena",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "disco_777": {
        name: "Disco 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "disco_beats": {
        name: "Disco Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "disco_diamonds": {
        name: "Disco Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "disco_funk": {
        name: "Disco Funk",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "disco_lady": {
        name: "Disco Lady",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "disco_party": {
        name: "Disco Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "divina_commedia_i_nove_cerchi": {
        name: "Divina Commedia I Nove Cerchi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "divine_divas": {
        name: "Divine Divas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "divine_dragon_hold_and_win": {
        name: "Divine Dragon: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "divine_dreams": {
        name: "Divine Dreams",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "divine_drop": {
        name: "Divine Drop",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "divine_fire": {
        name: "Divine Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "divine_links": {
        name: "Divine Links",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "divine_lotus": {
        name: "Divine Lotus",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "divine_queen_heart_of_ice": {
        name: "Divine Queen Heart of Ice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "divine_riches_helios": {
        name: "Divine Riches Helios",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "divine_showdown": {
        name: "Divine Showdown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dog_days": {
        name: "Dog Days",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "dolla_dolla_bill": {
        name: "Dolla Dolla Bill",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "dolla_dolla_bill_mo_money": {
        name: "Dolla Dolla Bill Mo Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "domnitors_treasure": {
        name: "Domnitor's Treasure",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "don_juans_peppers": {
        name: "Don Juan's Peppers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "donkey_and_the_goats": {
        name: "Donkey & The Goats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "donny_and_danny": {
        name: "Donny and Danny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "donut_division": {
        name: "Donut Division",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "doom_of_egypt": {
        name: "Doom of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "doomsday_rampage": {
        name: "Doomsday Rampage",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "doomsday_saloon": {
        name: "Doomsday Saloon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dork_unit": {
        name: "Dork Unit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dorks_of_the_deep": {
        name: "Dorks of the Deep",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "double_cash_mummy": {
        name: "Double Cash Mummy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "double_dragons": {
        name: "Double Dragons",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "double_fortune": {
        name: "Double Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "double_o_dollars": {
        name: "Double O Dollars",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "double_rainbow": {
        name: "Double Rainbow",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "double_tigers": {
        name: "Double Tigers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "down_the_chimney": {
        name: "Down The Chimney",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "down_the_rails": {
        name: "Down the Rails",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dr_feelgood": {
        name: "Dr Feelgood",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dr_fortuno": {
        name: "Dr Fortuno",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "dr_toonz": {
        name: "Dr. Toonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "draculas_castle": {
        name: "Dracula's Castle",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "drago_jewels_of_fortune": {
        name: "Drago - Jewels of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_age_hold_and_win_dragon_age": {
        name: "Dragon Age Hold and Win (Dragon Age)",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dragon_blox": {
        name: "Dragon Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "dragon_bonus_baccarat": {
        name: "Dragon Bonus Baccarat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_castle": {
        name: "Dragon Castle",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragon_chase": {
        name: "Dragon Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dragon_dance": {
        name: "Dragon Dance",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "dragon_egg": {
        name: "Dragon Egg",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "dragon_gold_88": {
        name: "Dragon Gold 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_hatch": {
        name: "Dragon Hatch",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragon_hero": {
        name: "Dragon Hero",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_horn": {
        name: "Dragon Horn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "dragon_hot_hold_and_spin": {
        name: "Dragon Hot Hold & Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_king_hot_pots": {
        name: "Dragon King Hot Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_kingdom": {
        name: "Dragon Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_kingdom_eyes_of_fire": {
        name: "Dragon Kingdom - Eyes of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_legend": {
        name: "Dragon Legend",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragon_maiden": {
        name: "Dragon Maiden",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dragon_of_the_princess": {
        name: "Dragon of the Princess",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "dragon_pots_megaways": {
        name: "Dragon Pots Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_queens_megaways": {
        name: "Dragon Queens Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dragon_riches": {
        name: "Dragon Riches",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "dragon_shard": {
        name: "Dragon Shard",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "dragon_ship": {
        name: "Dragon Ship",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dragon_shrine": {
        name: "Dragon Shrine",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dragon_tiger": {
        name: "Dragon Tiger",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "dragon_tiger_fortunes": {
        name: "Dragon Tiger Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragon_tiger_gate": {
        name: "Dragon Tiger Gate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragon_tiger_lobby": {
        name: "Dragon Tiger Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "dragon_tiger_luck": {
        name: "Dragon Tiger Luck",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragon_trail": {
        name: "Dragon Trail",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "dragon_vs_phoenix": {
        name: "Dragon VS Phoenix",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "dragonfall": {
        name: "Dragonfall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "dragonfates_favour": {
        name: "Dragonfate's Favour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "dragons_awakening": {
        name: "Dragons' Awakening",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "dragons_gate_bonus_choice": {
        name: "Dragon's Gate Bonus Choice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dragons_gold_100": {
        name: "Dragon's Gold 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dragons_loot_link_and_win_4_tunes": {
        name: "Dragon's Loot Link and Win 4 Tunes",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "dragons_lucky_8": {
        name: "Dragons Lucky 8™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "dragons_realm": {
        name: "Dragon's Realm",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragons_rhythm": {
        name: "Dragon's Rhythm",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "dragons_throne": {
        name: "Dragon's Throne",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "dragons_tower": {
        name: "Dragon's Tower",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "dragons_treasure_quest": {
        name: "Dragon's Treasure Quest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "dragons_win_multiplier": {
        name: "Dragon's Win Multiplier",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "draw_sevens": {
        name: "Draw Sevens",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "dream_car_speed": {
        name: "Dream Car Speed",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dream_car_urban": {
        name: "Dream Car Urban",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dream_date": {
        name: "Dream Date",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "dreams_of_gold": {
        name: "Dreams of Gold",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dreams_of_gold_delight": {
        name: "Dreams of Gold Delight",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dreams_of_gold_jackpot": {
        name: "Dreams of Gold Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "dreams_of_macau": {
        name: "Dreams of Macau",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "drill_that_gold": {
        name: "Drill That Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dropem": {
        name: "Drop'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "druids_drop": {
        name: "Druid's Drop",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "drunken_sailors": {
        name: "Drunken Sailors",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "duck_hunt_500": {
        name: "Duck Hunt 500",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "duck_king": {
        name: "Duck King",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "duck_shooter": {
        name: "Duck Shooter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "duel_at_dawn": {
        name: "Duel at Dawn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "duel_of_night_and_day": {
        name: "Duel of Night and Day",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dungeon_tower": {
        name: "Dungeon Tower",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "dungeons_and_diamonds": {
        name: "Dungeons and Diamonds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "durian_dynamite": {
        name: "Durian Dynamite",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dusk_princess": {
        name: "Dusk Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "dusty_duel": {
        name: "Dusty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "dwarf_and_dragon": {
        name: "Dwarf & Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dwarf_mine": {
        name: "Dwarf Mine",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "dwarfs_fortune": {
        name: "Dwarfs Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "dwarfs_gone_wild": {
        name: "Dwarfs Gone Wild",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "dwarven_gems_megaways": {
        name: "Dwarven Gems Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "dwarven_gold_deluxe": {
        name: "Dwarven Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dyna_mule": {
        name: "Dyna Mule",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "dynamite_diggin_doug": {
        name: "Dynamite Diggin Doug",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "dynamite_trio": {
        name: "Dynamite Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "dynasty_of_death": {
        name: "Dynasty of Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eager_beavers": {
        name: "Eager Beavers",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "eagle_power_hold_and_win": {
        name: "Eagle Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "eagle_storm": {
        name: "Eagle Storm",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eagle_strike": {
        name: "Eagle Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "eagle_strike_extra": {
        name: "Eagle Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "eagle_strike_lucky_cache": {
        name: "Eagle Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "eagles_wings": {
        name: "Eagle's Wings",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "easter_classics": {
        name: "Easter Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "easter_eggs": {
        name: "Easter Eggs",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "easter_eggspedition": {
        name: "Easter Eggspedition",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "easter_heist": {
        name: "Easter Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "easter_island": {
        name: "Easter Island",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "easter_island_2": {
        name: "Easter Island 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "eastern_emeralds": {
        name: "Eastern Emeralds",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "eforce": {
        name: "E-Force",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "egg_hustler": {
        name: "Egg Hustler",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "eggs_of_fortune": {
        name: "Eggs of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "eggstra_cash": {
        name: "Eggstra Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "egyptian_dreams": {
        name: "Egyptian Dreams",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "egyptian_dreams_deluxe": {
        name: "Egyptian Dreams Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "egyptian_fortunes": {
        name: "Egyptian Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "egypts_book_of_mystery": {
        name: "Egypt's Book of Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "el_jackpotto": {
        name: "El Jackpotto",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "electric_rush": {
        name: "Electric Rush",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "electro_cubes": {
        name: "Electro Cubes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "elemental_gems_megaways": {
        name: "Elemental Gems Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "elemento": {
        name: "Elemento",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "elements_of_power": {
        name: "Elements of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "elves": {
        name: "Elves",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "elvis_frog_in_vegas": {
        name: "Elvis Frog In Vegas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "elvis_frog_trueways": {
        name: "Elvis Frog TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "elysian_jackpots": {
        name: "Elysian Jackpots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "emberfall": {
        name: "Emberfall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "emberfall_40k": {
        name: "Emberfall 40K",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "emerald_king": {
        name: "Emerald King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emerald_king_rainbow_road": {
        name: "Emerald King Rainbow Road",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emerald_king_wheel_of_wealth": {
        name: "Emerald King Wheel of Wealth",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emeralds_infinity_reels": {
        name: "Emerald's Infinity Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "emoji_riches": {
        name: "Emoji Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "emperor_caishen": {
        name: "Emperor Caishen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "emperor_of_the_sea": {
        name: "Emperor of the Sea",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "emperor_of_the_sea_deluxe": {
        name: "Emperor of the Sea Deluxe",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "emperors_favour": {
        name: "Emperor's Favour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "emperors_rise": {
        name: "Emperor's Rise",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "empire_gold_hold_and_win": {
        name: "Empire Gold: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "empty_the_bank": {
        name: "Empty the Bank",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "enchanted_crystals": {
        name: "Enchanted Crystals",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "enchanted_meadow": {
        name: "Enchanted Meadow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "energoonz": {
        name: "Energoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "energy_coins_hold_and_win": {
        name: "Energy Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "energy_joker_hold_and_win": {
        name: "Energy Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "engeki_rising_x50": {
        name: "Engeki Rising x50",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "epic_bullets_and_bounty": {
        name: "Epic Bullets and Bounty",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "epic_dreams": {
        name: "Epic Dreams",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "epic_fish_adventure": {
        name: "Epic Fish Adventure",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "epic_fish_marlin_madness": {
        name: "Epic Fish Marlin Madness",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "epic_fish_net_of_fortune": {
        name: "Epic Fish Net of Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "epic_hellas": {
        name: "Epic Hellas",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "epic_joker": {
        name: "Epic Joker",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "erik_the_red": {
        name: "Erik the Red",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "escape_the_pyramid_fire_and_ice": {
        name: "Escape the Pyramid Fire and Ice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "esqueleto_explosivo": {
        name: "Esqueleto Explosivo",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "esqueleto_explosivo_2": {
        name: "Esqueleto Explosivo 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "esqueleto_explosivo_2_reborn": {
        name: "Esqueleto Explosivo 2 Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "esqueleto_explosivo_3": {
        name: "Esqueleto Explosivo 3",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "eternal_dawn": {
        name: "Eternal Dawn",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "eternal_duel": {
        name: "Eternal Duel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eternal_dusk": {
        name: "Eternal Dusk",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "eternal_empress_freeze_time": {
        name: "Eternal Empress - Freeze Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "eternal_phoenix_megaways": {
        name: "Eternal Phoenix Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "everest_avalanche": {
        name: "Everest Avalanche",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "everplay_blackjack": {
        name: "Everplay Blackjack",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "evil_devil": {
        name: "Evil Devil",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "evil_eyes": {
        name: "Evil Eyes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "excalibur_unleashed": {
        name: "Excalibur Unleashed",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "expanding_fireworks": {
        name: "Expanding Fireworks",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "explodiac": {
        name: "Explodiac",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "express_200_scratch": {
        name: "Express 200 Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "extra_bingo": {
        name: "Extra Bingo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "extra_juicy": {
        name: "Extra juicy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "extra_juicy_megaways": {
        name: "Extra Juicy MEGAWAYS",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "extreme_pay": {
        name: "Extreme Pay",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "eye_of_atum": {
        name: "Eye of Atum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "eye_of_cleopatra": {
        name: "Eye of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "eye_of_gods": {
        name: "Eye of Gods",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "eye_of_horus_megaways": {
        name: "Eye of Horus Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eye_of_horus_rise_of_egypt": {
        name: "Eye of Horus Rise of Egypt",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eye_of_horus_tablets_of_destiny": {
        name: "Eye of Horus Tablets of Destiny",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "eye_of_medusa": {
        name: "Eye of Medusa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eye_of_spartacus": {
        name: "Eye of Spartacus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "eye_of_the_kraken": {
        name: "Eye of the Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "eye_of_the_panda": {
        name: "Eye of the Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "eye_of_the_storm": {
        name: "Eye of the Storm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fa_cai_shen": {
        name: "Fa Cai Shen",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fa_cai_shen_deluxe": {
        name: "Fa Cai Shen Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "face_off": {
        name: "Face Off",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fairy_gate": {
        name: "Fairy Gate",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "fairytale_fortune": {
        name: "Fairytale Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fancy_fruits": {
        name: "Fancy Fruits",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_deluxe": {
        name: "Fancy Fruits Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_flaming_link": {
        name: "Fancy Fruits Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fancy_fruits_respins_of_amunre": {
        name: "Fancy Fruits Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fangs_and_fire": {
        name: "Fangs and Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fangs_inferno": {
        name: "Fang's Inferno",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "fangtastic_freespins": {
        name: "Fangtastic Freespins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "farm_frenzy": {
        name: "Farm Frenzy",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "farming_frenzy": {
        name: "Farming Frenzy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fashion_tv_blackjack": {
        name: "Fashion TV Blackjack",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "fat_frankies": {
        name: "Fat Frankies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fat_panda": {
        name: "Fat Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fat_stacks_miami_cash": {
        name: "Fat Stacks Miami Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fate_of_dead_blitzways": {
        name: "Fate of Dead Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fatzs_diner": {
        name: "Fatz's Diner",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "favela_boyz": {
        name: "Favela Boyz",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fawkes": {
        name: "Fawkes",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "fear_the_dark": {
        name: "Fear the Dark",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "feasting_fox": {
        name: "Feasting Fox",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "feather_fury": {
        name: "Feather Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "feeding_fury": {
        name: "Feeding Fury",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "feel_the_beat": {
        name: "Feel The Beat",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "feline_fury": {
        name: "Feline Fury",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "feng_fu": {
        name: "Feng Fu",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "fenghuang": {
        name: "Fenghuang",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fengs_fortune": {
        name: "Feng’s Fortune",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fenix_play": {
        name: "Fenix Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fenix_play_27": {
        name: "Fenix Play 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fenix_play_27_deluxe": {
        name: "Fenix Play 27 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fenix_play_deluxe": {
        name: "Fenix Play Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fields_of_clover": {
        name: "Fields of clover",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "fiesta_clusters": {
        name: "Fiesta Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fiesta_fortune": {
        name: "Fiesta Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fighter_pit": {
        name: "Fighter Pit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "finger_lickn_free_spins": {
        name: "Finger Lick'n Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fins_of_fortune": {
        name: "Fins of Fortune",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "fionas_christmas_fortune": {
        name: "Fiona's Christmas Fortune",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fire_88": {
        name: "Fire 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_and_diamond_jingle_joker": {
        name: "Fire and Diamond Jingle Joker",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fire_and_diamond_joker": {
        name: "Fire and Diamond Joker",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fire_and_roses_joker": {
        name: "Fire and Roses : Joker",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fire_and_roses_jolly_joker": {
        name: "Fire and Roses Jolly Joker",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fire_archer": {
        name: "Fire Archer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_bird": {
        name: "Fire Bird",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fire_dragon": {
        name: "Fire dragon",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fire_forge": {
        name: "Fire Forge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fire_hot_100": {
        name: "Fire Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_20": {
        name: "Fire Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_40": {
        name: "Fire Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_hot_5": {
        name: "Fire Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_joker": {
        name: "Fire Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_joker_100": {
        name: "Fire Joker 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_joker_blitz": {
        name: "Fire Joker Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_joker_freeze": {
        name: "Fire Joker Freeze",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_lightning": {
        name: "Fire Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fire_my_laser": {
        name: "Fire my Laser",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "fire_portals": {
        name: "Fire Portals",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_rooster": {
        name: "Fire Rooster",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fire_stampede": {
        name: "Fire Stampede",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_stampede_2": {
        name: "Fire Stampede 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_stampede_ultimate": {
        name: "Fire Stampede Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_strike": {
        name: "Fire Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_strike_2": {
        name: "Fire Strike 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fire_toad": {
        name: "Fire Toad",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fire_toad_2": {
        name: "Fire Toad 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "firebird_spirit_connect_and_collect": {
        name: "Firebird Spirit - Connect & Collect",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "firefly_frenzy": {
        name: "Firefly Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "firekick_multimax": {
        name: "Firekick! Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "firenhot": {
        name: "Fire'n'Hot",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "firewins_factory": {
        name: "FireWins Factory",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "fish_em_up": {
        name: "Fish Em Up",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fish_eye": {
        name: "Fish Eye",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fish_tales_colossal_catch_link_and_loot": {
        name: "Fish Tales Colossal Catch Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_double_catch": {
        name: "Fish Tales Double Catch",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_halloween": {
        name: "Fish Tales Halloween",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_monster_bass": {
        name: "Fish Tales Monster Bass",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fish_tales_monster_bass_10000": {
        name: "Fish Tales Monster Bass 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fishin_bigger_pots_of_gold": {
        name: "Fishin' Bigger Pots of Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fishin_christmas_pots_of_gold": {
        name: "Fishin' Christmas Pots of Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fishin_frenzy_big_catch_megaways": {
        name: "Fishin Frenzy Big Catch Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_frenzy_megaways": {
        name: "Fishin' Frenzy Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_frenzy_power_4_slots": {
        name: "Fishin Frenzy Power 4 Slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fishin_pots_of_gold": {
        name: "Fishin' Pots of Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fishin_pots_of_gold_gold_blitz": {
        name: "Fishin' Pots of Gold Gold Blitz",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fishin_reels": {
        name: "Fishin Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fishing_club": {
        name: "Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fishing_club_2": {
        name: "Fishing Club 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fishing_time": {
        name: "Fishing Time",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fist_of_destruction": {
        name: "Fist Of Destruction",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "flame_busters": {
        name: "Flame Busters",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "flaming_chillies": {
        name: "Flaming Chillies",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "flaming_fruit": {
        name: "Flaming Fruit",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "flirting_scholar": {
        name: "Flirting Scholar",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "floating_dragon": {
        name: "Floating Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_dragon_boat_festival": {
        name: "Floating Dragon - Dragon Boat Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_megaways": {
        name: "Floating Dragon Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_new_year_festival_ultra_megaways": {
        name: "Floating Dragon New Year Festival Ultra Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_wild_horses": {
        name: "Floating Dragon Wild Horses",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "floating_dragon_year_of_the_snake": {
        name: "Floating Dragon Year of the Snake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "florageddon": {
        name: "Florageddon",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "floridaman": {
        name: "Floridaman",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "flower_fortunes_supreme": {
        name: "Flower Fortunes Supreme",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "flux": {
        name: "Flux",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "fluxberry": {
        name: "Fluxberry",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "fly": {
        name: "Fly!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fly_x": {
        name: "Fly X",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "flying_high": {
        name: "Flying High",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "flyx_cash_turbo": {
        name: "Flyx Cash Turbo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "fonzos_feline_fortunes": {
        name: "Fonzo’s Feline Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "football_3x3": {
        name: "Football 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "football_blitz_top_card": {
        name: "Football Blitz Top Card",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "football_glory": {
        name: "Football Glory",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "football_hold_and_blitz": {
        name: "Football Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "football_hooligans": {
        name: "Football Hooligans",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "football_mania": {
        name: "Football Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "football_mania_deluxe": {
        name: "Football Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "football_scratch": {
        name: "Football Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "football_star": {
        name: "Football Star",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "football_star_deluxe": {
        name: "Football Star Deluxe",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "football_super_spins": {
        name: "Football Super Spins",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "forbidden_alchemy": {
        name: "Forbidden Alchemy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "forbidden_temple_power_hit": {
        name: "Forbidden Temple Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "forest_fortune": {
        name: "Forest Fortune",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "forge_of_fortunes": {
        name: "Forge of Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "forge_of_gems": {
        name: "Forge of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "forge_of_olympus": {
        name: "Forge of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "forge_of_the_gods": {
        name: "Forge of the Gods",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "forge_of_wealth": {
        name: "Forge of Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "forging_wilds": {
        name: "Forging Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "forgotten": {
        name: "Forgotten",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fort_brave": {
        name: "Fort Brave",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fortuna_trueways": {
        name: "Fortuna TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_ace": {
        name: "Fortune Ace",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_ace_scatter": {
        name: "Fortune Ace Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_and_finery": {
        name: "Fortune & Finery",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fortune_babies": {
        name: "Fortune Babies",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "fortune_babies_harmony": {
        name: "Fortune Babies Harmony",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "fortune_bells": {
        name: "Fortune Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_dogs": {
        name: "Fortune Dogs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fortune_dragon": {
        name: "Fortune Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_dragon_joy": {
        name: "Fortune Dragon Joy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fortune_gods": {
        name: "Fortune Gods",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_hitn_roll": {
        name: "Fortune Hit’n Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_horse": {
        name: "Fortune Horse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_llama": {
        name: "Fortune Llama",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fortune_mouse": {
        name: "Fortune Mouse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_of_giza": {
        name: "Fortune of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_of_olympus": {
        name: "Fortune of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortune_ox": {
        name: "Fortune Ox",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_pandas": {
        name: "Fortune Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "fortune_paw": {
        name: "Fortune Paw",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fortune_rabbit": {
        name: "Fortune Rabbit",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_red_packets": {
        name: "Fortune Red Packets",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_reels": {
        name: "Fortune Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fortune_rewind": {
        name: "Fortune Rewind",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fortune_roulette": {
        name: "Fortune Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "fortune_snake": {
        name: "Fortune Snake",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortune_spin": {
        name: "Fortune Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fortune_teller": {
        name: "Fortune Teller",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fortune_tiger": {
        name: "Fortune Tiger",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fortunes_of_ali_baba": {
        name: "Fortunes of Ali Baba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fortunes_of_aztec": {
        name: "Fortunes of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fortunium": {
        name: "Fortunium",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "forty_fruity_million": {
        name: "Forty Fruity Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "four_divine_beasts": {
        name: "Four Divine Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "four_lucky_clover": {
        name: "Four Lucky Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "four_lucky_diamonds": {
        name: "Four Lucky Diamonds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fox_mayhem": {
        name: "Fox Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "frankenstein": {
        name: "Frankenstein",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "frankensteins_fortune": {
        name: "Frankenstein's Fortune",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "franks_diner": {
        name: "Frank's Diner",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "franks_farm": {
        name: "Frank's Farm",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "frednfire": {
        name: "Fred-Nfire",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "freds_food_truck": {
        name: "Fred's Food Truck",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "free_bet_blackjack_fiesta": {
        name: "Free Bet BlackJack Fiesta",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "free_reelin_joker": {
        name: "Free Reelin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "free_reelin_joker_1000": {
        name: "Free Reelin Joker 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "frenzy_clusters": {
        name: "Frenzy Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "frequent_flyer": {
        name: "Frequent Flyer",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "frightening_frankie": {
        name: "Frightening Frankie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "frkn_bananas": {
        name: "FRKN Bananas",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "frog_grog": {
        name: "Frog Grog",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "frogs_and_bugs": {
        name: "Frogs & Bugs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "frogs_scratch": {
        name: "Frogs Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "front_runner_odds_on": {
        name: "Front Runner Odds On",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "frontier_fortunes": {
        name: "Frontier Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "frooty_troupe_gold_club": {
        name: "Frooty Troupe Gold Club",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "frooty_troupe_sun_splash": {
        name: "Frooty Troupe Sun Splash",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "frost_queen_jackpots": {
        name: "Frost Queen Jackpots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "frozen_age": {
        name: "Frozen Age",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "frozen_fruit": {
        name: "Frozen Fruit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "frozen_gems": {
        name: "Frozen Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "frozen_queen": {
        name: "Frozen Queen",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "frozen_tropics": {
        name: "Frozen Tropics",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_candy": {
        name: "Fruit Candy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "fruit_duel": {
        name: "Fruit Duel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "fruit_fiesta": {
        name: "Fruit Fiesta",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fruit_heaven_hold_and_win": {
        name: "Fruit Heaven Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "fruit_lightning": {
        name: "Fruit Lightning",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruit_lightning_3x5": {
        name: "Fruit Lightning 3x5",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruit_lines": {
        name: "Fruit Lines",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "fruit_lines_winter": {
        name: "Fruit Lines Winter",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "fruit_love": {
        name: "Fruit Love",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_mania": {
        name: "Fruit Mania",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_mania_deluxe": {
        name: "Fruit Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fruit_million": {
        name: "Fruit Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "fruit_party": {
        name: "Fruit Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_party_2": {
        name: "Fruit Party 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_rainbow": {
        name: "Fruit Rainbow",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fruit_rush": {
        name: "Fruit Rush",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "fruit_smash": {
        name: "Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "fruit_snapz": {
        name: "Fruit Snapz",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "fruit_warp": {
        name: "Fruit Warp",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "fruitillionaire": {
        name: "Fruitillionaire",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "fruitoids": {
        name: "Fruitoids",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "fruitopolis_fortune_play": {
        name: "Fruitopolis Fortune Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "fruits_and_jokers_100_lines": {
        name: "Fruits & Jokers: 100 lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "fruits_and_jokers_20_lines": {
        name: "Fruits & Jokers: 20 lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "fruits_and_jokers_40_lines": {
        name: "Fruits & Jokers: 40 lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "fruits_go_bananas": {
        name: "Fruits Go Bananas",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "fruits_go_pop": {
        name: "Fruits Go Pop!",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "fruity_3x3": {
        name: "Fruity 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "fruity_halloween": {
        name: "Fruity Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fruity_hold_and_blitz": {
        name: "Fruity Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruity_mayan": {
        name: "Fruity Mayan",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "fruity_megaways": {
        name: "Fruity Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "fruity_treats": {
        name: "Fruity Treats",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "frutopia": {
        name: "Frutopia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "fu_er_dai": {
        name: "Fu Er Dai",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "fu_fu_fu": {
        name: "Fu Fu Fu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "full_moon_fever": {
        name: "Full Moon Fever",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "full_moon_romance": {
        name: "Full Moon Romance",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "fulong_88": {
        name: "Fulong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "funky_buddha": {
        name: "Funky Buddha",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "funky_fortunez": {
        name: "Funky Fortunez",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "furry_bonanza_megaways": {
        name: "Furry Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fury_of_anubis": {
        name: "Fury of Anubis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "fury_of_odin_megaways": {
        name: "Fury of Odin Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "futebol_fever": {
        name: "Futebol Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "galactic_cash": {
        name: "Galactic Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "galactic_gems": {
        name: "Galactic Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gallo_gold_brunos_megaways": {
        name: "Gallo Gold Bruno's Megaways",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "gamblelicious_hold_and_win": {
        name: "Gamblelicious Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "game_of_gladiators": {
        name: "Game of Gladiators",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "game_of_gladiators_uprising": {
        name: "Game of Gladiators Uprising",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "game_show_lobby": {
        name: "Game Show Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "ganesha_fortune": {
        name: "Ganesha Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ganesha_gold": {
        name: "Ganesha Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gangsters": {
        name: "Gangsters",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "gangsterz": {
        name: "Gangsterz",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gargantoonz": {
        name: "Gargantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "garuda_gems": {
        name: "Garuda Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gates_of_asgard_power_combo": {
        name: "Gates of Asgard Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "gates_of_aztec": {
        name: "Gates of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_gatot_kaca": {
        name: "Gates of Gatot Kaca",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_gatot_kaca_1000": {
        name: "Gates of Gatot Kaca 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_gatot_kaca_super_scatter": {
        name: "Gates of Gatot Kaca Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_hades": {
        name: "Gates of Hades",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus": {
        name: "Gates of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_1000": {
        name: "Gates of Olympus 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_roulette": {
        name: "Gates of Olympus Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "gates_of_olympus_super_scatter": {
        name: "Gates of Olympus Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_olympus_xmas_1000": {
        name: "Gates of Olympus Xmas 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gates_of_persia": {
        name: "Gates of Persia",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gates_of_power": {
        name: "Gates of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gates_of_troy": {
        name: "Gates of Troy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gates_of_valhalla": {
        name: "Gates of Valhalla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gator_gold_deluxe_gigablox": {
        name: "Gator Gold Deluxe Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "gator_gold_gigablox": {
        name: "Gator Gold Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "gatot_kacas_fury": {
        name: "Gatot Kaca's Fury",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gatsby_gold_booster_bar": {
        name: "Gatsby Gold Booster Bar",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "gears_of_horus": {
        name: "Gears of Horus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "geishas_fan": {
        name: "Geisha's Fan",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "geishas_revenge": {
        name: "Geisha's Revenge",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_elevator": {
        name: "Gem Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gem_fire_fortune": {
        name: "Gem Fire Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gem_rocks": {
        name: "Gem Rocks",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "gem_rush": {
        name: "Gem Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "gem_saviour": {
        name: "Gem Saviour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_saviour_conquest": {
        name: "Gem Saviour Conquest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_saviour_sword": {
        name: "Gem Saviour Sword",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gem_splitter": {
        name: "Gem Splitter",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "gem_trio": {
        name: "Gem Trio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gemhalla": {
        name: "Gemhalla",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gemhalla_xtreme": {
        name: "Gemhalla Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gemix": {
        name: "Gemix",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gemix_100": {
        name: "Gemix 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gemix_2": {
        name: "Gemix 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gempops": {
        name: "GemPOPs",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "gems_bonanza": {
        name: "Gems Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gemstone_jam": {
        name: "Gemstone Jam",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "gemstones_gold": {
        name: "Gemstones Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "gemza": {
        name: "Gemza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "genie_jackpot_combo_frenzy": {
        name: "Genie Jackpot Combo Frenzy",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "genie_jackpots_wishmaker": {
        name: "Genie Jackpots Wishmaker",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "genies_3_wishes": {
        name: "Genie's 3 Wishes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "genies_gem_bonanza": {
        name: "Genie's Gem Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "genies_magic_wishes": {
        name: "Genie's Magic Wishes",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "genies_touch": {
        name: "Genies Touch",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "gerards_gambit": {
        name: "Gerard's Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "german_roulette": {
        name: "German Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "get_the_cheese": {
        name: "Get the CHEESE",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "ghost_father": {
        name: "Ghost Father",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "ghost_glyph": {
        name: "Ghost Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ghost_of_dead": {
        name: "Ghost of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ghostfather_awakened": {
        name: "Ghostfather Awakened",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "giant_king": {
        name: "Giant King",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "giants_and_sheep": {
        name: "Giants and Sheep",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "gift_rush": {
        name: "Gift Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "giga_zombies_giga_blox": {
        name: "Giga Zombies Giga Blox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "giganimals_gigablox": {
        name: "Giganimals Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "gigantoonz": {
        name: "Gigantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ginger_wins_wild_jungle": {
        name: "Ginger Wins: Wild Jungle",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "gingerbread_joy": {
        name: "Gingerbread Joy",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "give_me_the_money": {
        name: "Give Me The Money",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "giza_nights_hold_and_win": {
        name: "Giza Nights: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "gizas_portals": {
        name: "Giza's Portals",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "gladiator_legends": {
        name: "Gladiator Legends",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "gladiators_glory": {
        name: "Gladiator's Glory",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "glam_rock": {
        name: "Glam Rock",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "glamorous_times": {
        name: "Glamorous Times",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "gloria_invicta": {
        name: "Gloria Invicta",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "glory_of_rome": {
        name: "Glory Of Rome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "glyph_of_gods": {
        name: "Glyph of Gods",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "gnawn_gold": {
        name: "Gnaw'n Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gnomes_and_giants": {
        name: "Gnomes and Giants",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "go_fishing_reelin_fortunes": {
        name: "Go Fishing Reelin Fortunes",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "go_panda": {
        name: "Go Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "goal_blitz": {
        name: "Goal Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "goals_to_glory_football_fever": {
        name: "Goals to Glory Football Fever",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "goblin_brew": {
        name: "Goblin Brew",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "goblin_heist_powernudge": {
        name: "Goblin Heist Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "god_of_wealth_hold_and_win": {
        name: "God of Wealth Hold And Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gods_and_pyramids_power_combo": {
        name: "Gods and Pyramids Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "gods_gone_wild": {
        name: "Gods Gone Wild",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "gods_of_asgard_megaways": {
        name: "Gods Of Asgard Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_of_giza": {
        name: "Gods of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gods_of_glory": {
        name: "Gods of Glory",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "gods_of_olympus_3_megaways": {
        name: "Gods Of Olympus 3 Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_of_olympus_ii": {
        name: "Gods of Olympus II",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_of_olympus_iv": {
        name: "Gods of Olympus IV",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gods_of_rock": {
        name: "Gods of Rock!",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "gods_of_rock_reborn": {
        name: "Gods of Rock! Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "gold_and_glamour_hold_and_win": {
        name: "Gold and Glamour Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_blitz": {
        name: "Gold Blitz",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "gold_blitz_extreme": {
        name: "Gold Blitz Extreme",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "gold_coins": {
        name: "Gold Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "gold_frontier_jackpots_fastpot5": {
        name: "Gold frontier Jackpots FastPot5",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "gold_gold_gold": {
        name: "Gold Gold Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_gold_gold_5000": {
        name: "Gold Gold Gold 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_gold_gold_hold_and_win": {
        name: "Gold Gold Gold Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "gold_infinity": {
        name: "Gold Infinity",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "gold_king": {
        name: "Gold King",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_magnate": {
        name: "Gold Magnate",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gold_oasis": {
        name: "Gold Oasis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_of_fortune_god": {
        name: "Gold of Fortune God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_of_minos": {
        name: "Gold of Minos",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gold_party": {
        name: "Gold Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_party_2_after_hours": {
        name: "Gold Party 2 After Hours",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_rush": {
        name: "Gold Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_rush_with_johnny_cash": {
        name: "Gold Rush with Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "gold_strike": {
        name: "Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_strike_2": {
        name: "Gold Strike 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_strike_bonanza": {
        name: "Gold Strike Bonanza",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_strike_express": {
        name: "Gold Strike Express",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gold_train": {
        name: "Gold Train",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gold_trophy_2": {
        name: "Gold Trophy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_volcano": {
        name: "Gold Volcano",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gold_x": {
        name: "Gold X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "golden_avalanche": {
        name: "Golden Avalanche",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_avalon_hold_and_win": {
        name: "Golden Avalon Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_caravan": {
        name: "Golden Caravan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_castle_titanways": {
        name: "Golden Castle TitanWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "golden_cat_fortunes": {
        name: "Golden Cat Fortunes",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "golden_colts": {
        name: "Golden Colts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_egg_of_crazy_chicken": {
        name: "Golden Egg of Crazy Chicken",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "golden_fish_tank": {
        name: "Golden Fish Tank",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "golden_fish_tank_2_gigablox": {
        name: "Golden Fish Tank 2 Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "golden_fish_tank_party": {
        name: "Golden Fish Tank Party",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "golden_fishtank": {
        name: "Golden Fishtank",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "golden_gals": {
        name: "Golden Gal's",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_gals_3_reels": {
        name: "Golden Gal's 3 Reels",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_gals_cash_towers": {
        name: "Golden Gal's Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_glyph": {
        name: "Golden Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "golden_glyph_2": {
        name: "Golden Glyph 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "golden_glyph_3": {
        name: "Golden Glyph 3",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "golden_gorgon": {
        name: "Golden Gorgon",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "golden_horn": {
        name: "Golden Horn",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "golden_legend": {
        name: "Golden Legend",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_osiris": {
        name: "Golden Osiris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_ox": {
        name: "Golden Ox",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "golden_paw_hold_and_win": {
        name: "Golden Paw Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_pig": {
        name: "Golden Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "golden_pinata_hold_and_win": {
        name: "Golden Pinata Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_pride": {
        name: "Golden Pride",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "golden_scrolls": {
        name: "Golden Scrolls",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "golden_sphinx": {
        name: "Golden Sphinx",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "golden_taj_mahal": {
        name: "Golden Taj Mahal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "golden_ticket": {
        name: "Golden Ticket",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_ticket_2": {
        name: "Golden Ticket 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "golden_touch": {
        name: "Golden Touch",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "golden_triad": {
        name: "Golden Triad",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "golden_unicorn": {
        name: "Golden Unicorn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "golden_unicorn_deluxe": {
        name: "Golden Unicorn Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "goldilocks": {
        name: "Goldilocks",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "goldstar_express": {
        name: "Goldstar Express",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "goldwins": {
        name: "GoldWins",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "golfing_glory": {
        name: "Golfing Glory",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "good_luck_40": {
        name: "Good Luck 40",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "good_luck_and_good_fortune": {
        name: "Good Luck & Good Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "gorilla_gold_megaways_power_4_slots": {
        name: "Gorilla Gold Megaways: Power 4 slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "gorilla_mayhem": {
        name: "Gorilla Mayhem",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "grace_of_ebisu": {
        name: "Grace of Ebisu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "graffiti_rush": {
        name: "Graffiti Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "grand_ahoy": {
        name: "Grand Ahoy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "grand_buffalo_hold_and_win": {
        name: "Grand Buffalo Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "grand_casino_heist": {
        name: "Grand Casino Heist",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "grand_melee": {
        name: "Grand Melee",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "grand_mustang": {
        name: "Grand Mustang",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "grand_patron": {
        name: "Grand Patron",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "grannys_wild": {
        name: "Granny's Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "gravity_bonanza": {
        name: "Gravity Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_book_of_magic": {
        name: "Great Book Of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "great_book_of_magic_deluxe": {
        name: "Great Book Of Magic Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "great_game_rockies": {
        name: "Great Game Rockies",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "great_ghosts": {
        name: "Great Ghosts!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_grizzly": {
        name: "Great Grizzly",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "great_lagoon": {
        name: "Great Lagoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_reef": {
        name: "Great Reef",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_rhino": {
        name: "Great Rhino",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_rhino_deluxe": {
        name: "Great Rhino Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_rhino_megaways": {
        name: "Great Rhino Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "great_warrior": {
        name: "Great Warrior",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "greedy_alice": {
        name: "Greedy Alice",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "greedy_for_gold_hold_and_win": {
        name: "Greedy for Gold: Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "greedy_for_gold_power_hit": {
        name: "Greedy for Gold Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "greedy_fortune_pig": {
        name: "Greedy Fortune Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "greedy_wolf": {
        name: "Greedy Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "greek_gods": {
        name: "Greek Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "greek_legends": {
        name: "Greek Legends",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "grim_muerto": {
        name: "Grim Muerto",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "grimms_bounty_hanset_and_gretel": {
        name: "Grimms Bounty Hanset and Gretel",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "grizzly_strike": {
        name: "Grizzly Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "grizzly_strike_lucky_cache": {
        name: "Grizzly Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "gronks_gems": {
        name: "Gronk's Gems",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "guardian_of_athens": {
        name: "Guardian Of Athens",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "guardians_of_ice_and_fire": {
        name: "Guardians of Ice and Fire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "guitar_quest": {
        name: "Guitar Quest",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "gun_powder": {
        name: "Gun Powder",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "hades": {
        name: "Hades",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "hades_lost_treasures": {
        name: "Hades Lost Treasures",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "hades_river_of_souls": {
        name: "Hades: River of Souls",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "hall_of_the_mountain_king": {
        name: "Hall of the Mountain King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "halloween_bonanza": {
        name: "Halloween Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "halloween_horrors_megaways": {
        name: "Halloween Horrors Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "hammer_of_gods": {
        name: "Hammer of Gods",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "hammer_of_vulcan": {
        name: "Hammer of Vulcan",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "hammerstorm": {
        name: "Hammerstorm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hand_of_anubis": {
        name: "Hand of Anubis",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hand_of_midas_2": {
        name: "Hand of Midas 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hanzos_dojo": {
        name: "Hanzo's Dojo",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "happiest_christmas_tree": {
        name: "Happiest Christmas Tree",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "happy_ape": {
        name: "Happy Ape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "happy_halloween": {
        name: "Happy Halloween",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "happy_hatchlings": {
        name: "Happy Hatchlings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "happy_lucky_cats": {
        name: "Happy Lucky Cats",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "happy_scratch": {
        name: "Happy Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hard_cash": {
        name: "Hard Cash",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "hard_eight_poker": {
        name: "Hard Eight Poker",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "harvest_wilds": {
        name: "Harvest Wilds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hatching_gold_roosters_riches": {
        name: "Hatching Gold Rooster's Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "haunted_crypt": {
        name: "Haunted Crypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "haunted_harbor": {
        name: "Haunted Harbor",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "haunted_hospital": {
        name: "Haunted Hospital",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "haunted_house": {
        name: "Haunted House",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "haunted_reels": {
        name: "Haunted Reels",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hawaii_fever": {
        name: "Hawaii Fever",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hawaiian_diva": {
        name: "Hawaiian Diva",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream": {
        name: "Hawaiian Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream_gold": {
        name: "Hawaiian Dream GOLD",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream_jackpot": {
        name: "Hawaiian Dream Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_dream_xmas": {
        name: "Hawaiian Dream Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hawaiian_tiki": {
        name: "Hawaiian Tiki",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hazakura_ways": {
        name: "Hazakura Ways",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "heads_and_tails": {
        name: "Heads and Tails",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "heads_and_tails_xy": {
        name: "Heads And Tails XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "heart_of_cleopatra": {
        name: "Heart of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heart_of_rio": {
        name: "Heart of Rio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heart_of_tiki": {
        name: "Heart of Tiki",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "heartbreakers": {
        name: "Heartbreakers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heavenly_elephant_fortune": {
        name: "Heavenly Elephant Fortune",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "heist_for_the_golden_nuggets": {
        name: "Heist for the Golden Nuggets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heist_stakes": {
        name: "Heist Stakes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "heliopopolis": {
        name: "HelioPOPolis",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "helios_fury": {
        name: "Helios' Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hell_butcher": {
        name: "Hell Butcher",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hellapenos": {
        name: "Hellapenos",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "hellcatraz": {
        name: "Hellcatraz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hellfire": {
        name: "Hellfire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "hellvis_wild": {
        name: "Hellvis Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hercules_and_pegasus": {
        name: "Hercules and Pegasus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hercules_son_of_zeus": {
        name: "Hercules Son of Zeus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "heroes_gathering": {
        name: "Heroes' Gathering",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "heroes_hunt_2": {
        name: "Heroes Hunt 2",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "heroes_hunt_megaways": {
        name: "Heroes Hunt MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "heroic_spins": {
        name: "Heroic Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hex": {
        name: "Hex",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hey_sushi": {
        name: "Hey Sushi",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hidden_valley_120": {
        name: "Hidden Valley 120",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "high_flyer": {
        name: "High Flyer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "high_street_heist": {
        name: "High Street Heist",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "highschool_manga": {
        name: "Highschool Manga",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "highway_legends": {
        name: "Highway Legends",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "highway_to_hell": {
        name: "Highway to Hell",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "highway_to_hell_deluxe": {
        name: "Highway to Hell Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hikaru_super_live_bazooka": {
        name: "Hikaru Super Live BAZOOKA",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "hilo": {
        name: "Hilo",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "hilo_baccarat": {
        name: "Hi-Lo Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "himalayan_wild": {
        name: "Himalayan Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hip_hop_panda": {
        name: "Hip Hop Panda",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hiphop_pop": {
        name: "Hip-Hop Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "hippo_pop": {
        name: "Hippo Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "hit_the_bank_hold_and_win": {
        name: "Hit the Bank: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "hit_the_route": {
        name: "Hit The Route",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hockey_attack": {
        name: "Hockey Attack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hokkaido_wolf": {
        name: "Hokkaido Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "holiday_ride": {
        name: "Holiday Ride",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "holiday_season": {
        name: "Holiday Season",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "holiday_spirits": {
        name: "Holiday Spirits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "holly": {
        name: "Holly",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "holly_jolly_bonanza": {
        name: "Holly Jolly Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "holly_jolly_bonanza_2": {
        name: "Holly Jolly Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "holly_jolly_cash_pig": {
        name: "Holly Jolly Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "holmes_and_the_stolen_stones": {
        name: "Holmes and the Stolen Stones",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "honey_honey_honey": {
        name: "Honey Honey Honey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "honey_rush": {
        name: "Honey Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "honey_rush_100": {
        name: "Honey Rush 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "honey_rush_black_and_yellow": {
        name: "Honey Rush Black and Yellow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "honey_trap_of_diao_chan": {
        name: "Honey Trap of Diao Chan",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "honeylocks_pots": {
        name: "Honeylocks Pots",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "hood_vs_wolf": {
        name: "Hood vs Wolf",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hook_the_fortune": {
        name: "Hook the Fortune",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hooligan_hustle": {
        name: "Hooligan Hustle",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "hope_unleashed_fortune_reels": {
        name: "Hope Unleashed Fortune Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "horror_hotel": {
        name: "Horror Hotel",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "horses_treasure": {
        name: "Horse's Treasure",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "hot_777": {
        name: "Hot 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_777_deluxe": {
        name: "Hot 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_blizzard": {
        name: "Hot Blizzard",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hot_blizzard_deluxe": {
        name: "Hot Blizzard Deluxe",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hot_burning_wins": {
        name: "Hot Burning Wins",
        provider: "Playson",
        providerSlug: "playson"
    },
    "hot_charge": {
        name: "Hot Charge",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "hot_chilli": {
        name: "Hot Chilli",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_chilli_bells": {
        name: "Hot Chilli Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hot_chilli_bells_100": {
        name: "Hot Chilli Bells 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hot_coins_hold_and_win": {
        name: "Hot Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "hot_dog_heist": {
        name: "Hot Dog Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "hot_fiesta": {
        name: "Hot Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_heads": {
        name: "Hot Heads",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "hot_hot_fruit": {
        name: "Hot Hot Fruit",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hot_hot_halloween": {
        name: "Hot Hot Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hot_hot_summer": {
        name: "Hot Hot Summer",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hot_joker_fruits_20": {
        name: "Hot Joker Fruits 20",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "hot_party": {
        name: "Hot Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_party_deluxe": {
        name: "Hot Party Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_pepper": {
        name: "Hot Pepper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_potato": {
        name: "Hot Potato",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "hot_rocket_5x_3x_2x": {
        name: "Hot Rocket 5x 3x 2x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hot_rod_racers": {
        name: "Hot Rod Racers",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "hot_ross": {
        name: "Hot Ross",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hot_safari": {
        name: "Hot Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_slot_777_cash_out": {
        name: "Hot Slot™: 777 Cash Out",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_extremely_light": {
        name: "Hot Slot™: 777 Cash Out Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_grand_diamond_edition": {
        name: "Hot Slot™: 777 Cash Out Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_grand_gold_edition": {
        name: "Hot Slot™: 777 Cash Out Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_cash_out_grand_platinum_edition": {
        name: "Hot Slot™: 777 Cash Out Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_coins_extremely_light": {
        name: "Hot Slot™: 777 Coins Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_crown": {
        name: "Hot Slot: 777 Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_crown_extremely_light": {
        name: "Hot Slot™: 777 Crown Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_diamond_crown": {
        name: "Hot Slot 777 Diamond Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_gold_crown": {
        name: "Hot Slot 777 Gold Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_hold_the_jackpot": {
        name: "Hot Slot 777 Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_platinum_crown": {
        name: "Hot Slot 777 Platinum Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_rubies": {
        name: "Hot Slot: 777 Rubies",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_rubies_extremely_light": {
        name: "Hot Slot™: 777 Rubies Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_777_stars": {
        name: "Hot Slot: 777 Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_diamond_coins": {
        name: "Hot Slot Diamond Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_gold_coins": {
        name: "Hot Slot Gold Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_great_book_of_magic": {
        name: "Hot Slot™: Great Book Of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_magic_bombs": {
        name: "Hot Slot™: Magic Bombs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_magic_pearls": {
        name: "Hot Slot: Magic Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_slot_mystery_jackpot_joker": {
        name: "Hot Slot™: Mystery Jackpot Joker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hot_sync": {
        name: "Hot Sync",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "hot_to_burn": {
        name: "Hot to Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_7_deadly_free_spins": {
        name: "Hot to Burn – 7 Deadly Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_extreme": {
        name: "Hot To Burn Extreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_hold_and_spin": {
        name: "Hot to Burn Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_to_burn_multiplier": {
        name: "Hot To Burn Multiplier",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_tuna": {
        name: "Hot Tuna",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hot_turkey": {
        name: "Hot Turkey",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "hotel_yetiway": {
        name: "Hotel Yeti-Way",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "hotnfruity": {
        name: "Hot'n'Fruity",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "hotpot": {
        name: "Hotpot",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "hottest_666": {
        name: "Hottest 666",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "hounds_of_hell": {
        name: "Hounds of Hell",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "house_of_doom": {
        name: "House of Doom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "house_of_doom_2_the_crypt": {
        name: "House of Doom 2: The Crypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "howling_for_gold": {
        name: "Howling for Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "howling_wolves_megaways": {
        name: "Howling Wolves MEGAWAYS",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "hundreds_and_thousands": {
        name: "Hundreds and Thousands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "hungry_shark": {
        name: "Hungry Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "hyper_gold": {
        name: "Hyper Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "hyper_hues": {
        name: "Hyper Hues",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hyperburst": {
        name: "Hyperburst",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "ice_joker": {
        name: "Ice Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ice_lobster": {
        name: "Ice Lobster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ice_mint": {
        name: "Ice Mint",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ice_pop_party": {
        name: "Ice Pop Party",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "ice_queen": {
        name: "Ice Queen",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "idol_of_fortune": {
        name: "Idol of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "idol_pop_fever": {
        name: "Idol Pop Fever",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ignite_the_night": {
        name: "Ignite the Night",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "ikusa": {
        name: "Ikusa",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "immersive_roulette_deluxe": {
        name: "Immersive Roulette Deluxe",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "immortails_of_egypt": {
        name: "ImmorTails of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "immortal_5": {
        name: "Immortal 5",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "immortal_desire": {
        name: "Immortal Desire",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "imperial_coins": {
        name: "Imperial Coins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "imperial_fruits_100_lines": {
        name: "Imperial Fruits: 100 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "imperial_fruits_5_lines": {
        name: "Imperial Fruits: 5 lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "imperial_opera": {
        name: "Imperial Opera",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "in_the_forest": {
        name: "In The Forest",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "inca_queen": {
        name: "Inca Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "incan_wonders": {
        name: "Incan Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "incas_treasure": {
        name: "Inca's Treasure",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "incinerator": {
        name: "Incinerator",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "indian_cash_catcher": {
        name: "Indian Cash Catcher",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "indonesian_blackjackx": {
        name: "Indonesian BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "indonesian_roulette": {
        name: "Indonesian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "indonesian_speed_baccarat": {
        name: "Indonesian Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "infective_wild": {
        name: "Infective Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "infernal_fury": {
        name: "Infernal Fury",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "inferno_fortune_instastrike": {
        name: "Inferno Fortune InstaStrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "inferno_fortune_power_hit": {
        name: "Inferno Fortune Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "inferno_joker": {
        name: "Inferno Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "inferno_mayhem": {
        name: "Inferno Mayhem",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "inferno_star": {
        name: "Inferno Star",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "infinity_hero": {
        name: "Infinity Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "infinity_pull": {
        name: "Infinity Pull",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "instant_blitz": {
        name: "Instant Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "invading_vegas": {
        name: "Invading Vegas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "invading_vegas_las_christmas": {
        name: "Invading Vegas: Las Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "invading_vegas_revenge_on_mars": {
        name: "Invading Vegas Revenge on Mars",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "invictus": {
        name: "Invictus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "irish_charms": {
        name: "Irish Charms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "irish_crown": {
        name: "Irish Crown",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "irish_gold": {
        name: "Irish Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "iron_bank": {
        name: "Iron Bank",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "iron_bank_2": {
        name: "Iron Bank 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "iron_girl": {
        name: "Iron Girl",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "isibaya_queens": {
        name: "Isibaya Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "island_ices": {
        name: "Island Ices",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "istanbul_roulette": {
        name: "Istanbul Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "italia_3x3": {
        name: "Italia 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "italian_mega_roulette": {
        name: "Italian Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "itero": {
        name: "ITERO",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "its_bananas": {
        name: "It's Bananas!",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "its_time": {
        name: "It's Time!!",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "ivan_and_the_immortal_king": {
        name: "Ivan and the Immortal King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ivy": {
        name: "Ivy",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "jack": {
        name: "Jack",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "jack_frosts_winter": {
        name: "Jack Frost's Winter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jack_on_hold": {
        name: "Jack on Hold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jack_the_giant_hunter": {
        name: "Jack the Giant Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jack_win": {
        name: "Jack win",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "jackpot_3x3": {
        name: "Jackpot 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "jackpot_blaze": {
        name: "Jackpot Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jackpot_builders": {
        name: "Jackpot Builders",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jackpot_express": {
        name: "Jackpot Express",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "jackpot_hunter": {
        name: "Jackpot Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jackpot_raiders": {
        name: "Jackpot Raiders",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "jacks_ride": {
        name: "Jack's Ride",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jade_butterfly": {
        name: "Jade Butterfly",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jade_magician": {
        name: "Jade Magician",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jaguar_temple": {
        name: "Jaguar Temple",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "jam_bonanza": {
        name: "Jam Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "jane_hunter_and_the_mask_of_montezuma": {
        name: "Jane Hunter and the Mask of Montezuma",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "japanese_mask": {
        name: "Japanese Mask",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "japanese_speed_baccarat": {
        name: "Japanese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "jasmine_dreams": {
        name: "Jasmine Dreams",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jaws_of_justice": {
        name: "Jaws of Justice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "jelly_express": {
        name: "Jelly Express",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jelly_reels": {
        name: "Jelly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jelly_slice": {
        name: "Jelly Slice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "jellycious_doublemax": {
        name: "Jellycious DoubleMax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "jellyfish_flow": {
        name: "Jellyfish Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jellyfish_flow_ultra": {
        name: "Jellyfish Flow Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jesters_bells_bonanza": {
        name: "Jester's Bells Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "jesters_riches": {
        name: "Jester's Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "jesters_wilds": {
        name: "Jesters Wilds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "jetpack_x": {
        name: "Jetpack X",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "jewel_boom_super_drop": {
        name: "Jewel Boom Super Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jewel_box": {
        name: "Jewel Box",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jewel_of_athena": {
        name: "Jewel of Athena",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "jewel_rush": {
        name: "Jewel Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jewelling_diamonds": {
        name: "Jewelling Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "jewels_of_prosperity": {
        name: "Jewels of Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jiggly_cash": {
        name: "Jiggly Cash",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "jin_chans_pond_of_riches": {
        name: "Jin Chan's Pond of Riches",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "jingle_coins_hold_and_win": {
        name: "Jingle Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "jinglepop": {
        name: "JinglePOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "jogo_do_bicho": {
        name: "Jogo Do Bicho",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jogo_do_bicho_simple": {
        name: "Jogo Do Bicho Simple",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "john_hunter_and_galileos_secrets": {
        name: "John Hunter and Galileo's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_book_of_tut": {
        name: "John Hunter and the Book of Tut",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_book_of_tut_megaways": {
        name: "John Hunter and the Book of Tut Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_mayan_gods": {
        name: "John Hunter And The Mayan Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "john_hunter_and_the_tomb_of_the_scarab_queen": {
        name: "John Hunter and the Tomb of the Scarab Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "johnan_legendarian": {
        name: "Johnan Legendarian",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "johnny_cash": {
        name: "Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "joker_bombs": {
        name: "Joker Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "joker_burst_frenzy": {
        name: "Joker Burst Frenzy",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "joker_expand_5_lines": {
        name: "Joker Expand: 5 lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "joker_explosion": {
        name: "Joker Explosion",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "joker_flip": {
        name: "Joker Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "joker_ice_frenzy_epic_strike": {
        name: "Joker Ice Frenzy Epic Strike",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "joker_jewels_dice": {
        name: "Joker Jewels Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "joker_king": {
        name: "Joker King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "joker_queen": {
        name: "Joker Queen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "joker_race": {
        name: "Joker Race",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "joker_reelz": {
        name: "Joker Reelz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "joker_split": {
        name: "Joker Split",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "joker_strike": {
        name: "Joker Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "joker_vs_joker": {
        name: "Joker vs Joker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "joker_x_love": {
        name: "Joker X Love",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jokers_coins_hold_and_win": {
        name: "Joker’s Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "jokers_jewels": {
        name: "Joker's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_cash": {
        name: "Joker's Jewels Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_hold_and_spin": {
        name: "Joker's Jewels Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_hot": {
        name: "Joker’s Jewels Hot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_jewels_wild": {
        name: "Joker’s Jewels Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokers_million": {
        name: "Joker's Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jokers_revenge": {
        name: "Joker's Revenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jokersontop": {
        name: "JokersOnTop",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "jolly_bonus_wins": {
        name: "Jolly Bonus Wins",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "jolly_casino": {
        name: "Jolly casino",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "jolly_roger": {
        name: "Jolly Roger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jolly_roger_2": {
        name: "Jolly Roger 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "jolly_roger_wild_kraken": {
        name: "Jolly Roger Wild Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "journey_to_paris": {
        name: "Journey to Paris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "journey_to_the_wealth": {
        name: "Journey to the Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "journey_to_the_west": {
        name: "Journey to the West",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jugglenaut": {
        name: "Jugglenaut",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "juicy_fruits": {
        name: "Juicy Fruits",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "juicy_fruits_multihold": {
        name: "Juicy Fruits Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "juicy_jester": {
        name: "Juicy Jester",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "juicy_reels": {
        name: "Juicy Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "juicypop": {
        name: "JuicyPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "jumbo_juicy": {
        name: "Jumbo Juicy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "jumbo_safari": {
        name: "Jumbo Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jump": {
        name: "Jump!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jump_2": {
        name: "Jump! 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jumping_fruits": {
        name: "Jumping Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "jungle_books": {
        name: "Jungle Books",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "jungle_delight": {
        name: "Jungle Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jungle_fortune_build_your_bonus": {
        name: "Jungle Fortune Build Your Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "jungle_gorilla": {
        name: "Jungle Gorilla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "jungle_jim_and_the_lost_sphinx": {
        name: "Jungle Jim and the Lost Sphinx",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "jungle_jim_el_dorado": {
        name: "Jungle Jim - El Dorado",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "jungle_pop": {
        name: "Jungle Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "jungle_queen": {
        name: "Jungle Queen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "jungle_rumble": {
        name: "Jungle Rumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "jupiters_choice": {
        name: "Jupiters Choice",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "jurassic_kingdom": {
        name: "Jurassic Kingdom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "jurassic_party": {
        name: "Jurassic Party",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "kaiser": {
        name: "Kaiser",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "kanes_inferno": {
        name: "Kane's Inferno",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "karens_merry_meltdown": {
        name: "Karen's Merry Meltdown",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "keep_em_cool": {
        name: "Keep 'em Cool",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "keepem": {
        name: "Keep'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "keepers_of_the_secret": {
        name: "Keepers Of The Secret",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "keno": {
        name: "Keno",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "keno_live": {
        name: "Keno Live",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "kicker_mania": {
        name: "Kicker Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "kickoff": {
        name: "KickOff",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "kickoff_roulette": {
        name: "Kickoff Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "kill_road_66": {
        name: "Kill Road 66",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "king_and_queen": {
        name: "King & Queen",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "king_carrot": {
        name: "King Carrot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "king_cobra": {
        name: "King Cobra",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "king_colossus": {
        name: "King Colossus",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "king_kong_cash": {
        name: "King Kong Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_dj_prime8": {
        name: "King Kong Cash DJ Prime8",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_even_bigger_bananas": {
        name: "King Kong Cash Even Bigger Bananas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_even_bigger_bananas_2": {
        name: "King Kong Cash Even Bigger Bananas 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_cash_even_bigger_bananas_4": {
        name: "King Kong Cash Even Bigger Bananas 4",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_kong_splash": {
        name: "King Kong Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_of_kings": {
        name: "King of Kings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "king_of_samba": {
        name: "King of Samba",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "king_of_spear": {
        name: "King of Spear",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "king_of_sweets": {
        name: "King of Sweets",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "king_of_the_jungle": {
        name: "King of the Jungle",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "king_of_the_party": {
        name: "King of the Party",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "king_of_the_sky_hit_the_bonus": {
        name: "King of the Sky Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "king_of_the_streets": {
        name: "King of the Streets",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "king_of_the_west": {
        name: "King of the West",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "king_power": {
        name: "King Power",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "king_treasure": {
        name: "King Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "king_tuts_tomb": {
        name: "King Tut's Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "kingdom_below": {
        name: "Kingdom Below",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "kingdom_of_asgard": {
        name: "Kingdom of Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "kingdom_of_the_dead": {
        name: "Kingdom of the Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "kings_and_jewels": {
        name: "Kings & Jewels",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "kings_mask": {
        name: "King's Mask",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "kings_mask_eclipse_of_gods": {
        name: "King’s Mask: Eclipse of Gods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "kings_of_cash": {
        name: "Kings of Cash",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "kittypopins": {
        name: "KittyPOPins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "klowns": {
        name: "Klowns",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "kluster_krystals_megaclusters": {
        name: "Kluster Krystals Megaclusters",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "knight_hot_spotz": {
        name: "Knight Hot Spotz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "knights_vs_barbarians": {
        name: "Knights vs Barbarians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "knockout_football": {
        name: "Knockout Football",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "knockout_football_rush": {
        name: "Knockout Football Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "knockout_riches": {
        name: "Knockout Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "koi_cash": {
        name: "Koi Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "koi_koi_treasure": {
        name: "Koi Koi Treasure",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "koi_pond": {
        name: "Koi Pond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "kokeshi_pop": {
        name: "Kokeshi Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "kong_3_even_bigger_bonus": {
        name: "Kong 3 Even Bigger Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "kong_even_bigger_balls": {
        name: "Kong Even Bigger Balls",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "kong_even_bigger_christmas": {
        name: "Kong Even Bigger Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "kongo_bongo": {
        name: "Kongo Bongo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "kongs_jungle_tower": {
        name: "Kong's Jungle Tower",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "korean_baccarat": {
        name: "Korean Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "korean_blackjackx": {
        name: "Korean BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "korean_roulette": {
        name: "Korean Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "korean_speed_baccarat": {
        name: "Korean Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "krakens_cove": {
        name: "Kraken's Cove",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "krakens_hunger": {
        name: "Kraken's Hunger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "krakens_sky_bounty": {
        name: "Kraken's Sky Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "kung_pao_panda": {
        name: "Kung Pao Panda",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "la_dolce_vita": {
        name: "La Dolce Vita",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_2": {
        name: "La Dolce Vita 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_deluxe": {
        name: "La Dolce Vita Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_dolce_vita_flaming_link": {
        name: "La Dolce Vita Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "la_fiesta": {
        name: "La Fiesta",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "la_tomatina": {
        name: "La Tomatina",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "lab_of_madness": {
        name: "Lab of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "laced": {
        name: "Laced",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "ladies_nite": {
        name: "Ladies Nite",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lady_godiva": {
        name: "Lady Godiva",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lady_lucky_gun": {
        name: "Lady Lucky Gun",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lady_of_fortune": {
        name: "Lady of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lady_of_fortune_destiny_spins": {
        name: "Lady of Fortune Destiny Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lady_of_fortune_remastered": {
        name: "Lady of Fortune Remastered",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lady_wolf_moon": {
        name: "Lady Wolf Moon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lady_wolf_moon_megaways": {
        name: "Lady Wolf Moon Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lamp_of_infinity": {
        name: "Lamp Of Infinity",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "land_of_heroes": {
        name: "Land of Heroes",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "lantern_luck": {
        name: "Lantern Luck",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "lara_croft_temples_and_tombs": {
        name: "Lara Croft - Temples and Tombs",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "larry_the_leprechaun": {
        name: "Larry the Leprechaun",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "last_call": {
        name: "Last Call",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "last_man_standing": {
        name: "Last Man Standing",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "laughing_buddha": {
        name: "Laughing Buddha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "launch_to_riches": {
        name: "Launch to Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lava_balls": {
        name: "Lava Balls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lava_lava": {
        name: "Lava Lava",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "lava_lions": {
        name: "Lava Lions",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "lawn_n_disorder": {
        name: "Lawn N' Disorder",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "le_bandit": {
        name: "Le Bandit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_bunny": {
        name: "Le Bunny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_cowboy": {
        name: "Le Cowboy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_digger": {
        name: "Le Digger",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_fisherman": {
        name: "Le Fisherman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_football_fan": {
        name: "Le Football Fan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_hooligan": {
        name: "Le Hooligan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_king": {
        name: "Le King",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_pharaoh": {
        name: "Le Pharaoh",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_santa": {
        name: "Le Santa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_viking": {
        name: "Le Viking",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "le_zeus": {
        name: "Le Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "legacy_of_dead": {
        name: "Legacy of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_dynasties": {
        name: "Legacy of Dynasties",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_egypt": {
        name: "Legacy of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_gems_blitzways": {
        name: "Legacy of Gems Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_gods_megaways": {
        name: "Legacy of Gods Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "legacy_of_inca": {
        name: "Legacy of Inca",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legacy_of_oz": {
        name: "Legacy of Oz",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "legacy_of_ra_megaways": {
        name: "Legacy Of Ra Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "legacy_of_ramses_book": {
        name: "Legacy of Ramses Book",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "legacy_of_undead_dragon_abyssways": {
        name: "Legacy of Undead Dragon Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legend_of_cleopatra": {
        name: "Legend of Cleopatra",
        provider: "Playson",
        providerSlug: "playson"
    },
    "legend_of_cleopatra_megaways": {
        name: "Legend of Cleopatra Megaways",
        provider: "Playson",
        providerSlug: "playson"
    },
    "legend_of_heroes_megaways": {
        name: "Legend of Heroes MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "legend_of_hou_yi": {
        name: "Legend of Hou Yi",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "legend_of_nezha": {
        name: "Legend Of Nezha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "legend_of_perseus": {
        name: "Legend of Perseus",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "legend_of_the_golden_monkey": {
        name: "Legend of the Golden Monkey",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "legend_of_the_ice_dragon": {
        name: "Legend of the Ice Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legend_of_the_moon_lovers": {
        name: "Legend of the Moon Lovers",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "legendary_beasts": {
        name: "Legendary Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "legendary_diamonds": {
        name: "Legendary Diamonds",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "legendary_monkey_king": {
        name: "Legendary Monkey King",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "legion_gold": {
        name: "Legion Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_and_the_sphinx_of_dead": {
        name: "Legion Gold and the Sphinx of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_reckoning": {
        name: "Legion Gold Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_unleashed": {
        name: "Legion Gold Unleashed",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "legion_gold_victory": {
        name: "Legion Gold Victory",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechaun_carol": {
        name: "Leprechaun Carol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "leprechaun_charms": {
        name: "Leprechaun Charms",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "leprechaun_charms_rainbow_jackpot": {
        name: "Leprechaun Charms Rainbow Jackpot",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "leprechaun_goes_egypt": {
        name: "Leprechaun goes Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechaun_goes_wild": {
        name: "Leprechaun Goes Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechaun_hills": {
        name: "Leprechaun Hills",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "leprechaun_riches": {
        name: "Leprechaun Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "leprechaun_song": {
        name: "Leprechaun Song",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "leprechaun_strike": {
        name: "Leprechaun Strike",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "leprechauns_diamond_dig": {
        name: "Leprechaun's Diamond Dig",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "leprechauns_vault": {
        name: "Leprechaun's Vault",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "let_it_spin": {
        name: "Let it Spin",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "lets_get_ready_to_rumble": {
        name: "Let's get ready to Rumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "level20": {
        name: "Level20",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "liberty_and_freedom_hold_and_win_extreme_10000": {
        name: "Liberty and Freedom Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "life_and_death": {
        name: "Life and Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lightning_clovers_hit_the_bonus": {
        name: "Lightning Clovers - Hit the Bonus™",
        provider: "Playson",
        providerSlug: "playson"
    },
    "lightning_joker": {
        name: "Lightning Joker",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "limbo": {
        name: "Limbo+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lion_gems_3_pot_hold_and_win": {
        name: "Lion Gems 3 Pot Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "lion_gems_hold_and_win": {
        name: "Lion Gems: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "lion_saga_odyssey": {
        name: "Lion Saga Odyssey",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lion_thunder": {
        name: "Lion Thunder",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "little_green_money": {
        name: "Little Green Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "live_lobby": {
        name: "Live Lobby",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "loaded": {
        name: "Loaded",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "loaded_sack": {
        name: "Loaded Sack",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "lobster_bobs_crazy_crab_shack": {
        name: "Lobster Bob's Crazy Crab Shack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lobster_bobs_sea_food_and_win_it": {
        name: "Lobster Bob’s Sea Food and Win It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lobster_house": {
        name: "Lobster House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "loco_the_monkey": {
        name: "Loco the Monkey",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "loki_loot": {
        name: "Loki Loot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lokis_riches": {
        name: "Loki’s Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lolli_pop": {
        name: "Lolli Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "london_hunter": {
        name: "London Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "looney_pop": {
        name: "Looney Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "loony_blox": {
        name: "Loony Blox",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "loot_and_labyrinths": {
        name: "Loot and Labyrinths",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "loot_crab": {
        name: "Loot Crab",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "looting_raccoons": {
        name: "Looting Raccoons",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "lord_merlin_and_the_lady_of_the_lake": {
        name: "Lord Merlin and the Lady of the Lake",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "los_muertos": {
        name: "Los Muertos",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "los_muertos_ii": {
        name: "Los Muertos II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lost_city_of_the_djinn": {
        name: "Lost City of the Djinn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "lost_treasure": {
        name: "Lost Treasure",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lost_vegas": {
        name: "Lost Vegas",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "loti_fortune_spins": {
        name: "LOTI Fortune Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "loti_gold_spins": {
        name: "LOTI Gold Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "love_is_all_you_need": {
        name: "LOVE is all you need",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "love_is_in_the_fair": {
        name: "Love is in the Fair",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "love_joker": {
        name: "Love Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lucha_maniacs": {
        name: "Lucha Maniacs",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "luchadora": {
        name: "Luchadora",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "luchamigos": {
        name: "Luchamigos",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "luck_and_magic": {
        name: "Luck & Magic",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "luck_of_the_devil_power_combo": {
        name: "Luck of the Devil Power Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "luck_of_the_dragon": {
        name: "Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "lucked": {
        name: "Lucked",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "lucky_8_merge_up": {
        name: "Lucky 8 Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_9": {
        name: "Lucky 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_apocalypse_gigablox": {
        name: "Lucky Apocalypse Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "lucky_cauldron": {
        name: "Lucky Cauldron",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "lucky_charms_trio": {
        name: "Lucky Charms Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "lucky_clover_riches": {
        name: "Lucky Clover Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "lucky_clucks": {
        name: "Lucky Clucks",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_crew": {
        name: "Lucky Crew",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_dama_muerta": {
        name: "Lucky Dama Muerta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_diamonds": {
        name: "Lucky Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "lucky_dragon_ball": {
        name: "Lucky Dragon Ball",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_dragon_multidice_x": {
        name: "Lucky Dragon MultiDice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_dragons": {
        name: "Lucky Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_ducky": {
        name: "Lucky Ducky",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_durian": {
        name: "Lucky Durian",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "lucky_farm": {
        name: "Lucky Farm",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "lucky_farm_bonanza": {
        name: "Lucky Farm Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_fire_blitz_win_boost": {
        name: "Lucky Fire Blitz Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "lucky_firecracker": {
        name: "Lucky Firecracker",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_fish": {
        name: "Lucky Fish",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_fishing_megaways": {
        name: "Lucky Fishing MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_fortune": {
        name: "Lucky Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_fortune_cat": {
        name: "Lucky Fortune Cat",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "lucky_grace_and_charm": {
        name: "Lucky, Grace & Charm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_koi": {
        name: "Lucky Koi",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_ladys_clover": {
        name: "Lucky Lady's Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_leprechaun_clusters": {
        name: "Lucky Leprechaun Clusters",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_lightning": {
        name: "Lucky Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_little_dragons": {
        name: "Lucky Little Dragons",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_lu": {
        name: "Lucky Lu",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_lucifer": {
        name: "Lucky Lucifer",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lucky_lucky": {
        name: "Lucky Lucky",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "lucky_neko": {
        name: "Lucky Neko",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "lucky_new_year": {
        name: "Lucky New Year",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_new_year_tiger_treasures": {
        name: "Lucky New Year: Tiger Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucky_numbers_x12": {
        name: "Lucky Numbers x12",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_numbers_x16": {
        name: "Lucky Numbers x16",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_numbers_x20": {
        name: "Lucky Numbers x20",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_numbers_x8": {
        name: "Lucky Numbers x8",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_oak": {
        name: "Lucky Oak",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_oasis": {
        name: "Lucky Oasis",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "lucky_pack_2026_cup": {
        name: "Lucky Pack 2026 Cup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "lucky_pharaoh": {
        name: "Lucky Pharaoh",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "lucky_piggy": {
        name: "Lucky Piggy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "lucky_queen": {
        name: "Lucky Queen",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_rainbow_rush": {
        name: "Lucky Rainbow Rush",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_reels": {
        name: "Lucky Reels™",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "lucky_ryan_gigablox": {
        name: "Lucky Ryan Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "lucky_scarab": {
        name: "Lucky Scarab",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "lucky_scratch": {
        name: "Lucky Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_shot": {
        name: "Lucky Shot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "lucky_streaks": {
        name: "Lucky Streaks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "lucky_twins": {
        name: "Lucky Twins",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_twins_and_9_lions": {
        name: "Lucky Twins and 9 Lions",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_twins_jackpot": {
        name: "Lucky Twins Jackpot",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_twins_link_and_win": {
        name: "Lucky Twins Link & Win",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_twins_power_cluster": {
        name: "Lucky Twins Power Cluster",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_twins_wilds": {
        name: "Lucky Twins Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "lucky_twins_wilds_link_and_merge": {
        name: "Lucky Twins Wilds Link and Merge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "luckys_wild_pub": {
        name: "Lucky's Wild Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "luckys_wild_pub_2": {
        name: "Lucky's Wild Pub 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "lucy_luck_and_the_crimson_diamond": {
        name: "Lucy Luck and the Crimson Diamond",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lucy_luck_and_the_quest_for_coins": {
        name: "Lucy Luck and the Quest for Coins",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lucy_luck_and_the_temple_of_mysteries": {
        name: "Lucy Luck and the Temple of Mysteries",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "lure_of_fortune": {
        name: "Lure of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "maaax_diamonds": {
        name: "Maaax Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "maaax_diamonds_christmas_edition": {
        name: "Maaax Diamonds Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "maaax_diamonds_deluxe": {
        name: "Maaax Diamonds Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "mad_cabs": {
        name: "Mad Cabs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "mad_cabs_hold_and_win": {
        name: "Mad Cabs Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "madame_destiny": {
        name: "Madame Destiny",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "madame_destiny_megaways": {
        name: "Madame Destiny Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "madame_ink": {
        name: "Madame Ink",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mafia": {
        name: "Mafia",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "mafia_gold": {
        name: "Mafia Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "magic_eggs": {
        name: "Magic Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruit_cherries": {
        name: "Magic Fruit: Cherries",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruit_dice": {
        name: "Magic Fruit Dice",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits": {
        name: "Magic Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_27": {
        name: "Magic Fruits 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_4": {
        name: "Magic Fruits 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_4_deluxe": {
        name: "Magic Fruits 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_81": {
        name: "Magic Fruits 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_deluxe": {
        name: "Magic Fruits Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_fruits_oranges": {
        name: "Magic Fruits Oranges",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_hot": {
        name: "Magic Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_hot_4": {
        name: "Magic Hot 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_hot_4_deluxe": {
        name: "Magic Hot 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_journey": {
        name: "Magic Journey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "magic_money_maze": {
        name: "Magic Money Maze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "magic_mummy_megaways": {
        name: "Magic Mummy Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "magic_oak": {
        name: "Magic Oak",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "magic_of_the_ring": {
        name: "Magic Of The Ring",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_of_the_ring_deluxe": {
        name: "Magic Of The Ring Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_piggy": {
        name: "Magic Piggy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "magic_piggy_og": {
        name: "Magic Piggy OG",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "magic_spins": {
        name: "Magic Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars": {
        name: "Magic Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_3": {
        name: "Magic Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_5": {
        name: "Magic Stars 5",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_6": {
        name: "Magic Stars 6",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stars_9": {
        name: "Magic Stars 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_stone": {
        name: "Magic Stone",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "magic_target": {
        name: "Magic Target",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magic_target_deluxe": {
        name: "Magic Target Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "magicians_secrets": {
        name: "Magician's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "magicious": {
        name: "Magicious",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "magikspell": {
        name: "Magikspell",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "mahjong_88": {
        name: "Mahjong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mahjong_panda": {
        name: "Mahjong Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_reels": {
        name: "Mahjong Reels",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "mahjong_ways": {
        name: "Mahjong Ways",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mahjong_ways_2": {
        name: "Mahjong Ways 2",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mahjong_wins": {
        name: "Mahjong Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_wins_bonus": {
        name: "Mahjong Wins Bonus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_wins_super_scatter": {
        name: "Mahjong Wins Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mahjong_wins_triple_pot": {
        name: "Mahjong Wins Triple Pot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "majestic_coins": {
        name: "Majestic Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "majestic_empire": {
        name: "Majestic Empire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "majestic_express_gold_run": {
        name: "Majestic Express Gold Run",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "majestic_fury_megaways": {
        name: "Majestic Fury Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "majestic_fury_megaways_unleashed": {
        name: "Majestic Fury Megaways Unleashed",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "majestic_fury_win_stepper": {
        name: "Majestic Fury Win Stepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "majestic_meow": {
        name: "Majestic Meow",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "majestic_treasures": {
        name: "Majestic Treasures",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mammoth_gold_megaways": {
        name: "Mammoth Gold Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mammoth_triple_riches": {
        name: "Mammoth Triple Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "maneki_88_fortunes": {
        name: "Maneki 88 Fortunes",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "maneki_88_gold": {
        name: "Maneki 88 Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "manic_fairy": {
        name: "Manic Fairy",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "manta_mayhem": {
        name: "Manta Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "maradona": {
        name: "Maradona",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "maradona_el_diez": {
        name: "Maradona El Diez",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "maradona_el_pibe_de_oro": {
        name: "Maradona: El Pibe De Oro",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "marching_legions": {
        name: "Marching Legions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "marlin_masters": {
        name: "Marlin Masters",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "marlin_masters_atlantis": {
        name: "Marlin Masters: Atlantis",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "marlin_masters_the_big_haul": {
        name: "Marlin Masters: The Big Haul",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "marvelous_furlongs": {
        name: "Marvelous Furlongs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mask_carnival": {
        name: "Mask Carnival",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mask_of_amun": {
        name: "Mask of Amun",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "massive_gold": {
        name: "Massive Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "master_chens_fortune": {
        name: "Master Chen’s Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "master_joker": {
        name: "Master Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "masters_of_olympus": {
        name: "Masters of Olympus",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "masters_of_valhalla": {
        name: "Masters of Valhalla",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "match_day": {
        name: "Match Day",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "matsuri": {
        name: "Matsuri",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "max_elements_gigablox": {
        name: "Max Elements Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "mayan_boost": {
        name: "Mayan Boost",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "mayan_destiny": {
        name: "Mayan Destiny",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mayan_fire": {
        name: "Mayan Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "mayan_ritual": {
        name: "Mayan Ritual",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mayan_stackways": {
        name: "Mayan Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mayana": {
        name: "Mayana",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "maze_escape_megaways": {
        name: "Maze Escape MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "mechanical_clover": {
        name: "Mechanical Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "medallion_megaways": {
        name: "Medallion MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "medieval_mania": {
        name: "Medieval Mania",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "medusa": {
        name: "Medusa",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "medusa_ii": {
        name: "Medusa II",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "medusas_madness": {
        name: "Medusa's Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "medusas_stone": {
        name: "Medusa's Stone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mega_baccarat": {
        name: "Mega Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_charged_cash": {
        name: "Mega Charged Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "mega_don_feeding_frenzy": {
        name: "Mega Don: Feeding Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mega_don_triple_threat": {
        name: "Mega Don Triple Threat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mega_flip": {
        name: "Mega Flip",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_heist": {
        name: "Mega Heist",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_mammoth_multiplier_mayhem": {
        name: "Mega Mammoth Multiplier Mayhem",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "mega_masks": {
        name: "Mega Masks",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_mine": {
        name: "Mega Mine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mega_mystery_mine": {
        name: "Mega Mystery Mine",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mega_roulette": {
        name: "Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_roulette_3000": {
        name: "Mega Roulette 3000",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_sic_bac": {
        name: "Mega Sic Bac",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_sic_bo": {
        name: "Mega Sic Bo",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "mega_wheel": {
        name: "Mega Wheel",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "megablox_777": {
        name: "MegaBlox 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "megablox_pyramids": {
        name: "Megablox Pyramids",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "megadon": {
        name: "Megadon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "megaways_jack": {
        name: "MegaWays Jack",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "megaways_jack_and_the_magic_beans": {
        name: "MegaWays Jack and The Magic Beans",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "megaways_jack_frost": {
        name: "Megaways Jack Frost",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "mejuicea": {
        name: "MeJUICEa",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "meow_janken": {
        name: "Meow Janken",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "merge_up": {
        name: "Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "merge_up_2": {
        name: "Merge Up 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "merlin_and_the_ice_queen_morgana": {
        name: "Merlin and the Ice Queen Morgana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlin_journey_of_flame": {
        name: "Merlin: Journey of Flame",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlin_realm_of_charm": {
        name: "Merlin Realm of Charm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlins_fortune": {
        name: "Merlin's Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "merlins_grimoire": {
        name: "Merlin's Grimoire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "merlins_secret_maxways": {
        name: "Merlin's Secret Maxways",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "mermaid_riches": {
        name: "Mermaid Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mermaids_diamond": {
        name: "Mermaid's Diamond",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mermaids_millions": {
        name: "Mermaids Millions",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "mermaids_treasure_love": {
        name: "Mermaid's Treasure Love",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "merry_giftmas_hold_and_win": {
        name: "Merry Giftmas: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "merry_megaways": {
        name: "Merry Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "merry_xmas": {
        name: "Merry Xmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mexomax_multimax": {
        name: "MexoMax! Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "miami_beach": {
        name: "Miami Beach",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "miami_mayhem": {
        name: "Miami Mayhem",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mice_and_magic_wonder_spin": {
        name: "Mice & Magic Wonder Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "microgaming_live_lobby": {
        name: "Microgaming Live Lobby",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "midas_coins": {
        name: "Midas Coins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "midas_fortune": {
        name: "Midas Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "midas_glory_coin_collect": {
        name: "Midas Glory Coin Collect",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "midas_golden_touch": {
        name: "Midas Golden Touch",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "midas_golden_touch_2": {
        name: "Midas Golden Touch 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "midas_golden_touch_christmas_edition": {
        name: "Midas Golden Touch Christmas Edition",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "midas_golden_touch_reborn": {
        name: "Midas Golden Touch Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "midas_king_of_gold": {
        name: "Midas King Of Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "midnight_gold": {
        name: "Midnight Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "midnight_hunt": {
        name: "Midnight Hunt",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "midnight_in_tokyo": {
        name: "Midnight in Tokyo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "midnight_marauder": {
        name: "Midnight Marauder",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "might_of_freya_megaways": {
        name: "Might of Freya Megaways™",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "might_of_ra": {
        name: "Might of Ra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mighty_arthur": {
        name: "Mighty Arthur",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "mighty_dragon": {
        name: "Mighty Dragon",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "mighty_fish_blue_marlin": {
        name: "Mighty Fish™: Blue Marlin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_gorilla": {
        name: "Mighty Gorilla",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mighty_hot_amazonia": {
        name: "Mighty Hot: Amazonia",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_kong": {
        name: "Mighty Kong",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mighty_mania": {
        name: "Mighty Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mighty_marlin": {
        name: "Mighty Marlin",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mighty_marlin_super_reel": {
        name: "Mighty Marlin Super Reel",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mighty_masks": {
        name: "Mighty Masks",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mighty_medusa": {
        name: "Mighty Medusa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mighty_mountain": {
        name: "Mighty Mountain",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mighty_munching_melons": {
        name: "Mighty Munching Melons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mighty_panda": {
        name: "Mighty Panda",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "mighty_symbols_crowns": {
        name: "Mighty Symbols: Crowns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_symbols_diamonds": {
        name: "Mighty Symbols™: Diamonds",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_symbols_jokers": {
        name: "Mighty Symbols™: Jokers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_symbols_sevens": {
        name: "Mighty Symbols: Sevens",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_jaguar": {
        name: "Mighty Wild™: Jaguar",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther": {
        name: "Mighty Wild™: Panther",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther_grand_diamond_edition": {
        name: "Mighty Wild™: Panther Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther_grand_gold_edition": {
        name: "Mighty Wild™: Panther Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wild_panther_grand_platinum_edition": {
        name: "Mighty Wild™: Panther Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mighty_wins": {
        name: "Mighty Wins",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "milk_the_cow": {
        name: "Milk the Cow",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "million_baccarat": {
        name: "Million Baccarat",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_blackjack_london_deal": {
        name: "Million Blackjack London Deal",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_blackjack_peek": {
        name: "Million Blackjack Peek",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million_tree": {
        name: "Million Tree",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "million_wheel": {
        name: "Million Wheel",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "mindiana_jones": {
        name: "Mindiana Jones",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "mine_mine_quest": {
        name: "Mine Mine Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "mine_pop": {
        name: "Mine Pop",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "miner_donkey_trouble": {
        name: "Miner Donkey Trouble",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mines": {
        name: "Mines",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "mining_pots_of_gold": {
        name: "Mining Pots of Gold",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "mining_rush": {
        name: "Mining Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mirror_joker": {
        name: "Mirror Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "miss_cherry_fruits": {
        name: "Miss Cherry Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "miss_cherry_fruits_jackpot_party": {
        name: "Miss Cherry Fruits Jackpot Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mission_cash": {
        name: "Mission Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mochimon": {
        name: "Mochimon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mole_digger": {
        name: "Mole Digger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moleionaire": {
        name: "Moleionaire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_bunny_show": {
        name: "Money Bunny Show",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "money_cart": {
        name: "Money Cart",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_cart_2": {
        name: "Money Cart 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_cart_3": {
        name: "Money Cart 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_cart_4": {
        name: "Money Cart 4",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_dragon": {
        name: "Money Dragon",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "money_jar": {
        name: "Money Jar",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "money_jar_2": {
        name: "Money Jar 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "money_maker": {
        name: "Money Maker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "money_money_money": {
        name: "Money Money Money",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_mouse": {
        name: "Money Mouse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_on_reels": {
        name: "Money on Reels",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "money_on_reels_super_arrow": {
        name: "Money on Reels Super Arrow",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "money_roll": {
        name: "Money Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_sleigh": {
        name: "Money Sleigh",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_stacks": {
        name: "Money Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_stacks_megaways": {
        name: "Money Stacks Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "money_time": {
        name: "Money Time",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "money_train": {
        name: "Money Train",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_train_2": {
        name: "Money Train 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_train_3": {
        name: "Money Train 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_train_4": {
        name: "Money Train 4",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "money_wheel": {
        name: "Money Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "monkey_27": {
        name: "Monkey 27",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "monkey_battle_for_the_scrolls": {
        name: "Monkey: Battle for the Scrolls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "monkey_madness": {
        name: "Monkey Madness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "monkey_mania": {
        name: "Monkey Mania",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "monkey_pop": {
        name: "Monkey Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "monkey_warrior": {
        name: "Monkey Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "monkeypop_2": {
        name: "MonkeyPop 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "monkeys_go_bananas": {
        name: "Monkeys Go Bananas",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "monster_blox": {
        name: "Monster Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "monster_hunt": {
        name: "Monster Hunt",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "monster_madness": {
        name: "Monster Madness",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "monster_mash_cash": {
        name: "Monster Mash Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "monster_superlanche": {
        name: "Monster Superlanche",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "moo_moo_cow": {
        name: "Moo Moo Cow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "moon_of_fortune": {
        name: "Moon Of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "moon_princess": {
        name: "Moon Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_100": {
        name: "Moon Princess 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_christmas_kingdom": {
        name: "Moon Princess: Christmas Kingdom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_origins": {
        name: "Moon Princess Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_power_of_love": {
        name: "Moon Princess: Power of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_stargazing": {
        name: "Moon Princess Stargazing",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moon_princess_trinity": {
        name: "Moon Princess Trinity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "moonshot": {
        name: "Moonshot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "motley_crue": {
        name: "Motley Crue",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mount_m": {
        name: "Mount M",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mount_mazuma": {
        name: "Mount Mazuma",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mr_bling": {
        name: "Mr Bling",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mr_first_live": {
        name: "Mr First Live",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "mr_hallowwin": {
        name: "Mr. Hallow-Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mr_nulls_wicked_wares": {
        name: "Mr Null's Wicked Wares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mr_oinksters_hold_and_win": {
        name: "Mr. Oinksters Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mr_oinksters_power_hit": {
        name: "Mr. Oinkster's Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mr_porky_banker_cash_stash": {
        name: "Mr Porky Banker: Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "mr_treasures_fortune": {
        name: "Mr Treasure's Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "muay_thai_champion": {
        name: "Muay Thai Champion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "muddy_waters": {
        name: "Muddy Waters",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "muerto_en_mictlan": {
        name: "Muerto En Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "muertos_multiplier_megaways": {
        name: "Muertos Multiplier Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "multi_machine": {
        name: "Multi Machine",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "multi_rush": {
        name: "Multi Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "multifly": {
        name: "Multifly!",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "multifruit_81": {
        name: "Multifruit 81",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "multihand_blackjack": {
        name: "Multihand Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "multiplier_odyssey": {
        name: "Multiplier Odyssey",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "mummy_hunter": {
        name: "Mummy Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mummy_lock_riches": {
        name: "Mummy Lock Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "mummy_money": {
        name: "Mummy Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mummy_princess": {
        name: "Mummy Princess",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "mummys_gold": {
        name: "Mummy's Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mummys_jewels": {
        name: "Mummy's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mummys_jewels_100": {
        name: "Mummy's Jewels 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "munchy_milo": {
        name: "Munchy Milo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "museum_mystery": {
        name: "Museum Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mustang_gold": {
        name: "Mustang Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mustang_gold_megaways": {
        name: "Mustang Gold Megaways™",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mustang_hold_and_win": {
        name: "Mustang Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "mustang_trail": {
        name: "Mustang Trail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mutagenes": {
        name: "Mutagenes",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "mysterious": {
        name: "Mysterious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mysterious_egypt": {
        name: "Mysterious Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mystery_egg_surprise": {
        name: "Mystery Egg Surprise",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_garden": {
        name: "Mystery Garden",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mystery_genie_fortunes_of_the_lamp": {
        name: "Mystery Genie Fortunes of the Lamp",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_heist": {
        name: "Mystery Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "mystery_jack": {
        name: "Mystery Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mystery_jack_deluxe": {
        name: "Mystery Jack Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mystery_joker": {
        name: "Mystery Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_joker_6000": {
        name: "Mystery Joker 6000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mystery_kindom_mystery_bells": {
        name: "Mystery Kindom: Mystery Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "mystery_mice": {
        name: "Mystery Mice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mystic_chief": {
        name: "Mystic Chief",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "mystic_fortune_deluxe": {
        name: "Mystic Fortune Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "mystic_potion": {
        name: "Mystic Potion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "mystic_spells": {
        name: "Mystic Spells",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "mystical_forest": {
        name: "Mystical Forest",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "mystical_spirits": {
        name: "Mystical Spirits",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "myth": {
        name: "Myth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "myth_of_dead": {
        name: "Myth of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "mythical_guardians": {
        name: "Mythical Guardians",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "napoleon_2_fat_stacks": {
        name: "Napoleon 2 Fat Stacks",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "napoleon_deluxe": {
        name: "Napoleon Deluxe",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "napoleon_megaways": {
        name: "Napoleon Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "napoleon_rise_of_an_empire": {
        name: "Napoleon: Rise of an Empire",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "naughty_nicks_book": {
        name: "Naughty Nick's Book",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "naughty_santa": {
        name: "Naughty Santa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "naughty_wukong": {
        name: "Naughty Wukong",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "necromancers_gate": {
        name: "Necromancer's Gate",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "neon_city": {
        name: "Neon City",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "neon_dreams": {
        name: "Neon Dreams",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "neon_rush_splitz": {
        name: "Neon Rush – Splitz",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "neon_villains_doublemax": {
        name: "Neon Villains Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "neros_fortune": {
        name: "Nero's Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "net_gains": {
        name: "Net Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "new_year_riches": {
        name: "New Year Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "new_years_bash": {
        name: "New Years Bash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "nice_catch_2": {
        name: "Nice Catch 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "nice_catch_doublemax": {
        name: "Nice Catch DoubleMax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "night_club_81": {
        name: "Night Club 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "night_wolves": {
        name: "Night Wolves",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "nile_fortune": {
        name: "Nile Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "nine_tails": {
        name: "Nine Tails",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ninja_fruits": {
        name: "Ninja Fruits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ninja_raccoon_frenzy": {
        name: "Ninja Raccoon Frenzy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ninja_vs_samurai": {
        name: "Ninja vs Samurai",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "nirvana": {
        name: "Nirvana",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "nitro_100": {
        name: "Nitro 100",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "nitro_nights": {
        name: "Nitro Nights",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "no_commission_baccarat_eclipse": {
        name: "No Commission Baccarat Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "no_commission_baccarat_ftv": {
        name: "No Commission Baccarat FTV",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "no_commission_korean_baccarat": {
        name: "No Commission Korean Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "nordic_fire": {
        name: "Nordic Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "north_guardians": {
        name: "North Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "northern_sky": {
        name: "Northern Sky",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "not_enough_kittens": {
        name: "Not Enough Kittens",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "notredame_tales_gigablox": {
        name: "Notre-Dame Tales GigaBlox™",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "nova_ultra_blast": {
        name: "Nova Ultra Blast",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "nugget": {
        name: "Nugget",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "nugget_n_nonsense": {
        name: "Nugget N' Nonsense",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "nuwa": {
        name: "Nuwa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "nuwa_deluxe": {
        name: "Nuwa Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "oasis_of_dead": {
        name: "Oasis of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ocean_party": {
        name: "Ocean party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "oceans_call": {
        name: "Ocean's Call",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "octo_attack": {
        name: "Octo Attack",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "octobeer_fortunes": {
        name: "Octobeer Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "octopus_treasure": {
        name: "Octopus Treasure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "odin_protector_of_realms": {
        name: "Odin: Protector of Realms",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "of_sabers_and_monsters_wildfight": {
        name: "Of Sabers and Monsters WildFight",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "office_party": {
        name: "Office Party",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "oiran_dream": {
        name: "Oiran Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "oiran_dream_xmas": {
        name: "Oiran Dream Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "oiran_hearts": {
        name: "Oiran Hearts",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "oishi_delights": {
        name: "Oishi Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "old_fisherman": {
        name: "Old Fisherman",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "olympus_trueways": {
        name: "Olympus Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "one_blackjack": {
        name: "One Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "one_coins": {
        name: "One Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "oodles_of_noodles": {
        name: "Oodles of Noodles",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "oof_the_goldmine_planet": {
        name: "OOF The Goldmine Planet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "oops": {
        name: "Oops",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "open_it": {
        name: "Open It",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "opera_dynasty": {
        name: "Opera Dynasty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "oracle_of_gold": {
        name: "Oracle of Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "orb_of_destiny": {
        name: "Orb of Destiny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "orbs_of_atlantis": {
        name: "Orbs of Atlantis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "orient_express": {
        name: "Orient Express",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "oriental_prosperity": {
        name: "Oriental Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "orphan_organ": {
        name: "Orphan Organ",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "outlaws": {
        name: "Outlaws",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "outlaws_inc": {
        name: "Outlaws Inc.",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "overdose": {
        name: "Overdose",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "ozwins_jackpots": {
        name: "Ozwins Jackpots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "pack_and_cash": {
        name: "Pack and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "paddys_payout_race_to_riches": {
        name: "Paddy's Payout Race to Riches",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "paddys_pooches": {
        name: "Paddy's Pooches",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "pamper_me": {
        name: "Pamper Me",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "panda_fortune_rush": {
        name: "Panda Fortune Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "panda_luck": {
        name: "Panda Luck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "panda_panda": {
        name: "Panda Panda",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pandas_fortune": {
        name: "Panda's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pandas_run": {
        name: "Pandas Run",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "pandastic_adventure": {
        name: "Pandastic Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pandemic_rising": {
        name: "Pandemic Rising",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pandoras_box_of_evil": {
        name: "Pandora's Box of Evil",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pantera_rica": {
        name: "Pantera Rica",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "panthers_reign": {
        name: "Panther's Reign",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "papaya_pop": {
        name: "Papaya Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "paradise_ticket": {
        name: "Paradise Ticket",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "paris_nights": {
        name: "Paris Nights",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "payday_pig": {
        name: "Payday Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "pearl_beauty_hold_and_win": {
        name: "Pearl Beauty: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "pearl_lagoon": {
        name: "Pearl Lagoon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pearl_o_plinko": {
        name: "Pearl O Plinko",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pearl_o_plinko_mermaid": {
        name: "Pearl O Plinko Mermaid",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pearl_ocean_hold_and_win": {
        name: "Pearl Ocean: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "pearls_of_india": {
        name: "Pearls of India",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "peking_luck": {
        name: "Peking Luck",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "penalty_champion_goals_to_glory": {
        name: "Penalty Champion Goals to Glory",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "penalty_duel": {
        name: "Penalty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "penalty_duel_with_julio_cesar": {
        name: "Penalty Duel with Julio Cesar",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "penguin_city": {
        name: "Penguin City",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "penguins_christmas_party_time": {
        name: "Penguins Christmas Party Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pengwins": {
        name: "PengWins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "penny_pelican": {
        name: "Penny Pelican",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "peppes_pepperoni_pizza_plaza": {
        name: "Peppe's Pepperoni Pizza Plaza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "perfect_catch": {
        name: "Perfect Catch",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "perfect_gems": {
        name: "Perfect Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "perfect_strike": {
        name: "Perfect Strike",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "peter_hunter": {
        name: "Peter Hunter",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "phantoms_mirror": {
        name: "Phantom's Mirror",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "pharaohs_last_wish": {
        name: "Pharaoh's Last Wish",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "pharaos_riches": {
        name: "Pharao's Riches",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "phoenix_duelreels": {
        name: "Phoenix DuelReels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "phoenix_forge": {
        name: "Phoenix Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "phoenix_fury": {
        name: "Phoenix Fury",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "phoenix_inferno": {
        name: "Phoenix Inferno",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "phoenix_paradise": {
        name: "Phoenix Paradise",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "phoenix_reborn": {
        name: "Phoenix Reborn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "phoenix_rises": {
        name: "Phoenix Rises",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "phoenix_sun": {
        name: "Phoenix Sun",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "photo_safari": {
        name: "Photo Safari",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pied_piper": {
        name: "Pied Piper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pig_wizard_cash_lock": {
        name: "Pig Wizard Cash Lock",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "piggy_bank_bills": {
        name: "Piggy Bank Bills",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "piggy_bank_cash": {
        name: "Piggy Bank Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "piggy_bank_farm": {
        name: "Piggy Bank Farm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_bank_hold_and_win": {
        name: "Piggy Bank Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "piggy_bank_stash": {
        name: "Piggy Bank Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "piggy_bankers": {
        name: "Piggy Bankers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "piggy_blitz": {
        name: "Piggy Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_blitz_casino_gold": {
        name: "Piggy Blitz Casino Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_blitz_disco_gold": {
        name: "Piggy Blitz Disco Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_gold": {
        name: "Piggy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "piggy_heist": {
        name: "Piggy Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "piggy_pop": {
        name: "Piggy Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "piggy_pop_grand_affair_2": {
        name: "Piggy Pop Grand Affair 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "piggy_power_hit_the_bonus": {
        name: "Piggy Power: Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "piggy_rush": {
        name: "Piggy Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "piggypop_grand_affair": {
        name: "PiggyPop Grand Affair",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pilgrim_of_dead": {
        name: "Pilgrim of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pimped": {
        name: "Pimped",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pinata_go_go": {
        name: "Pinata Go Go",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "pinata_wins": {
        name: "Pinata Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pineapple_crush": {
        name: "Pineapple Crush",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ping_pong_star": {
        name: "Ping Pong Star",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "pink_clovers_xxxl_hold_and_win": {
        name: "Pink Clovers XXXL: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "pink_elephants": {
        name: "Pink Elephants",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "pink_elephants_2": {
        name: "Pink Elephants 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "pink_elephants_2_reborn": {
        name: "Pink Elephants 2 Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "pink_joker_hold_and_win": {
        name: "Pink Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "pinup_girls": {
        name: "Pinup Girls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirahna_pays": {
        name: "Pirahna Pays",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pirate_armada": {
        name: "Pirate Armada",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "pirate_chest_hold_and_win": {
        name: "Pirate Chest: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "pirate_coins": {
        name: "Pirate Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "pirate_gold": {
        name: "Pirate Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirate_gold_deluxe": {
        name: "Pirate Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirate_kingdom_megaways": {
        name: "Pirate Kingdom Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "pirate_multi_coins": {
        name: "Pirate Multi Coins",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "pirates_2_mutiny": {
        name: "Pirates 2: Mutiny",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "pirates_charm": {
        name: "Pirate's Charm",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pirates_fight_for_fortune": {
        name: "Pirate's Fight for Fortune",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "pirates_pub": {
        name: "Pirates Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pirates_smugglers_paradise": {
        name: "Pirates: Smugglers Paradise",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "pixel_paws": {
        name: "Pixel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pixie_wings": {
        name: "Pixie Wings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pixiepop": {
        name: "PixiePop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pizza_fiesta": {
        name: "Pizza Fiesta",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "pizza_pizza_pizza": {
        name: "PIZZA! PIZZA? PIZZA!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "planet_fortune": {
        name: "Planet Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "platinum_lightning": {
        name: "Platinum Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "platinum_lightning_deluxe": {
        name: "Platinum Lightning Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "playboy": {
        name: "Playboy",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "playboy_fortunes": {
        name: "Playboy Fortunes",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "playboy_gems_and_desires": {
        name: "Playboy Gems and Desires",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "playboy_gems_and_desires_vf": {
        name: "Playboy Gems and Desires VF",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "playboy_gold_jackpots": {
        name: "Playboy Gold Jackpots",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "playboy_wilds": {
        name: "Playboy Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "plenty_o_fish": {
        name: "Plenty o' Fish",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "plenty_of_presents": {
        name: "Plenty of Presents",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "plinko": {
        name: "Plinko",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "plinko_go": {
        name: "Plinko Go",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "plinko_pop": {
        name: "Plinko Pop",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "plunderland": {
        name: "Plunderland",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "plushie_frenzy": {
        name: "Plushie Frenzy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "plushie_peril": {
        name: "Plushie Peril",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "pocket_ace": {
        name: "Pocket Ace",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "poker_kingdom_win": {
        name: "Poker Kingdom Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "polar_buffalo_extreme_hold_and_win_25000": {
        name: "Polar Buffalo Extreme Hold and Win 25,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "polar_paws": {
        name: "Polar Paws",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "pompeii_megareels_megaways": {
        name: "Pompeii Megareels Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pong_pong_mahjong": {
        name: "Pong Pong Mahjong",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "pong_pong_mahjong_jackpots": {
        name: "Pong Pong Mahjong Jackpots",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "pool_shark": {
        name: "Pool Shark",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pop_cop": {
        name: "Pop Cop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "pop_noir": {
        name: "Pop Noir",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pop_ogold": {
        name: "Pop o'Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pop_rocks": {
        name: "Pop Rocks",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "pop_till_you_drop": {
        name: "Pop TIll You Drop",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "pop_zen": {
        name: "Pop Zen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "poseidon": {
        name: "Poseidon",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pot_of_fortune": {
        name: "Pot of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "potion_of_madness": {
        name: "Potion of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "potion_power": {
        name: "Potion Power",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "potion_spells": {
        name: "Potion Spells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "pots_of_power_zeus": {
        name: "Pots of Power Zeus",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "power_crown_hold_and_win": {
        name: "Power Crown: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "power_of_atlantis_trio": {
        name: "Power of Atlantis Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_god_medusa_extremely_light": {
        name: "Power of God: Medusa Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_egypt": {
        name: "Power of Gods: Egypt",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_hades": {
        name: "Power of Gods: Hades",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_medusa": {
        name: "Power of Gods™: Medusa",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_the_pantheon": {
        name: "Power of Gods: The Pantheon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_valhalla": {
        name: "Power of Gods™: Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_gods_valhalla_extremely_light": {
        name: "Power of Gods™: Valhalla Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_hercules_bonanza": {
        name: "Power of Hercules Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_merlin_megaways": {
        name: "Power of Merlin Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_of_ninja": {
        name: "Power of Ninja",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "power_of_olympus": {
        name: "Power of Olympus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_rome": {
        name: "Power of Rome",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "power_of_sun_svarog": {
        name: "Power of Sun™: Svarog",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "power_of_ten": {
        name: "Power of Ten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "power_of_thor_megaways": {
        name: "Power of Thor Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "powerspin": {
        name: "Powerspin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "powerup_roulette": {
        name: "PowerUP Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic_play_live_lobby": {
        name: "Pragmatic Play Live Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pray_for_six": {
        name: "Pray for Six",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "pray_for_three": {
        name: "Pray for Three",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "preach_tv": {
        name: "Preach TV",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "precious_7": {
        name: "Precious 7",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "presto": {
        name: "Presto!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "primal_megaways": {
        name: "Primal Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "primal_rampage": {
        name: "Primal Rampage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prime_zone": {
        name: "Prime Zone",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "prince_of_purrwood": {
        name: "Prince of Purrwood",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "prince_treasure": {
        name: "Prince Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "prism_of_gems": {
        name: "Prism of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prissy_princess": {
        name: "Prissy Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prive_lounge_baccarat": {
        name: "Prive Lounge Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "prosperity_blessing": {
        name: "Prosperity Blessing",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "prosperity_fortune_tree": {
        name: "Prosperity Fortune Tree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "prosperity_horse": {
        name: "Prosperity Horse",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "prosperity_lion": {
        name: "Prosperity Lion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "prosperity_palace": {
        name: "Prosperity Palace",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "prosperity_pearls": {
        name: "Prosperity Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "prosperity_reels": {
        name: "Prosperity Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "prost": {
        name: "Prost!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pub_kings": {
        name: "Pub Kings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pucker_up_prince": {
        name: "Pucker Up Prince",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "puebla_parade": {
        name: "Puebla Parade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "pug_life": {
        name: "Pug Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "pumped_up": {
        name: "Pumped Up",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "pumpkin_patch": {
        name: "Pumpkin Patch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "pumpkin_smash": {
        name: "Pumpkin Smash",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "punch_club": {
        name: "Punch Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "punto_banco_italia_tricolore": {
        name: "Punto Banco Italia Tricolore",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "puppy_payday": {
        name: "Puppy Payday",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "pure_platinum": {
        name: "Pure Platinum",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "purrrminator": {
        name: "Purrrminator",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "pushy_cats": {
        name: "Pushy Cats",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "pyramid_bonanza": {
        name: "Pyramid Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pyramid_king": {
        name: "Pyramid King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pyramid_rising_x33": {
        name: "Pyramid Rising x33",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "pyramyth": {
        name: "Pyramyth",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "pyramyth_reborn": {
        name: "Pyramyth Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "quackin_reels": {
        name: "Quackin' Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "queen_of_alexandria": {
        name: "Queen of Alexandria",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "queen_of_bounty": {
        name: "Queen of Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "queen_of_crystal_rays": {
        name: "Queen of Crystal Rays",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "queen_of_embers": {
        name: "Queen of Embers",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "queen_of_gods": {
        name: "Queen of Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "queen_of_queens": {
        name: "Queen of Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "queen_of_queens_ii": {
        name: "Queen of Queens II",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "queen_of_the_sphinx": {
        name: "Queen of the Sphinx",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "queen_treasure": {
        name: "Queen Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "queenie": {
        name: "Queenie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "queens_day_tilt": {
        name: "Queen's Day Tilt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "queens_of_ra": {
        name: "Queens of Ra",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "quest": {
        name: "Quest",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "rabbit_garden": {
        name: "Rabbit Garden™",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rabbit_hole_riches": {
        name: "Rabbit Hole Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "racing_royalty": {
        name: "Racing Royalty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "rad_maxx": {
        name: "Rad Maxx",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rage_to_riches": {
        name: "Rage to Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_bull": {
        name: "Raging Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "raging_pop": {
        name: "Raging Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "raging_rabbits": {
        name: "Raging Rabbits",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "raging_rex": {
        name: "Raging Rex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_rex_2": {
        name: "Raging Rex 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_rex_3": {
        name: "Raging Rex 3",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "raging_riches": {
        name: "Raging Riches",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "raging_waterfall_megaways": {
        name: "Raging Waterfall Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ragnaravens_wildenergy": {
        name: "Ragnaravens WildEnergy",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "ragnarok": {
        name: "Ragnarok",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "ragnarok_40k": {
        name: "Ragnarok 40k",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "ragnawolves_wildenergy": {
        name: "Ragnawolves WildEnergy",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "raiden_shogun": {
        name: "Raiden Shogun",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "raider_janes_crypt_of_fortune": {
        name: "Raider Jane's Crypt of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "raigeki_rising_x30": {
        name: "Raigeki Rising x30",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "rainbow_3x3": {
        name: "Rainbow 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "rainbow_gold": {
        name: "Rainbow Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rainbow_princess": {
        name: "Rainbow Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rainbow_reels": {
        name: "Rainbow Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rainbow_rush": {
        name: "Rainbow Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "rainbow_ryan": {
        name: "Rainbow Ryan",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "rainbow_ryan_2": {
        name: "Rainbow Ryan 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "rainbow_wilds_megaways": {
        name: "Rainbow Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "rainbowmania": {
        name: "Rainbowmania",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "rainforest_magic": {
        name: "Rainforest Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rainforest_magic_bingo": {
        name: "Rainforest Magic Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rainin_money": {
        name: "Rainin Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "rally_4_riches": {
        name: "Rally 4 Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ramses_book": {
        name: "Ramses Book",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_christmas_edition": {
        name: "Ramses Book Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_deluxe": {
        name: "Ramses Book Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_easter_edition": {
        name: "Ramses Book Easter Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_flaming_link": {
        name: "Ramses Book Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_book_respins_of_amunre": {
        name: "Ramses Book Respins of Amun-Re",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ramses_revenge": {
        name: "Ramses Revenge",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "raptor_2": {
        name: "Raptor 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "raptor_doublemax": {
        name: "Raptor Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "rapunzels_tower": {
        name: "Rapunzel's Tower",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ras_reckoning": {
        name: "Ra's Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ras_relics_bonanza": {
        name: "Ra's Relics Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "rascal_riches": {
        name: "Rascal Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rat_riches": {
        name: "Rat Riches",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rave_party_fever": {
        name: "Rave Party Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ravens_eye": {
        name: "Raven's Eye",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "razortooth": {
        name: "Razortooth",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "reactoonz": {
        name: "Reactoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "reactoonz_100": {
        name: "Reactoonz 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "reactoonz_2": {
        name: "Reactoonz 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rebel_paws": {
        name: "Rebel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "reborn_of_zeus_3000": {
        name: "Reborn of Zeus 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "recycle_riches": {
        name: "Recycle Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "red_head_bounty": {
        name: "Red Head Bounty",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "red_hot_catch": {
        name: "Red Hot Catch",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "red_hot_chilli": {
        name: "Red Hot Chilli",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "red_hot_eruption": {
        name: "Red Hot Eruption",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "red_hot_riches": {
        name: "Red Hot Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "red_lights": {
        name: "Red Lights",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "red_rascal": {
        name: "Red Rascal",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "red_zone_blitz": {
        name: "Red Zone Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "red_zone_blitz_hold_and_win": {
        name: "Red Zone Blitz Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "reef_pop": {
        name: "Reef Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "reel_banks": {
        name: "Reel Banks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "reel_desire": {
        name: "Reel Desire",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "reel_diamonds": {
        name: "Reel Diamonds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "reel_fruits": {
        name: "Reel Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "reel_gems": {
        name: "Reel Gems",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "reel_goal_cash_towers": {
        name: "Reel Goal Cash Towers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "reel_hero": {
        name: "Reel Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "reel_joke": {
        name: "Reel Joke",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "reel_love": {
        name: "Reel Love",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "reel_nightmare": {
        name: "Reel Nightmare",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "reel_rampage": {
        name: "Reel Rampage",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "reel_royale_showdown": {
        name: "Reel Royale Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "reel_thunder": {
        name: "Reel Thunder",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "reel_warriors": {
        name: "Reel Warriors",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "reels": {
        name: "Reels",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "reels_paradise": {
        name: "Reels Paradise",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "reign_of_fire": {
        name: "Reign of Fire",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "reign_of_rome": {
        name: "Reign of Rome",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "release_the_bison": {
        name: "Release the Bison",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "release_the_kraken": {
        name: "Release the Kraken",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "release_the_kraken_2": {
        name: "Release the Kraken 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "release_the_kraken_megaways": {
        name: "Release the Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "relic_hunters_and_the_book_of_faith": {
        name: "Relic Hunters and the Book of Faith",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "reno_7s": {
        name: "Reno 7's",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "resurrecting_riches": {
        name: "Resurrecting Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "retro_reels": {
        name: "Retro Reels",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "retro_reels_diamond_glitz": {
        name: "Retro Reels - Diamond Glitz",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "retro_trader": {
        name: "Retro Trader",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "return_of_kong_megaways": {
        name: "Return of Kong Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "return_of_the_dead": {
        name: "Return of the Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "return_to_the_feature": {
        name: "Return To The Feature",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "returntovalhalla": {
        name: "ReturnToValhalla",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "revenge_of_loki_megaways": {
        name: "Revenge of Loki Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rex_the_hunt": {
        name: "Rex the Hunt",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "rhino_coins_hit_the_bonus": {
        name: "Rhino Coins Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "rhino_hold_and_win": {
        name: "Rhino Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "rhino_rampage": {
        name: "Rhino Rampage",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "rich_diamonds_hold_and_win": {
        name: "Rich Diamonds: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "rich_raptors": {
        name: "Rich Raptors",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "rich_wilde_and_the_amulet_of_dead": {
        name: "Rich Wilde and the Amulet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_pearls_of_vishnu": {
        name: "Rich Wilde and the Pearls of Vishnu",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_shield_of_athena": {
        name: "Rich Wilde and The Shield of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_tome_of_dead": {
        name: "Rich Wilde and the Tome of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_tome_of_insanity": {
        name: "Rich Wilde and the Tome of Insanity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_tome_of_madness": {
        name: "Rich Wilde and the Tome of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rich_wilde_and_the_wandering_city": {
        name: "Rich Wilde and the Wandering City",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "riches_of_ra": {
        name: "Riches of RA",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "riches_of_robin": {
        name: "Riches of Robin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "riches_of_zeus": {
        name: "Riches of Zeus",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "richie_fruits_roulette": {
        name: "Richie Fruits Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "richie_wheel": {
        name: "Richie Wheel",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "riddle_reels_a_case_of_riches": {
        name: "Riddle Reels: A Case of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ride_em_cowboy": {
        name: "Ride 'em Cowboy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ride_the_lightning": {
        name: "Ride the Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "riders_of_the_storm": {
        name: "Riders of the Storm",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "ring_of_odin": {
        name: "Ring of Odin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rings_of_prosperity": {
        name: "Rings of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rio_fantasia": {
        name: "Rio Fantasia",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "rip_city": {
        name: "RIP City",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "ripe_rewards": {
        name: "Ripe Rewards",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_apollo": {
        name: "Rise of Apollo",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "rise_of_athena": {
        name: "Rise of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_atlantis": {
        name: "Rise of Atlantis",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "rise_of_atlantis_2": {
        name: "Rise of Atlantis 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "rise_of_dead": {
        name: "Rise of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_egypt": {
        name: "Rise of Egypt",
        provider: "Playson",
        providerSlug: "playson"
    },
    "rise_of_fortuna": {
        name: "Rise of Fortuna",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rise_of_giza_powernudge": {
        name: "Rise of Giza PowerNudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_gods_reckoning": {
        name: "Rise of Gods Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_merlin": {
        name: "Rise of Merlin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus": {
        name: "Rise of Olympus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_100": {
        name: "Rise of Olympus 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_1000": {
        name: "Rise of Olympus 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_bingo": {
        name: "Rise of Olympus Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_extreme": {
        name: "Rise of Olympus Extreme",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_olympus_origins": {
        name: "Rise of Olympus Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_orpheus": {
        name: "Rise of Orpheus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rise_of_pyramids": {
        name: "Rise of Pyramids",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai": {
        name: "Rise of Samurai",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai_4": {
        name: "Rise of Samurai 4",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai_iii": {
        name: "Rise of Samurai III",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_samurai_megaways": {
        name: "Rise of Samurai MegaWays",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rise_of_the_valkyrie": {
        name: "Rise Of The Valkyrie",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "rise_of_ymir": {
        name: "Rise of Ymir",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "road_2_riches": {
        name: "Road 2 Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "roadquake": {
        name: "Roadquake",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "robber_strike": {
        name: "Robber Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "robbin_robin": {
        name: "Robbin Robin",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "robin_nottingham_raiders": {
        name: "Robin - Nottingham Raiders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "robin_sherwood_marauders": {
        name: "Robin - Sherwood Marauders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "robospin": {
        name: "Robospin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "rocco_gallo": {
        name: "Rocco Gallo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rock_star_santa_multimax": {
        name: "Rock Star Santa MultiMax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "rock_the_reels_megaways": {
        name: "Rock the Reels Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "rock_vegas": {
        name: "Rock Vegas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rocket_blast_megaways": {
        name: "Rocket Blast Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rocket_eruption_triple_blast": {
        name: "Rocket Eruption Triple Blast",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "rocket_fellas_inc": {
        name: "Rocket Fellas Inc",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "rocket_reels": {
        name: "Rocket Reels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "roll_the_dice": {
        name: "Roll the Dice",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "rolling_in_treasures": {
        name: "Rolling in Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rolling_roger": {
        name: "Rolling Roger",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "roman_empire": {
        name: "Roman Empire",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "roman_glory": {
        name: "Roman Glory",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "roman_legion": {
        name: "Roman Legion",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_deluxe": {
        name: "Roman Legion Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_extreme": {
        name: "Roman Legion Extreme",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "roman_legion_flaming_link": {
        name: "Roman Legion Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "romanian_roulette": {
        name: "Romanian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "rome_fight_for_gold_20000x": {
        name: "Rome Fight for Gold 20000x",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "rome_the_conquerors": {
        name: "Rome - The Conquerors",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "ronaldinho_scores_shoot_and_win": {
        name: "Ronaldinho Scores  Shoot & Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ronaldinho_spins": {
        name: "Ronaldinho Spins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ronaldinhos_streetball_bonanza": {
        name: "Ronaldinho's Streetball Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ronin_stackways": {
        name: "Ronin Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "ronins_honour": {
        name: "Ronin's Honour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rooster_rumble": {
        name: "Rooster Rumble",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "rosy_orbit_treasure_turn": {
        name: "Rosy Orbit Treasure Turn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rot_stormo": {
        name: "Rot Stormo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "rotating_element": {
        name: "Rotating Element",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "rotiki": {
        name: "Rotiki",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "rotten": {
        name: "Rotten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "roulette": {
        name: "Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_arabic": {
        name: "Roulette Arabic",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "roulette_armenian": {
        name: "Roulette Armenian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "roulette_aurum": {
        name: "Roulette Aurum",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "roulette_brasileira": {
        name: "Roulette Brasileira",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "roulette_india": {
        name: "Roulette India",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_italia_tricolore": {
        name: "Roulette Italia Tricolore",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_kurdish": {
        name: "Roulette Kurdish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "roulette_latina": {
        name: "Roulette Latina",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_lobby": {
        name: "Roulette Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_macao": {
        name: "Roulette Macao",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_ruby": {
        name: "Roulette Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "roulette_turkish": {
        name: "Roulette Turkish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "roulette_vision_vip": {
        name: "Roulette Vision VIP",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "royal_7_xxl": {
        name: "Royal 7 XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_beellion_hold_and_win": {
        name: "Royal Beellion Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_coins_2_hold_and_win": {
        name: "Royal Coins 2: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "royal_coins_hold_and_win": {
        name: "Royal Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "royal_easter": {
        name: "Royal Easter",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_express_hold_and_win": {
        name: "Royal Express Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "royal_fortunator_hold_and_win": {
        name: "Royal Fortunator: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "royal_fruits_multilines": {
        name: "Royal Fruits MultiLines",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_highroad": {
        name: "Royal High-Road",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_joker_hold_and_win": {
        name: "Royal Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "royal_masquerade": {
        name: "Royal Masquerade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "royal_roulette_500x": {
        name: "Royal Roulette 500x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "royal_seven": {
        name: "Royal Seven",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_deluxe": {
        name: "Royal Seven Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_flaming_link": {
        name: "Royal Seven Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_ultra": {
        name: "Royal Seven Ultra",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_ultra_flaming_link": {
        name: "Royal Seven Ultra Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_xxl": {
        name: "Royal Seven XXL",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_xxl_easter_edition": {
        name: "Royal Seven XXL Easter Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_seven_xxl_flaming_link": {
        name: "Royal Seven XXL Flaming Link",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "royal_wins": {
        name: "Royal Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "royale_seven_deluxe_xxl_deluxe": {
        name: "Royale Seven Deluxe XXL Deluxe",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "ruby_rush": {
        name: "Ruby Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "rudis": {
        name: "Rudis",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "rudolphs_gone_rogue": {
        name: "Rudolph's Gone Rogue",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "ruff_heist": {
        name: "Ruff Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "ruffled_up": {
        name: "Ruffled Up",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "rugby_star": {
        name: "Rugby Star",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "rugby_star_deluxe": {
        name: "Rugby Star Deluxe",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "rujak_bonanza": {
        name: "Rujak Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "rum_and_raiders": {
        name: "Rum and Raiders",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "running_sushi": {
        name: "Running Sushi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "russian_roulette": {
        name: "Russian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "rust_world": {
        name: "Rust World",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "rusty_and_curly": {
        name: "Rusty and Curly",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sabaton": {
        name: "Sabaton",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sacred_buffalo": {
        name: "Sacred Buffalo",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "safari_gold_megaways": {
        name: "Safari Gold Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "safari_king": {
        name: "Safari King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "safari_of_wealth": {
        name: "Safari of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "safari_sun": {
        name: "Safari Sun",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "safari_wilds": {
        name: "Safari Wilds",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "sahara_nights": {
        name: "Sahara Nights",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "sails_of_fortune": {
        name: "Sails of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "sails_of_gold": {
        name: "Sails of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sails_of_riches": {
        name: "Sails of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "saint_nicked_2": {
        name: "Saint Nicked 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "saint_nicked_3_present_tense": {
        name: "Saint Nicked 3 Present Tense",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "sakura_fortune": {
        name: "Sakura Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sakura_fortune_2": {
        name: "Sakura Fortune 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sakura_fortune_epic_bloom": {
        name: "Sakura Fortune Epic Bloom",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sakura_riches_60": {
        name: "Sakura Riches 60",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "samba_carnival": {
        name: "Samba Carnival",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "samurai_code": {
        name: "Samurai Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "samurai_ikusa": {
        name: "Samurai Ikusa",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "sanatorium_secrets": {
        name: "Sanatorium Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sand_and_ashes": {
        name: "Sand and Ashes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sands_of_destiny": {
        name: "Sands of Destiny",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "sands_of_eternity": {
        name: "Sands of Eternity",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "sands_of_eternity_2": {
        name: "Sands of Eternity 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "santa": {
        name: "Santa",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santa_in_vegas": {
        name: "Santa in Vegas",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "santa_yetti": {
        name: "Santa Yetti",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "santas_big_bash_megaways": {
        name: "Santa's Big Bash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "santas_express_hold_and_win": {
        name: "Santa's Express Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "santas_gift_rush": {
        name: "Santa's Gift Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "santas_great_gifts": {
        name: "Santa's Great Gifts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santas_inn": {
        name: "Santa's Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "santas_sack": {
        name: "Santa's Sack",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "santas_slay": {
        name: "Santa's Slay",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santas_snowball_smash_instant_win": {
        name: "Santas Snowball Smash Instant Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "santas_stack": {
        name: "Santa's Stack",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "santas_village": {
        name: "Santa's Village",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "santas_wonderland": {
        name: "Santa's Wonderland",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "santas_xmas_rush": {
        name: "Santa’s Xmas Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "savage_buffalo_spirit": {
        name: "Savage Buffalo Spirit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "savage_buffalo_spirit_megaways": {
        name: "Savage Buffalo Spirit Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "savanna_moon": {
        name: "Savanna Moon",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "savannah_king": {
        name: "Savannah King",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "savannah_strike": {
        name: "Savannah Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "savannah_strike_extra": {
        name: "Savannah Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "scales_of_dead": {
        name: "Scales of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scarab_rising_megaways": {
        name: "Scarab Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "scepter_of_anubis": {
        name: "Scepter of Anubis",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "scopa": {
        name: "Scopa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "scourge_of_rome": {
        name: "Scourge of Rome",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scratch_bronze": {
        name: "SCRATCH! Bronze",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratch_gold": {
        name: "SCRATCH! Gold",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratch_platinum": {
        name: "SCRATCH! Platinum",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratch_silver": {
        name: "SCRATCH! Silver",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratchy": {
        name: "Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratchy_big": {
        name: "Scratchy Big",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scratchy_mini": {
        name: "Scratchy Mini",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "scroll_of_dead": {
        name: "Scroll of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scroll_of_seth": {
        name: "Scroll of Seth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "scrooge": {
        name: "Scrooge",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "scruffy_scallywags": {
        name: "Scruffy Scallywags",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "sea_fantasy": {
        name: "Sea Fantasy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sea_hunter": {
        name: "Sea Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sea_of_plenty": {
        name: "Sea of Plenty",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "season_of_fortune": {
        name: "Season of Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "seasons": {
        name: "Seasons",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "second_strike": {
        name: "Second Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "secret_bar_multidice_x": {
        name: "Secret Bar Multidice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "secret_book_of_amun_ra": {
        name: "Secret Book of Amun Ra",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "secret_city_gold": {
        name: "Secret City Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "secret_of_dead": {
        name: "Secret of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "secrets_of_cleopatra": {
        name: "Secrets of Cleopatra",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "serpent_shrine": {
        name: "Serpent Shrine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "sevens_and_books": {
        name: "Sevens & Books",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sevens_and_fruits": {
        name: "Sevens & Fruits",
        provider: "Playson",
        providerSlug: "playson"
    },
    "sevens_and_fruits_20_lines": {
        name: "Sevens and Fruits: 20 lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "sevens_and_jok3rs": {
        name: "Sevens and Jok3rs",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "sevens_and_suns": {
        name: "Sevens & Suns",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "sevens_fire": {
        name: "Sevens Fire",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sevens_high": {
        name: "Sevens High",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sevens_high_ultra": {
        name: "Sevens High Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sew": {
        name: "Sew",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadow_summoner_elementals": {
        name: "Shadow Summoner Elementals",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "shamrock_holmes_megaways": {
        name: "Shamrock Holmes Megaways",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "shamrock_miner": {
        name: "Shamrock Miner",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shamrock_quest": {
        name: "Shamrock Quest",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shaolin_fortunes": {
        name: "Shaolin Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shaolin_fortunes_100": {
        name: "Shaolin Fortunes 100",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shaolin_master": {
        name: "Shaolin Master",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "shaolin_soccer": {
        name: "Shaolin Soccer",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "shaolins_tiger": {
        name: "Shaolin's Tiger",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "shark_and_spark_hold_and_win": {
        name: "Shark and Spark Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "shark_feast": {
        name: "Shark Feast",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shark_frenzy": {
        name: "Shark Frenzy",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "shark_hunter": {
        name: "Shark Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "shark_wash": {
        name: "Shark Wash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "shave_the_beard": {
        name: "Shave the Beard",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "shave_the_sheep": {
        name: "Shave the Sheep",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sheeple": {
        name: "Sheeple",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "sheriff_colt": {
        name: "Sheriff Colt",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "sherlock_a_scandal_in_bohemia": {
        name: "Sherlock: A Scandal in Bohemia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sherwood_gold": {
        name: "Sherwood Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shield_of_sparta": {
        name: "Shield Of Sparta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shields_of_gold_valkyrie_hold_and_win": {
        name: "Shields of Gold Valkyrie Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "shields_of_lambda": {
        name: "Shields of Lambda",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "shifting_seas": {
        name: "Shifting Seas",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "shimmering_woods": {
        name: "Shimmering Woods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "shining_hot_100": {
        name: "Shining Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_20": {
        name: "Shining Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_40": {
        name: "Shining Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shining_hot_5": {
        name: "Shining Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "shippy_d_pop": {
        name: "Shippy D Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "shogun_of_time": {
        name: "Shogun of Time",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "shoguns_land": {
        name: "Shogun's Land",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "shoguns_secret": {
        name: "Shogun's Secret",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sic_bo": {
        name: "Sic Bo",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "sic_bo_lobby": {
        name: "Sic Bo Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "sienna_steele": {
        name: "Sienna Steele",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "silicon_spinners": {
        name: "Silicon Spinners",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "simply_the_best": {
        name: "Simply the Best",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sinbad": {
        name: "Sinbad",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sir_blingalot": {
        name: "Sir Blingalot",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "sirens_kingdom": {
        name: "Siren's Kingdom",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sirens_spell": {
        name: "Siren's Spell",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "sisters_of_the_sun": {
        name: "Sisters of The Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sixsixsix": {
        name: "SixSixSix",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sizable_win": {
        name: "Sizable Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sizzling_777": {
        name: "Sizzling 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_777_deluxe": {
        name: "Sizzling 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_bells": {
        name: "Sizzling Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs": {
        name: "Sizzling Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs_extremely_light": {
        name: "Sizzling Eggs Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs_grand_gold_edition": {
        name: "Sizzling Eggs Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_eggs_grand_platinum_edition": {
        name: "Sizzling Eggs Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_kindom_bison": {
        name: "Sizzling Kindom: Bison",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_moon": {
        name: "Sizzling Moon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sizzling_spins": {
        name: "Sizzling Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "skaterboy": {
        name: "SkaterBoy",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "skull_kings_treasure": {
        name: "Skull King's Treasure",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "skulls_up": {
        name: "Skulls UP!",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sky_barons": {
        name: "Sky Barons",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "skylight_wonders": {
        name: "Skylight Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "slashimi": {
        name: "Slashimi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "slayers_inc": {
        name: "Slayers Inc",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sleeping_dragon": {
        name: "Sleeping Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "slider": {
        name: "Slider",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "slime_party": {
        name: "Slime Party",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "slot_jam": {
        name: "Slot Jam",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "slot_machine": {
        name: "Slot Machine",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sloth_tumble": {
        name: "Sloth Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "slugger_time": {
        name: "Slugger Time",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "smoking_dragon": {
        name: "Smoking Dragon",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "smoking_hot_fortunes": {
        name: "Smoking Hot Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "smoking_hot_fruits": {
        name: "Smoking Hot Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_hot_fruits_20_lines": {
        name: "Smoking Hot Fruits 20 Lines",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_hot_fruits_stacks": {
        name: "Smoking Hot Fruits Stacks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_hot_fruits_wild_respins": {
        name: "Smoking Hot Fruits Wild Respins",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "smoking_pistols": {
        name: "Smoking Pistols",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "smugglers_cove": {
        name: "Smugglers Cove",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snake_arena": {
        name: "Snake Arena",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "snake_arena_2": {
        name: "Snake Arena 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "snakes_and_ladders_live": {
        name: "Snakes & Ladders Live",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "snakes_and_ladders_megadice": {
        name: "Snakes and Ladders Megadice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snakes_and_ladders_snake_eyes": {
        name: "Snakes & Ladders - Snake Eyes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snoop_dogg_dollars": {
        name: "Snoop Dogg Dollars",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "snow_party": {
        name: "Snow Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "snow_scratcher": {
        name: "Snow Scratcher",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sobeks_godly_spins": {
        name: "Sobek's Godly Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "soccer_hold_and_blitz": {
        name: "Soccer Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "soccer_striker": {
        name: "Soccer Striker",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "soccermania": {
        name: "Soccermania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "soccerx_vf": {
        name: "SoccerX VF",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "soju_bomb": {
        name: "Soju Bomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "solar_king": {
        name: "Solar King",
        provider: "Playson",
        providerSlug: "playson"
    },
    "solar_nova": {
        name: "Solar Nova",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "solar_nova_megaways": {
        name: "Solar Nova Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "solar_queen": {
        name: "Solar Queen",
        provider: "Playson",
        providerSlug: "playson"
    },
    "solar_temple": {
        name: "Solar Temple",
        provider: "Playson",
        providerSlug: "playson"
    },
    "songkran_splash": {
        name: "Songkran Splash",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "sonic_reels": {
        name: "Sonic Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sos": {
        name: "S.O.S!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "space_cows_to_the_moon": {
        name: "Space Cows to the Moo'n",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "space_fortune": {
        name: "Space Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "space_gem": {
        name: "Space Gem",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "space_goonz": {
        name: "Space Goonz",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "space_jammers": {
        name: "Space Jammers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "space_miners": {
        name: "Space Miners",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "space_race": {
        name: "Space Race",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "space_sam_walk_and_win": {
        name: "Space Sam Walk and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "space_spins": {
        name: "Space Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "spark_of_genius": {
        name: "Spark of Genius",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sparkling_777s": {
        name: "Sparkling 777s",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "sparky_and_shortz": {
        name: "Sparky and Shortz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sparky_and_shortz_hidden_joules": {
        name: "Sparky & Shortz Hidden Joules",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sparta": {
        name: "Sparta",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "spartan_king": {
        name: "Spartan King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spear_of_athena": {
        name: "Spear of Athena",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "spectra": {
        name: "Spectra",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "spectrum": {
        name: "Spectrum",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "speed_auto_roulette": {
        name: "Speed Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_baccarat": {
        name: "Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_blackjack": {
        name: "Speed Blackjack",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "speed_champion": {
        name: "Speed Champion",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "speed_freaks": {
        name: "Speed Freaks",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "speed_roulette": {
        name: "Speed Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "speed_winner": {
        name: "Speed Winner",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "spell_forged": {
        name: "Spell Forged",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "spellbinding_mystery": {
        name: "Spellbinding Mystery",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spellmaster": {
        name: "Spellmaster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sphinx_treasure": {
        name: "Sphinx Treasure",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "spice_spice_baby": {
        name: "Spice Spice Baby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spin_and_score_megaways": {
        name: "Spin & Score Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spin_and_spell": {
        name: "Spin And Spell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "spin_party": {
        name: "Spin Party",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spina_colada": {
        name: "Spina Colada",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "spinball": {
        name: "Spinball",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "spinfection": {
        name: "Spinfection",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "spinions": {
        name: "Spinions",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "spinions_xmas_party": {
        name: "Spinions X-mas Party",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "spinman": {
        name: "Spinman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "spinman_hv": {
        name: "Spinman H.V.",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "spinnin_records_into_the_beat": {
        name: "Spinnin Records into the Beat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spinnin_records_raving_reels": {
        name: "Spinnin Records Raving Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "spino_cricket": {
        name: "Spino Cricket",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "spinxiety": {
        name: "Spinxiety",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "spirit_of_adventure": {
        name: "Spirit of Adventure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "spirit_of_the_beast": {
        name: "Spirit of the Beast",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "spirit_wolf_wins": {
        name: "Spirit Wolf Wins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "spirited_wonders": {
        name: "Spirited Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "splash_of_riches": {
        name: "Splash of Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "split_happens": {
        name: "Split Happens",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "spooktacular_bonanza": {
        name: "Spooktacular Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "spooky_scary_scratchy": {
        name: "Spooky Scary Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "spring_break": {
        name: "Spring Break",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "squealin_riches": {
        name: "Squealin' Riches",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "stack_em_scratch": {
        name: "Stack 'em Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stackem": {
        name: "Stack'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stadium_of_riches": {
        name: "Stadium of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "stampede_bonanza": {
        name: "Stampede Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "stampeding_strike": {
        name: "Stampeding Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "star_bounty": {
        name: "Star Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "star_joker": {
        name: "Star Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "star_pirates_code": {
        name: "Star Pirates Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "star_stash_wilds_7s": {
        name: "Star Stash Wilds 7s",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "star_treasure": {
        name: "Star Treasure",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "star_trek_the_next_generation": {
        name: "Star Trek The Next Generation",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "starfire_fortunes_tophit": {
        name: "Starfire Fortunes TopHit",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "starlight_archer_1000": {
        name: "Starlight Archer 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_christmas": {
        name: "Starlight Christmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess": {
        name: "Starlight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess_1000": {
        name: "Starlight Princess 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess_pachi": {
        name: "Starlight Princess Pachi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlight_princess_super_scatter": {
        name: "Starlight Princess Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "starlite_fruits": {
        name: "Starlite Fruits",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "starspell": {
        name: "StarSpell",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "starz_megaways": {
        name: "Starz Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "static_nightmare": {
        name: "Static Nightmare",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "steamin_reels": {
        name: "Steamin Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "steampunk_plinko": {
        name: "Steampunk Plinko",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "steamrunners": {
        name: "Steamrunners",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "steamworks_gears_of_fortune": {
        name: "Steamworks Gears of Fortune",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "steamworks_the_workshop": {
        name: "Steamworks the Workshop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "stellar_ways": {
        name: "Stellar Ways",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "stepping_diamonds": {
        name: "Stepping Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "stickermania_wild_rumble": {
        name: "Stickermania Wild Rumble",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "stickman_cash": {
        name: "Stickman Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sticky_bandits": {
        name: "Sticky Bandits",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_3_most_wanted": {
        name: "Sticky Bandits 3: Most Wanted",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_thunder_rail": {
        name: "Sticky Bandits Thunder Rail",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_trail_of_blood": {
        name: "Sticky Bandits Trail of Blood",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_unchained": {
        name: "Sticky Bandits Unchained",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bandits_wild_return": {
        name: "Sticky Bandits: Wild Return",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "sticky_bees": {
        name: "Sticky Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sticky_diamonds": {
        name: "Sticky Diamonds",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sticky_diamonds_easter_egg": {
        name: "Sticky Diamonds Easter Egg",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sticky_joker": {
        name: "Sticky Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "stormborn": {
        name: "Stormborn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "stormforged": {
        name: "Stormforged",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "strawberry_cocktail": {
        name: "Strawberry Cocktail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "street_magic": {
        name: "Street Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "street_ninja": {
        name: "Street Ninja",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "street_power": {
        name: "Street Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "street_racer": {
        name: "Street Racer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "strength_of_hercules": {
        name: "Strength of Hercules",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "striking_hot_5": {
        name: "Striking Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "suck": {
        name: "Suck",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "sugar_craze_bonanza": {
        name: "Sugar Craze Bonanza",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "sugar_merge_up": {
        name: "Sugar Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sugar_mix": {
        name: "Sugar Mix",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sugar_rush": {
        name: "Sugar Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_rush_1000": {
        name: "Sugar Rush 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_rush_super_scatter": {
        name: "Sugar Rush Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_rush_xmas": {
        name: "Sugar Rush Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_supreme_powernudge": {
        name: "Sugar Supreme Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sugar_teddy": {
        name: "Sugar Teddy",
        provider: "Playson",
        providerSlug: "playson"
    },
    "sultan_spins": {
        name: "Sultan Spins",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "summer_scratch": {
        name: "Summer Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "sumo_supreme_megaways": {
        name: "Sumo Supreme Megaways™",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sun_of_fortune": {
        name: "Sun of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "sun_princess": {
        name: "Sun Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "suncatcher_gigablox": {
        name: "Suncatcher Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "sunny_fruits_2_hold_and_win": {
        name: "Sunny Fruits 2: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "sunny_fruits_hold_and_win": {
        name: "Sunny Fruits: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "sunny_sevens": {
        name: "Sunny Sevens",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "sunny_shores": {
        name: "Sunny Shores",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "sunset_delight": {
        name: "Sunset Delight",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "super_7_winner": {
        name: "Super 7 Winner",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "super_7s": {
        name: "Super 7s",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_duper": {
        name: "Super Duper",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "super_duper_cherry": {
        name: "Super Duper Cherry",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "super_egg_hunt": {
        name: "Super Egg Hunt",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "super_flip": {
        name: "Super Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "super_flip_deluxe": {
        name: "Super Flip Deluxe",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "super_fruit_smash": {
        name: "Super Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "super_golf_drive": {
        name: "Super Golf Drive",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "super_gummy_strike": {
        name: "Super Gummy Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_hot": {
        name: "Super Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "super_joker": {
        name: "Super Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_pink_joker_hold_and_win": {
        name: "Super Pink Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "super_rainbow_megaways": {
        name: "Super Rainbow Megaways",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "super_sake": {
        name: "Super Sake",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "super_sevens": {
        name: "Super Sevens",
        provider: "Oryx Gaming",
        providerSlug: "oryx-gaming"
    },
    "super_strike": {
        name: "Super Strike",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "super_tiki_strike": {
        name: "Super Tiki Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "super_twister": {
        name: "Super Twister",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "super_wheel": {
        name: "Super Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "super_wild_diamonds": {
        name: "Super Wild Diamonds",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "super_wildrix": {
        name: "Super Wildrix",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "super_x": {
        name: "Super X",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "supercharged_clovers_hold_and_win": {
        name: "Supercharged Clovers: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "supermarket_spree": {
        name: "Supermarket Spree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "superstar_sevens": {
        name: "Superstar Sevens",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "surrender_multihand_blackjack": {
        name: "Surrender Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sweet_27": {
        name: "Sweet 27",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy": {
        name: "Sweet Alchemy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy_100": {
        name: "Sweet Alchemy 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy_2": {
        name: "Sweet Alchemy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_alchemy_bingo": {
        name: "Sweet Alchemy Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "sweet_bonanza": {
        name: "Sweet Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_1000": {
        name: "Sweet Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_2500": {
        name: "Sweet Bonanza 2500",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_candyland": {
        name: "Sweet Bonanza CandyLand",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "sweet_bonanza_dice": {
        name: "Sweet Bonanza Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_super_scatter": {
        name: "Sweet Bonanza Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_bonanza_xmas": {
        name: "Sweet Bonanza Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_candy_blitz": {
        name: "Sweet Candy Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_cash_megaways": {
        name: "Sweet Candy Cash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_cash_megaways_deluxe": {
        name: "Sweet Candy Cash Megaways Deluxe",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_cash_stash": {
        name: "Sweet Candy Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_candy_christmas": {
        name: "Sweet Candy Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "sweet_craze": {
        name: "Sweet Craze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_crush": {
        name: "Sweet Crush",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sweet_gold_3000": {
        name: "Sweet Gold 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "sweet_gummy": {
        name: "Sweet Gummy",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "sweet_jar_combo": {
        name: "Sweet Jar Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "sweet_jar_xmas_combo": {
        name: "Sweet Jar Xmas Combo",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "sweet_kingdom": {
        name: "Sweet Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_powernudge": {
        name: "Sweet Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_rush_bonanza": {
        name: "Sweet Rush Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sweet_rush_megaways": {
        name: "Sweet Rush Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sweet_samurai": {
        name: "Sweet Samurai",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "sweet_spotz": {
        name: "Sweet Spotz",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "sweet_success_megaways": {
        name: "Sweet Success Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "sweetopia_royale": {
        name: "Sweetopia Royale",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "swift_roulette_8_in_one": {
        name: "Swift Roulette 8 IN ONE",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "swoll": {
        name: "Swoll",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "sword_of_ares": {
        name: "Sword of Ares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "sword_of_arthur": {
        name: "Sword of Arthur",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "sword_of_fortune": {
        name: "Sword of Fortune",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "sword_of_khans": {
        name: "Sword of Khans",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "sword_of_shoguns": {
        name: "Sword of Shoguns",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "symbols_of_egypt": {
        name: "Symbols of Egypt",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "synchro": {
        name: "Synchro",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "syncronite": {
        name: "Syncronite",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "taberna_de_los_muertos": {
        name: "Taberna De Los Muertos",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "taberna_de_los_muertos_ultra": {
        name: "Taberna De Los Muertos Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tai_the_toad": {
        name: "Tai the Toad",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "taiko_beats": {
        name: "Taiko Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "take_5": {
        name: "Take 5",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "take_5_christmas_edition": {
        name: "Take 5 Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "tale_of_kyubiko": {
        name: "Tale Of Kyubiko",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tales_of_asgard_freyas_wedding": {
        name: "Tales of Asgard: Freya's Wedding",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tales_of_asgard_lokis_fortune": {
        name: "Tales of Asgard: Loki’s Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tales_of_dr_dolittle": {
        name: "Tales of Dr. Dolittle",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "tales_of_mithrune_syns_fortune": {
        name: "Tales of Mithrune Syn's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tally_ho": {
        name: "Tally Ho",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "tango_of_chaos": {
        name: "Tango of Chaos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "tao_tree_coins": {
        name: "Tao Tree Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tasty_bonanza": {
        name: "Tasty Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tasty_bonanza_1000": {
        name: "Tasty Bonanza 1,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tasty_trailz": {
        name: "Tasty Trailz",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "tasty_treats": {
        name: "Tasty Treats",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "team_win_fast": {
        name: "Team Win Fast",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "team_winfast": {
        name: "Team Winfast",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "techno_tumble": {
        name: "Techno Tumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "teen_patti": {
        name: "Teen Patti",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "telly_reels": {
        name: "Telly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "templar_tumble": {
        name: "Templar Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "temple_guardians": {
        name: "Temple Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "temple_of_akhet": {
        name: "Temple of Akhet",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "temple_of_paw": {
        name: "Temple of Paw",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "temple_of_prosperity": {
        name: "Temple of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "temple_of_tollan": {
        name: "Temple of Tollan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "temple_of_torment": {
        name: "Temple of Torment",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "temple_of_treasures_megaways": {
        name: "Temple of Treasures Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "temple_stacks_splitz": {
        name: "Temple Stacks: Splitz",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "temple_treasure_holdandwin": {
        name: "Temple Treasure Hold&Win",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "temple_tumble_megaways": {
        name: "Temple Tumble MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "temujin_treasures": {
        name: "Temujin Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ternion": {
        name: "Ternion",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "testament": {
        name: "Testament",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "thai_baccarat": {
        name: "Thai Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "thai_river_wonders": {
        name: "Thai River Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "thai_speed_baccarat": {
        name: "Thai Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "thats_rich": {
        name: "That’s Rich",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_alter_ego": {
        name: "The Alter Ego",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_big_dawgs": {
        name: "The Big Dawgs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_big_deal": {
        name: "The Big Deal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_big_deal_deluxe": {
        name: "The Big Deal Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_big_dog_house": {
        name: "The Big Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_big_hit": {
        name: "The Big Hit",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "the_bingo_spot": {
        name: "The Bingo Spot",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "the_book_beyond": {
        name: "The Book Beyond",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_book_beyond_2": {
        name: "The Book Beyond 2",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_bowery_boys": {
        name: "The Bowery Boys",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_chillies": {
        name: "The Chillies",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_choice_is_yours_megaways": {
        name: "The Choice is Yours Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "the_count": {
        name: "The Count",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_cup": {
        name: "The Cup",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "the_dead_escape": {
        name: "The Dead Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_dog_house": {
        name: "The Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_dice_show": {
        name: "The Dog House Dice Show",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_dog_or_alive": {
        name: "The Dog House – Dog or Alive",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_megaways": {
        name: "The Dog House Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_multihold": {
        name: "The Dog House Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_muttley_crew": {
        name: "The Dog House – Muttley Crew",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dog_house_royal_hunt": {
        name: "The Dog House Royal Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_dragon_tiger": {
        name: "The Dragon Tiger",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_eternal_widow": {
        name: "The Eternal Widow",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "the_expandable": {
        name: "The Expandable",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_faces_of_freya": {
        name: "The Faces of Freya",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_falcon_huntress": {
        name: "The Falcon Huntress",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "the_goat": {
        name: "The G.O.A.T",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "the_golden_mummy_hold_and_win": {
        name: "The Golden Mummy Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "the_grand": {
        name: "The Grand",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "the_grape_escape": {
        name: "The Grape Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "the_great_chicken_escape": {
        name: "The Great Chicken Escape",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_great_icescape": {
        name: "The Great Icescape",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "the_great_pigsby": {
        name: "The Great Pigsby",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_great_pigsby_megapays": {
        name: "The Great Pigsby Megapays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_great_pigsby_megaways": {
        name: "The Great Pigsby MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_great_stickup": {
        name: "The Great Stick-Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_green_knight": {
        name: "The Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_green_knight_oath_of_thorns": {
        name: "The Green Knight Oath of Thorns",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_grim_reaper": {
        name: "The Grim Reaper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "the_gunman_of_goldwood": {
        name: "The Gunman of Goldwood",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "the_hand_of_midas": {
        name: "The Hand of Midas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_knight_king": {
        name: "The Knight King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_last_sundown": {
        name: "The Last Sundown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_legend_of_musashi": {
        name: "The Legend of Musashi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "the_luxe": {
        name: "The Luxe",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_mighty_king": {
        name: "The Mighty King",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "the_mighty_toro": {
        name: "The Mighty Toro",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_money_men_megaways": {
        name: "The Money Men Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_one_armed_bandit": {
        name: "The One Armed Bandit",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "the_paying_piano_club": {
        name: "The Paying Piano Club",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_perfect_scratch": {
        name: "The Perfect Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "the_queens_banquet": {
        name: "The Queen's Banquet",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "the_red_queen": {
        name: "The Red Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_return_of_the_green_knight": {
        name: "The Return of the Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_rift": {
        name: "The Rift",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "the_royal_family": {
        name: "The Royal Family",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "the_secret_of_ba": {
        name: "The Secret of BA",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "the_soapranos": {
        name: "The Soapranos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "the_sword_and_the_grail": {
        name: "The Sword and The Grail",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_sword_and_the_grail_excalibur": {
        name: "The Sword and the Grail Excalibur",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_tiger_warrior": {
        name: "The Tiger Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_tumbles": {
        name: "The Tumbles",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "the_tweety_house": {
        name: "The Tweety House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_twisted_circus": {
        name: "The Twisted Circus",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "the_ultimate_5": {
        name: "The Ultimate 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_vault_chase": {
        name: "The Vault Chase",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "the_wild_chase": {
        name: "The Wild Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "the_wild_class": {
        name: "The Wild Class",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "the_wild_gang": {
        name: "The Wild Gang",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_wild_machine": {
        name: "The Wild Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "the_wild_wings_of_phoenix": {
        name: "The Wild Wings of Phoenix",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_wild_wings_of_phoenix_deluxe": {
        name: "The Wild Wings of Phoenix Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "the_wildos": {
        name: "The Wildos",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "the_wildwood_curse": {
        name: "The Wildwood Curse",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "theseus_rises": {
        name: "Theseus Rises",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "thorfinns_journey": {
        name: "Thorfinn's Journey",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "three_cards": {
        name: "Three Cards",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "three_crazy_piggies": {
        name: "Three Crazy Piggies",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "three_samurai": {
        name: "Three Samurai",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "three_star_fortune": {
        name: "Three Star Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "thrones_of_persia": {
        name: "Thrones of Persia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "thunder_coins_hold_and_win": {
        name: "Thunder Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "thunder_coins_xxl_multicoin": {
        name: "Thunder Coins XXL Multicoin",
        provider: "Playson",
        providerSlug: "playson"
    },
    "thunder_eagle_hold_and_win_10000": {
        name: "Thunder Eagle Hold and Win 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "thunder_hawk": {
        name: "Thunder Hawk",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "thunder_of_thor": {
        name: "Thunder Of Thor",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "thunder_wheel": {
        name: "Thunder Wheel",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "thunderscreech": {
        name: "Thunderscreech",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "thunderstruck": {
        name: "Thunderstruck",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "thunderstruck_ii": {
        name: "Thunderstruck II",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "thunderstruck_stormchaser": {
        name: "Thunderstruck Stormchaser",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "thunderstruck_wild_lightning": {
        name: "Thunderstruck Wild Lightning",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "tic_tac_take": {
        name: "Tic Tac Take",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ticket_to_the_stars": {
        name: "Ticket to the Stars",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "tiger_kingdom": {
        name: "Tiger Kingdom",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tiger_legends": {
        name: "Tiger Legends",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "tiger_rush": {
        name: "Tiger Rush",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "tiger_scratch": {
        name: "Tiger Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "tiger_shrine": {
        name: "Tiger Shrine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tigers_glory": {
        name: "Tiger's Glory",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "tigers_glory_ultra": {
        name: "Tiger's Glory Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "tigers_ice": {
        name: "Tiger's Ice",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "tigers_treasures": {
        name: "Tiger's Treasures",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "tik_talkers": {
        name: "Tik Talkers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "tiki_pop": {
        name: "Tiki Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "tiki_thunder": {
        name: "Tiki Thunder",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "tiki_tiki_boom": {
        name: "Tiki Tiki Boom",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "tikipop_spooky_temples": {
        name: "TikiPop Spooky Temples",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "tile_master": {
        name: "Tile Master",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "timber_stacks": {
        name: "Timber Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "time_spinners": {
        name: "Time Spinners",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "time_travel_tigers": {
        name: "Time Travel Tigers",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "tiny_toads": {
        name: "Tiny Toads",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "tippy_tavern": {
        name: "Tippy Tavern",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "titan_strike": {
        name: "Titan Strike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tnt_bonanza": {
        name: "TNT Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tnt_bonanza_2": {
        name: "TNT Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "tnt_tumble": {
        name: "TNT Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "toads_bounty": {
        name: "Toad's Bounty",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "toki_time": {
        name: "Toki Time",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "tomb_of_dead_power_4_slots": {
        name: "Tomb of Dead: Power 4 slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "tomb_of_gold": {
        name: "Tomb of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tomb_of_gold_ii": {
        name: "Tomb of Gold II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tomb_of_gold_reimagined": {
        name: "Tomb of Gold Reimagined",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tome_of_madness_bingo": {
        name: "Tome Of Madness Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tooty_fruity_fruits": {
        name: "Tooty Fruity Fruits",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "top_dawg": {
        name: "Top Dawg$",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "torii_tumble": {
        name: "Torii Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tornado_power_hold_and_win": {
        name: "Tornado Power Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "toshi_video_club": {
        name: "Toshi Video Club",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "toshi_ways_club": {
        name: "Toshi Ways Club",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "totally_hot": {
        name: "Totally Hot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "totem_towers": {
        name: "Totem Towers",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "totem_warrior": {
        name: "Totem Warrior",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "totem_wonders": {
        name: "Totem Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "tower_of_pizza": {
        name: "Tower Of Pizza",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tower_of_power": {
        name: "Tower of Power",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "tower_tumble": {
        name: "Tower Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "towering_fortunes": {
        name: "Towering Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "track_n_gold": {
        name: "Track n' Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "trailblazer": {
        name: "Trailblazer",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "train_to_rio_grande": {
        name: "Train to Rio Grande",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "tramp_day": {
        name: "Tramp Day",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "tramp_day_trueways": {
        name: "Tramp Day Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "transformers": {
        name: "Transformers",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "trawler_fishin": {
        name: "Trawler Fishin'",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "treasure_diver": {
        name: "Treasure Diver",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "treasure_explorer": {
        name: "Treasure Explorer",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "treasure_horse": {
        name: "Treasure Horse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "treasure_hunter": {
        name: "Treasure Hunter",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "treasure_island": {
        name: "Treasure Island",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "treasure_labyrinth": {
        name: "Treasure Labyrinth",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "treasure_of_anubis": {
        name: "Treasure of Anubis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "treasure_palace": {
        name: "Treasure Palace",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "treasure_stacks": {
        name: "Treasure Stacks",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "treasure_stacks_wilds": {
        name: "Treasure Stacks Wilds",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "treasure_tomb": {
        name: "Treasure Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "treasure_tumble": {
        name: "Treasure Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "treasure_vault": {
        name: "Treasure Vault",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "treasure_wild": {
        name: "Treasure Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "treasures_of_aztec": {
        name: "Treasures of Aztec",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "treasures_of_fire": {
        name: "Treasures of Fire",
        provider: "Playson",
        providerSlug: "playson"
    },
    "treasures_of_kongar": {
        name: "Treasures of Kongar",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "treasures_of_lion_city": {
        name: "Treasures of Lion City",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "treasures_of_the_dead": {
        name: "Treasures of the Dead",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "treat_yo_elf": {
        name: "Treat Yo' Elf",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "treats_of_terror": {
        name: "Treats of Terror",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "tree_of_fortune": {
        name: "Tree of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "tree_of_riches": {
        name: "Tree of Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "trees_of_treasure": {
        name: "Trees of Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "trickstar_spins": {
        name: "Trickstar Spins",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "trinity_impact": {
        name: "Trinity Impact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "triple_action_cash_strike": {
        name: "Triple Action Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "triple_bar": {
        name: "Triple Bar",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "triple_christmas_gold": {
        name: "Triple Christmas Gold",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "triple_dragons": {
        name: "Triple Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_joker": {
        name: "Triple Joker",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "triple_launch_fortune_wild": {
        name: "Triple Launch Fortune Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "triple_pot_diamond": {
        name: "Triple Pot Diamond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_pot_gold": {
        name: "Triple Pot Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_pot_plinko_hercules": {
        name: "Triple Pot Plinko Hercules",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_royal_gold": {
        name: "Triple Royal Gold",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "triple_star": {
        name: "Triple Star",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "triple_thunder": {
        name: "Triple Thunder",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "triple_tigers": {
        name: "Triple Tigers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "triple_up": {
        name: "Triple Up",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "troll_hunters": {
        name: "Troll Hunters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "troll_hunters_2": {
        name: "Troll Hunters 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "trollfufu_bonanza": {
        name: "Trollfufu Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "trolls_bridge": {
        name: "Trolls Bridge",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "trolls_gold": {
        name: "Troll's Gold",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "tropical_thunder": {
        name: "Tropical Thunder",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "tropical_tiki": {
        name: "Tropical Tiki",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "truth": {
        name: "Truth",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "tuk_tuk_thailand": {
        name: "Tuk Tuk Thailand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "tundras_fortune": {
        name: "Tundra’s Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "turbo_play": {
        name: "Turbo Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "turkish_mega_roulette": {
        name: "Turkish Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "turkish_one_blackjack": {
        name: "Turkish ONE Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "turkish_roulette": {
        name: "Turkish Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "turning_totems": {
        name: "Turning Totems",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "tutstwister": {
        name: "TutsTwister",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "twentyone": {
        name: "Twenty-One",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "twilight_princess": {
        name: "Twilight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "twin_buffalo_hold_and_win": {
        name: "Twin Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "twisted_lab": {
        name: "Twisted Lab",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "twisted_turbine": {
        name: "Twisted Turbine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "tyrants_fall": {
        name: "Tyrant's Fall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "ufo_pyramids": {
        name: "UFO Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "ultimate_goal_blitz": {
        name: "Ultimate Goal Blitz",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "ultimate_hold_n_win": {
        name: "Ultimate Hold 'N' Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ultimate_slot_of_america": {
        name: "Ultimate Slot of America",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "ultimate_striker": {
        name: "Ultimate Striker",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "ultra_ace": {
        name: "Ultra Ace",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "ultra_buffalo_hold_and_win": {
        name: "Ultra Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ultra_burn": {
        name: "Ultra Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ultra_fruit_smash": {
        name: "Ultra Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "ultra_hold_and_spin": {
        name: "Ultra Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "ultras": {
        name: "Ultras",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "undead_fortune": {
        name: "Undead Fortune",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "undefeated_xerxes": {
        name: "Undefeated Xerxes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "unicorn_reels": {
        name: "Unicorn Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "usa_flip": {
        name: "USA Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "valentine_monchy": {
        name: "Valentine Monchy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "valentines_coins": {
        name: "Valentine's Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "valhalla": {
        name: "Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "valhalluck": {
        name: "Valhalluck",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "valkyries": {
        name: "Valkyries",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "valletta_megaways": {
        name: "Valletta Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "valley_of_the_dead_only_wins_boltlock": {
        name: "Valley of the Dead Only Wins BoltLock",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "valley_of_the_gods": {
        name: "Valley of the Gods",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "valley_of_the_gods_2": {
        name: "Valley of the Gods 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vampire_riches": {
        name: "Vampire Riches",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vampire_senpai": {
        name: "Vampire Senpai",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "vampires_charm": {
        name: "Vampire's Charm",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "vampires_fate": {
        name: "Vampire's Fate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "vampires_vs_wolves": {
        name: "Vampires vs Wolves",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "vampy_party": {
        name: "Vampy Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "van_helsings_book_of_the_undead": {
        name: "Van Helsing's Book Of The Undead",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "vault_of_fortune": {
        name: "Vault of Fortune",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vault_rush": {
        name: "Vault Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "vegas_ball_bonanza": {
        name: "Vegas Ball Bonanza",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vegas_fortune": {
        name: "Vegas Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "vegas_gold": {
        name: "Vegas Gold",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "vegas_hold_and_win": {
        name: "Vegas Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "vegas_hot": {
        name: "Vegas Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "vegas_hot_81": {
        name: "Vegas Hot 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "vegas_hot_spots": {
        name: "Vegas Hot spots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "vegas_joker": {
        name: "Vegas Joker",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "vegas_magic": {
        name: "Vegas Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "vegas_nights": {
        name: "Vegas Nights",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "vegas_reels_ii": {
        name: "Vegas Reels II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "vegas_wins": {
        name: "Vegas Wins",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "vending_machine": {
        name: "Vending Machine",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "video_poker": {
        name: "Video Poker",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "vietnamese_roulette": {
        name: "Vietnamese Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vietnamese_speed_baccarat": {
        name: "Vietnamese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "viking_apocalypse": {
        name: "Viking Apocalypse",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "viking_fall": {
        name: "Viking Fall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "viking_forge": {
        name: "Viking Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "viking_runecraft": {
        name: "Viking Runecraft",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "viking_runecraft_100": {
        name: "Viking Runecraft 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "viking_runecraft_bingo": {
        name: "Viking Runecraft Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "vikings_creed": {
        name: "Vikings Creed",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "vikings_go_berzerk": {
        name: "Vikings go Berzerk",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vikings_go_berzerk_reloaded": {
        name: "Vikings Go Berzerk: Reloaded",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vikings_go_to_egypt_wild_fight": {
        name: "Vikings Go To Egypt Wild Fight",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vikings_go_to_hell": {
        name: "Vikings Go To Hell",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vikings_go_to_valhalla": {
        name: "Vikings go to Valhalla",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vikings_go_to_vegas_wild_fight": {
        name: "Vikings go to Vegas Wild Fight",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vikings_go_wild": {
        name: "Vikings go Wild",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "vikings_plunder": {
        name: "Viking's Plunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "vikings_unleashed_megaways": {
        name: "Vikings Unleashed Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "vikings_unleashed_reloaded_megaways": {
        name: "Vikings Unleashed Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "vip_auto_roulette": {
        name: "VIP Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "vip_filthy_riches": {
        name: "VIP Filthy Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "vip_roulette": {
        name: "VIP Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "viper_city_heist": {
        name: "Viper City Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "virtual_football_pro": {
        name: "Virtual Football Pro",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "virtual_soccer": {
        name: "Virtual Soccer",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "virus_mania": {
        name: "Virus Mania",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "volatile_vikings": {
        name: "Volatile Vikings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "volatile_vikings_2": {
        name: "Volatile Vikings 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "volcano_goddess": {
        name: "Volcano Goddess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "volcano_riches": {
        name: "Volcano Riches",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "voodoo_hex": {
        name: "Voodoo Hex",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "voodoo_magic": {
        name: "Voodoo Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "voodoo_people": {
        name: "Voodoo People",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wacky_panda": {
        name: "Wacky Panda",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "waltz_beauty": {
        name: "Waltz Beauty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wanted_dead_or_a_wild": {
        name: "Wanted Dead or a Wild",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "wanted_outlaws": {
        name: "Wanted Outlaws",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "war": {
        name: "War",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "warp_wreckers_power_glyph": {
        name: "Warp Wreckers Power Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "warrior_ways": {
        name: "Warrior Ways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "water_blox": {
        name: "Water Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "waves_of_poseidon": {
        name: "Waves of Poseidon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "way_of_the_wolf_hold_and_win_extreme_10000": {
        name: "Way of the Wolf Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "ways_of_fortune": {
        name: "Ways Of Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "ways_of_the_qilin": {
        name: "Ways of the Qilin",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wbc_ring_of_riches": {
        name: "WBC Ring of Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wealth_inn": {
        name: "Wealth Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "weird_science": {
        name: "Weird Science",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "welcome_to_hell_81": {
        name: "Welcome To Hell 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "well_of_wonders": {
        name: "Well of Wonders",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "west_town": {
        name: "West Town",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "western_jack": {
        name: "Western Jack",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "western_wilds": {
        name: "Western Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "western_wilds_hold_and_win": {
        name: "Western Wilds Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "western_wilds_megaways": {
        name: "Western Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "what_a_hoot": {
        name: "What A Hoot",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "wheel": {
        name: "Wheel",
        provider: "Flush Originals",
        providerSlug: "flush-originals"
    },
    "wheel_of_happiness": {
        name: "Wheel of Happiness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wheel_of_luck_hold_and_win": {
        name: "Wheel of Luck Hold and Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wheel_of_mictlan": {
        name: "Wheel of Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wheel_ogold": {
        name: "Wheel O’Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "whisker_jones": {
        name: "Whisker jones",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "whispering_winds": {
        name: "Whispering Winds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "whole_lotta_honey": {
        name: "Whole Lotta Honey",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "wicked_whiskers": {
        name: "Wicked Whiskers",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "wicked_witch": {
        name: "Wicked Witch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wild_ape_3258": {
        name: "Wild Ape #3258",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_bandito": {
        name: "Wild Bandito",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_bandolier": {
        name: "Wild Bandolier",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_bard": {
        name: "Wild Bard",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "wild_beach_party": {
        name: "Wild Beach Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_beans": {
        name: "Wild Beans",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_bison_charge": {
        name: "Wild Bison Charge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_blood": {
        name: "Wild Blood",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_blood_2": {
        name: "Wild Blood 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_booster": {
        name: "Wild Booster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_bounty_showdown": {
        name: "Wild Bounty Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_card_gang": {
        name: "Wild Card Gang",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_cash": {
        name: "Wild Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_cash_dice": {
        name: "Wild Cash Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_cash_x9990": {
        name: "Wild Cash X9990",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_catch_new": {
        name: "Wild Catch (New)",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "wild_cauldron": {
        name: "Wild Cauldron",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_celebrity_bus_megaways": {
        name: "Wild Celebrity Bus Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_chapo": {
        name: "Wild Chapo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wild_chapo_2": {
        name: "Wild Chapo 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wild_chase_tokyo_go": {
        name: "Wild Chase: Tokyo Go",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_chicago": {
        name: "Wild Chicago",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_clusters": {
        name: "Wild Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_coaster": {
        name: "Wild Coaster",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_depths": {
        name: "Wild Depths",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_diamond_7x": {
        name: "Wild Diamond 7x",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "wild_duel": {
        name: "Wild Duel",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "wild_falls": {
        name: "Wild Falls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_falls_2": {
        name: "Wild Falls 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_fireworks": {
        name: "Wild Fireworks",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wild_flow": {
        name: "Wild Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wild_frames": {
        name: "Wild Frames",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_girls": {
        name: "Wild Girls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_guns": {
        name: "Wild Guns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_harlequin": {
        name: "Wild Harlequin",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_heart": {
        name: "Wild Heart",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_heist_at_peacock_manor": {
        name: "Wild Heist at Peacock Manor",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "wild_hike": {
        name: "Wild Hike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wild_hop_and_drop": {
        name: "Wild Hop & Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_hour_league": {
        name: "Wild Hour League",
        provider: "IndigoMagic",
        providerSlug: "indigomagic"
    },
    "wild_island": {
        name: "Wild Island",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "wild_jack": {
        name: "Wild Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_jack_81": {
        name: "Wild Jack 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wild_luchador": {
        name: "Wild Luchador",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_melon": {
        name: "Wild Melon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_million": {
        name: "Wild Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_mirage": {
        name: "Wild Mirage",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wild_moon_thieves": {
        name: "Wild Moon Thieves",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_north": {
        name: "Wild North",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_north_radiant_skies": {
        name: "Wild North Radiant Skies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_one": {
        name: "Wild One",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "wild_orient": {
        name: "Wild Orient",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "wild_pixies": {
        name: "Wild Pixies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_pops": {
        name: "Wild Pops",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "wild_rails": {
        name: "Wild Rails",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_robo_factory": {
        name: "Wild Robo Factory",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "wild_rubies": {
        name: "Wild Rubies",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "wild_rubies_christmas_edition": {
        name: "Wild Rubies Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "wild_silverback": {
        name: "Wild Silverback",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "wild_skullz": {
        name: "Wild Skullz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_skyfire": {
        name: "Wild Skyfire",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wild_spells": {
        name: "Wild Spells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_stack_frenzy": {
        name: "Wild Stack Frenzy",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "wild_survivor": {
        name: "Wild Survivor",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_tiger": {
        name: "Wild Tiger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_tiger_2": {
        name: "Wild Tiger 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_tome_of_the_woods": {
        name: "Wild Tome of the Woods",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wild_trigger": {
        name: "Wild Trigger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wild_trucks": {
        name: "Wild Trucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wild_walker": {
        name: "Wild Walker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_weather": {
        name: "Wild Weather",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wild_west_angel": {
        name: "Wild West Angel",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "wild_west_angel_rodeo": {
        name: "Wild West Angel Rodeo",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "wild_west_gold": {
        name: "Wild West Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_west_gold_blazing_bounty": {
        name: "Wild West Gold Blazing Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_west_gold_megaways": {
        name: "Wild West Gold Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_west_trueways": {
        name: "Wild West TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_wick": {
        name: "Wild Wick",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "wild_wild_bananas": {
        name: "Wild Wild Bananas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_joker": {
        name: "Wild Wild Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_pearls": {
        name: "Wild Wild Pearls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_riches": {
        name: "Wild Wild Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_riches_returns": {
        name: "Wild Wild Riches Returns",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_wild_vegas": {
        name: "Wild Wild Vegas",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "wild_wildebeest_wins": {
        name: "Wild Wildebeest Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wild_woof_returns": {
        name: "Wild Woof Returns",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "wild_yield": {
        name: "Wild Yield",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wildchemy": {
        name: "Wildchemy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "wildest_gambit": {
        name: "Wildest Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wildfire": {
        name: "Wildfire",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "wildfire_wins": {
        name: "Wildfire Wins",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "wildfire_wins_extreme": {
        name: "Wildfire Wins Extreme",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "wildhalla": {
        name: "Wildhalla",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "wildhound_derby": {
        name: "Wildhound Derby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wildies": {
        name: "Wildies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wildndice": {
        name: "WildNDice",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "wilhelm_tell": {
        name: "Wilhelm Tell",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "win_and_replay": {
        name: "Win And Replay",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "win_blaster": {
        name: "Win Blaster",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "win_blaster_christmas_edition": {
        name: "Win Blaster Christmas Edition",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "win_shooter": {
        name: "Win Shooter",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "win_win_fish_prawn_crab": {
        name: "Win Win Fish Prawn Crab",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "win_win_won": {
        name: "Win Win Won",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "winabeest": {
        name: "Win-A-Beest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wings_of_iguazu": {
        name: "Wings of Iguazu",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "wins_of_fortune": {
        name: "Wins of Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "wins_of_mermaid_multi_power": {
        name: "Wins of Mermaid Multi Power",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "wins_of_winter": {
        name: "Wins of Winter",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "winter_champions": {
        name: "Winter Champions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "winter_fishing_club": {
        name: "Winter Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "winter_trophy_hold_and_win": {
        name: "Winter Trophy Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "winterberries": {
        name: "Winterberries",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "winterberries_2": {
        name: "Winterberries 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "wisdom_of_athena": {
        name: "Wisdom of Athena",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wisdom_of_athena_1000": {
        name: "Wisdom of Athena 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wisdom_of_athena_1000_xmas": {
        name: "Wisdom of Athena 1000 Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wish_upon_a_cashpot": {
        name: "Wish Upon a Cashpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wish_upon_a_jackpot": {
        name: "Wish Upon a Jackpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wish_upon_a_jackpot_megaways": {
        name: "Wish Upon a Jackpot Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wishbringer": {
        name: "Wishbringer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "witch_heart_megaways": {
        name: "Witch Heart Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "witches_tome": {
        name: "Witches Tome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "witchy_poppins": {
        name: "Witchy POPpins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "wizard_of_gems": {
        name: "Wizard of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wizards_want_war": {
        name: "Wizards Want War",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "wolf_gold": {
        name: "Wolf Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wolf_gold_4_pack": {
        name: "Wolf Gold 4 Pack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wolf_gold_ultimate": {
        name: "Wolf Gold Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "wolf_hunters": {
        name: "Wolf Hunters",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "wolf_legend_megaways": {
        name: "Wolf Legend Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wolf_legend_spinboost": {
        name: "Wolf Legend Spinboost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "wolf_power_hold_and_win": {
        name: "Wolf Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "wolf_power_megaways": {
        name: "Wolf Power Megaways",
        provider: "Playson",
        providerSlug: "playson"
    },
    "wolf_sierra": {
        name: "Wolf Sierra",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "wolf_strike": {
        name: "Wolf Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "wolf_strike_hold_and_win_extra": {
        name: "Wolf Strike Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "wonder_machine": {
        name: "Wonder Machine",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "worms_of_valor": {
        name: "Worms of Valor",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "wrappin_gold": {
        name: "Wrappin Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "wrath_of_seth_split": {
        name: "Wrath of Seth Split",
        provider: "MicroGaming",
        providerSlug: "microgaming"
    },
    "wukong_rush": {
        name: "Wukong Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "x1000_golden_penny_2": {
        name: "x1000 Golden Penny 2",
        provider: "Playson",
        providerSlug: "playson"
    },
    "xibalba": {
        name: "Xibalba",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "xmas_3x3": {
        name: "Xmas 3x3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "xmas_drop": {
        name: "Xmas Drop",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "xmas_joker": {
        name: "Xmas Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "xmas_magic": {
        name: "Xmas Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "xmas_pop_delight": {
        name: "Xmas Pop Delight",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "xmas_rush": {
        name: "Xmas Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "xploding_pumpkins": {
        name: "Xploding Pumpkins",
        provider: "Gamomat Games",
        providerSlug: "gamomat-games"
    },
    "xterminate": {
        name: "Xterminate",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "xwild": {
        name: "X-Wild",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "yakuza_honor": {
        name: "Yakuza Honor",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "year_of_the_dragon_king": {
        name: "Year of the Dragon King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "yeti_battle_of_greenhat_peak": {
        name: "Yeti Battle of Greenhat peak",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "yeti_quest": {
        name: "Yeti Quest",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "yin_and_yang": {
        name: "Yin & Yang",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "yokozuna_clash": {
        name: "Yokozuna Clash",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "you_can_piggy_bank_on_it": {
        name: "You Can Piggy Bank On It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "your_own_island": {
        name: "Your Own Island",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yum_yum_powerways": {
        name: "Yum Yum Powerways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zap_attack": {
        name: "Zap Attack!",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "ze_zeus": {
        name: "Ze Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "zeus": {
        name: "Zeus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "zeus_2": {
        name: "Zeus 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "zeus_deluxe": {
        name: "Zeus Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "zeus_diving_multipliers": {
        name: "Zeus Diving Multipliers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "zeus_goes_wild": {
        name: "Zeus Goes Wild",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "zeus_vs_hades_gods_of_war": {
        name: "Zeus vs Hades - Gods of War",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zeus_vs_hades_gods_of_war_250": {
        name: "Zeus vs Hades Gods of War 250",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zeus_vs_typhoon": {
        name: "Zeus vs Typhoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zeus_ze_zecond": {
        name: "Zeus Ze Zecond",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "zombie_apopalypse": {
        name: "Zombie aPOPalypse",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "zombie_blasters": {
        name: "Zombie Blasters",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "zombie_carnival": {
        name: "Zombie Carnival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zombie_circus": {
        name: "Zombie Circus",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "zombie_knight": {
        name: "Zombie Knight",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "zombie_outbreak": {
        name: "Zombie Outbreak",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "zombie_road": {
        name: "Zombie Road",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "zombie_school_megaways": {
        name: "Zombie School Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zombie_train": {
        name: "Zombie Train",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "zombies": {
        name: "Zombies",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "zoom": {
        name: "Zoom",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
};
